/* Rippin Moto custom wheelset builder.
   Six steps, live price from real variant data, Savor cart drawer on add.
   Product facts (bikes, finishes, lead times) come from the redesign constants and
   from the fitment data. Nothing here is a theme-editor setting. */
(function () {
  'use strict';

  /* ---------- constants, verbatim from the redesign constants file ---------- */

  var BIKES = [
    {
      id: 'Sur-Ron LBX 2018-2025',
      handle: 'sur-ron-lbx',
      name: 'Sur-Ron Light Bee X 2018-2025',
      grp: 'Sur-Ron',
      years: '2018-2025. The 2026 uses a different front wheel',
      status: 'listed',
    },
    {
      id: 'Sur-Ron LBX 2026',
      handle: 'sur-ron-lbx-2026',
      name: 'Sur-Ron Light Bee X 2026',
      grp: 'Sur-Ron',
      years: '2026 model year (108 mm front fork spacing)',
      status: 'listed',
    },
    {
      id: 'Sur-Ron Light Bee 2',
      handle: 'sur-ron-light-bee-2',
      name: 'Sur-Ron Light Bee 2',
      grp: 'Sur-Ron',
      years: 'All years listed as one fitment',
      status: 'listed',
    },
    {
      id: 'Sur-Ron Ultra Bee',
      handle: 'sur-ron-ultra-bee',
      name: 'Sur-Ron Ultra Bee',
      grp: 'Sur-Ron',
      years: 'All years listed as one fitment',
      status: 'listed',
    },
    {
      id: 'SRPNT Z27 / X8',
      handle: 'srpnt-z27-x8',
      name: 'SRPNT Z27 / X8',
      grp: 'SRPNT',
      years: 'Z27 and X8 share the Sur-Ron Ultra Bee fitment',
      status: 'listed',
    },
    {
      id: 'Talaria MX3',
      handle: 'talaria-mx3',
      name: 'Talaria Sting MX3',
      grp: 'Talaria',
      years: '2018 to mid-2022',
      status: 'listed',
    },
    {
      id: 'Talaria MX4/XXX',
      handle: 'talaria-mx4-xxx',
      name: 'Talaria Sting MX4 / XXX',
      grp: 'Talaria',
      years: 'mid-2022 and later',
      status: 'listed',
    },
    {
      id: 'Talaria MX5',
      handle: 'talaria-mx5',
      name: 'Talaria Sting MX5',
      grp: 'Talaria',
      years: 'All years listed as one fitment',
      status: 'listed',
    },
    {
      id: 'Talaria Komodo',
      handle: 'talaria-komodo',
      name: 'Talaria Komodo',
      grp: 'Talaria',
      years: 'All years listed as one fitment',
      status: 'listed',
    },
    {
      id: 'E-Ride Pro SS 2.0',
      handle: 'e-ride-pro-ss-2-0',
      name: 'E-Ride Pro SS 2.0',
      grp: 'E-Ride Pro',
      years: 'SS 2.0 only. The 3.0 / SR and S are different fitments',
      status: 'listed',
    },
    {
      id: 'E-Ride PRO 3.0/SR',
      handle: 'e-ride-pro-3-0-sr',
      name: 'E-Ride Pro 3.0 / SR',
      grp: 'E-Ride Pro',
      years: '3.0 and SR share this fitment',
      status: 'listed',
    },
    {
      id: 'E-Ride PRO 4.0',
      handle: 'e-ride-pro-4-0',
      name: 'E-Ride Pro 4.0',
      grp: 'E-Ride Pro',
      years: 'Shares the PRO 3.0 / SR wheel fitment',
      status: 'listed',
    },
    {
      id: 'Altis Sigma 2025',
      handle: 'altis-sigma-2025',
      name: 'Altis Sigma',
      grp: 'Altis',
      years: '2025',
      status: 'listed',
    },
    {
      id: 'Altis Sigma 2025 LE',
      handle: 'altis-sigma-2025-le',
      name: 'Altis Sigma',
      grp: 'Altis',
      years: '2025 LE',
      status: 'listed',
    },
    {
      id: 'Altis Sigma 2026',
      handle: 'altis-sigma-2026',
      name: 'Altis Sigma',
      grp: 'Altis',
      years: '2026',
      status: 'listed',
    },
    /* The Varg MX and EX are two bikes here (Peter, 2026-10-17), both read off the one
       stark-varg fitment. fit is the store's bike, the one the header and the fitment
       rows know; variant is the store's option value, so a size the store lists per
       model shows only that model's rows and prices, and a size listed for "Stark Varg"
       shows for both. */
    {
      id: 'Stark Varg MX',
      handle: 'stark-varg-mx',
      fit: 'stark-varg',
      variant: 'Stark Varg MX',
      name: 'Stark Varg MX',
      grp: 'Stark',
      years: 'Motocross model',
      stockRear: 19,
      status: 'listed',
    },
    {
      id: 'Stark Varg EX',
      handle: 'stark-varg-ex',
      fit: 'stark-varg',
      variant: 'Stark Varg EX',
      name: 'Stark Varg EX',
      grp: 'Stark',
      years: 'Enduro model',
      stockRear: 18,
      status: 'listed',
    },
    {
      id: 'Arctic Leopard XE PRO S',
      handle: 'arctic-leopard-xe-pro-s',
      name: 'Arctic Leopard XE PRO S',
      grp: 'Other',
      years: 'Wheels listed. We confirm fitment before the build starts',
      status: 'check',
    },
    {
      id: 'Arctic Leopard XE PRO R',
      handle: 'arctic-leopard-xe-pro-r',
      name: 'Arctic Leopard XE PRO R',
      grp: 'Other',
      years: 'Brake pads and spring kit listed; wheels on request',
      status: 'check',
    },
    {
      id: 'Vetra Blazer',
      handle: 'vetra-blazer',
      name: 'Vetra Blazer',
      grp: 'Other',
      years: 'Wheels listed. We confirm fitment before the build starts',
      status: 'check',
    },
  ];

  /* The hub colors. Hubs and spoke nipples always match. The first eight are real
     product variants on every wheelset listing. The ten after them are builder only
     (Peter, 2026-09-29): the listings do not carry them, so a build in one of them
     prices and carts as the Black variant and the real color rides on the cart line as
     a property. hex is the solid color used wherever a plain color is required, such as
     the diagram. swatch, where there is one, is what the rider sees on a swatch or chip.
     hubUp is a charge per hub, so a front and rear set pays it twice. */
  var COLORS = [
    { id: 'Black', hex: '#1c1c1e' },
    { id: 'Silver', hex: '#c9ccd1' },
    /* textUp marks a color whose charge is already in its variant prices (Magnesium,
       $15 a hub, Peter 2026-10-15), so it is never added to a price. The help text
       reads the real amount off the size row in hand. */
    { id: 'Magnesium', hex: '#9a948a', textUp: 15 },
    { id: 'Red', hex: '#c8102e' },
    { id: 'Blue', hex: '#1b5fd6' },
    { id: 'Gold', hex: '#c9a227' },
    { id: 'Purple', hex: '#6d3fb5' },
    { id: 'Green', hex: '#2e8b57' },
    { id: 'Orange', hex: '#f06a1c', builderOnly: true },
    { id: 'Yellow', hex: '#e3cf12', builderOnly: true },
    { id: 'Pink', hex: '#e6007e', builderOnly: true },
    { id: 'Light Blue', hex: '#4fb3e8', builderOnly: true },
    { id: 'Turquoise', hex: '#1db9a3', builderOnly: true },
    { id: 'Bronze', hex: '#8a5a2e', builderOnly: true },
    { id: 'Desert Gold', hex: '#8a5f42', builderOnly: true },
    { id: 'Titanium', hex: '#6f6b66', builderOnly: true },
    {
      id: 'Burnt Blue',
      hex: '#2f3f9e',
      swatch: 'linear-gradient(135deg,#1b4fd0 0%,#2f3f9e 40%,#5a3aa8 70%,#8a4fd6 100%)',
      builderOnly: true,
      hubUp: 20,
    },
    {
      id: 'Rainbow',
      hex: '#ff2d95',
      swatch: 'linear-gradient(135deg,#e6007e 0%,#d9a520 28%,#1faa6a 52%,#1b6fd6 76%,#7a4dff 100%)',
      builderOnly: true,
      hubUp: 20,
    },
  ];

  /* Rim finishes and their per-set surcharge. This list is the fallback. The live
     list comes from the wheel_finish metaobjects through the section config, and
     matches these rows one for one. */
  var RIMS_FALLBACK = [
    { id: 'Black', css: '#1c1c1e', up: 0, tier: 'included', note: 'Blackline standard' },
    { id: 'Red', css: '#c8102e', up: 80, tier: 'standard' },
    { id: 'Blue', css: '#1b5fd6', up: 80, tier: 'standard' },
    { id: 'Gold', css: '#c9a227', up: 80, tier: 'standard' },
    { id: 'Green', css: '#2e8b57', up: 80, tier: 'standard' },
    { id: 'Magnesium', css: '#9a948a', up: 80, tier: 'standard' },
    { id: 'Orange', css: '#f06a1c', up: 80, tier: 'standard' },
    { id: 'White', css: '#f2f2f0', up: 80, tier: 'standard' },
    { id: 'Purple', css: '#843177', up: 110, tier: 'special' },
    { id: 'Silver', css: '#c9ccd1', up: 110, tier: 'special' },
    {
      id: 'Chrome',
      css: 'linear-gradient(135deg,#ffffff 0%,#b9bec4 30%,#f4f5f6 48%,#7d838a 62%,#e6e8ea 100%)',
      up: 110,
      tier: 'special',
      note: 'Plated finish',
    },
    {
      id: 'Rainbow',
      css: 'conic-gradient(from 200deg,#ff2d95,#ffb400,#2bff88,#00c8ff,#7a4dff,#ff2d95)',
      up: 110,
      tier: 'special',
      note: 'Iridescent finish',
    },
  ];

  /* Spoke surcharges are per wheel, not per set. */
  var SPOKES_FALLBACK = [
    { id: 'Black', css: '#242527', up: 0, note: 'Standard' },
    { id: 'Stainless', css: '#c8cacc', up: 0, note: 'No charge' },
  ];

  /* Chrome and rainbow are not flat colors. The metaobject carries one hex for them,
     which is enough for a dot but not for a swatch, so the gradient stays here and the
     panel says in plain words that it is a stand-in. */
  var FINISH_GRADIENT = {
    'rim-chrome': 'linear-gradient(135deg,#ffffff 0%,#b9bec4 30%,#f4f5f6 48%,#7d838a 62%,#e6e8ea 100%)',
    'rim-rainbow': 'conic-gradient(from 200deg,#ff2d95,#ffb400,#2bff88,#00c8ff,#7a4dff,#ff2d95)',
    'rim-two-tone': 'linear-gradient(135deg, #c8102e 0 50%, #1b5fd6 50% 100%)',
    'rim-splatter':
      'radial-gradient(#c8102e 22%, transparent 24%) 0 0/9px 9px, radial-gradient(#c8102e 18%, transparent 20%) 4.5px 4.5px/9px 9px, #1c1c1e',
  };
  var FINISH_NOTE = {
    'rim-chrome': 'Plated finish',
    'rim-rainbow': 'Iridescent finish',
    'rim-two-tone': 'Two colors, one fade',
    'rim-splatter': 'Splatter thrown over a base color',
  };

  /* Two-tone is one rim finish carrying two colors. The studio photos name the pair in
     one fixed order, so a rider who picks red and black and a rider who picks black and
     red are looking at the same file and the same wheel. The order below is that order,
     and it also decides which color ends up on the upper half. */
  var TWO_TONE_RIM = 'Two-tone';
  var TWO_TONE_ORDER = [
    'black',
    'matte-black',
    'red',
    'orange',
    'yellow',
    'gold',
    'green',
    'light-blue',
    'blue',
    'magnesium',
    'white',
  ];
  /* Pairs we do not offer: the two colors sit so close that the fade reads as one color
     on the wheel and in the swatch grid (Peter, 2026-09-15). Either order is refused. */
  var TWO_TONE_EXCLUDED = [
    ['black', 'matte-black'],
    ['yellow', 'gold'],
    ['orange', 'gold'],
    ['gold', 'magnesium'],
    ['yellow', 'magnesium'],
    ['light-blue', 'blue'],
  ];

  /* Splatter is one rim finish carrying two colors as well, but the two are not a pair:
     one is the base the rim is coated in and the other is thrown over it, so the order
     is fixed by the wheel rather than by a naming rule. Only three bases are sprayed,
     and the splatter itself comes from the standard gloss colors. */
  var SPLATTER_RIM = 'Splatter';
  var SPLATTER_BASE_ORDER = ['black', 'matte-black', 'white'];
  var SPLATTER_COLOR_ORDER = [
    'black',
    'red',
    'orange',
    'yellow',
    'gold',
    'green',
    'light-blue',
    'blue',
    'magnesium',
    'white',
  ];

  /* Splatter has to read against its base, so a base rules out the color it would
     disappear into. Matte black and black are the same color to the eye at speed, so a
     black splatter is off the list for both of them. */
  var SPLATTER_BASE_FAMILY = { 'matte-black': 'black' };

  var RIMS = RIMS_FALLBACK;
  var SPOKES = SPOKES_FALLBACK;

  var LEAD = {
    wheels: '2-3 weeks to build, then an estimated 7-10 business days in transit after shipment',
    rtr: '3-4 weeks to build and mount the tires, then an estimated 5-7 business days in transit after shipment',
    mag: 'Magnesium adds about 5 business days',
  };

  var SETUPS = [
    {
      id: 'offroad',
      title: 'Off-road',
      blurb: 'Front and rear set on knobby sizes. 17, 19 or 21 inch front with a 14, 16, 18 or 19 inch rear.',
      pair: true,
    },
    {
      id: 'supermoto',
      title: 'Supermoto',
      blurb: 'Front and rear set on wide supermoto rims, 16 inch and 17 inch.',
      pair: true,
    },
    { id: 'front_single', title: 'Front only', blurb: 'Choose from 17", 19" and 21" sizes.', pair: false, end: 'front' },
    { id: 'rear_single', title: 'Rear only', blurb: 'Choose from 14", 16", 17", 18" and 19" sizes.', pair: false, end: 'rear' },
  ];

  /* Size comes before tires (Peter, 2026-10-16): a rider picks the size first, then sees
     only the tire packages that size is offered in. */
  var STEP_NAMES = ['Bike', 'Riding style', 'Wheel size', 'Wheelset package', 'Colors', 'Review'];
  /* What the phone bar says on each step before a price exists. */
  /* What Continue leads to, by current step (Peter, 2026-10-15: "Next step: Choose ..."). The
     long form is for the desktop buttons; the phone bar has room for the short one under a
     small "Next step". "Wheel size", not "wheelset size", since single wheels are built too. */
  var NEXT_LABEL = ['Pick riding style', 'Choose wheel size', 'Select tires', 'Choose colors', 'Review your build'];
  var NEXT_SHORT = ['Pick riding style', 'Choose wheel size', 'Select tires', 'Choose Colors', 'Review build'];
  /* The forward buttons read as the step they lead to with a chevron after it, and no
     "Next Step" in front (Peter, 2026-10-17). Screen readers still hear "Next step". */
  var NEXT_CHEVRON =
    '<svg class="rm-bld__chev" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="m9 5 7 7-7 7"/></svg>';
  function nextHtml(label) {
    return '<span class="rm-visually-hidden">Next step: </span><span class="rm-bld__nexttxt">' + esc(label) + '</span>' + NEXT_CHEVRON;
  }
  var STEP_PROMPTS = ['Pick your bike', 'Pick a riding style', 'Pick a size', 'Wheels only or Ready-to-Ride', 'Pick your colors', 'Review'];

  /* ---------- helpers ---------- */

  var root = document.querySelector('[data-rm-builder]');
  if (!root) return;

  function readJson(selector) {
    var el = document.querySelector(selector);
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  var CONFIG = readJson('[data-rm-builder-config]') || {};

  /* ---------- finishes from the store ---------- */

  /* The wheel_finish metaobjects are the source of the rim and spoke lists, their
     swatches and their surcharges. The set sits under the Liquid row cap, so what the
     section renders is complete. If it comes back empty the built-in list stands in. */
  function buildFinishes() {
    var raw = CONFIG.finishes;
    if (!raw || !raw.length) return;
    var rims = [];
    var spokes = [];
    raw
      .slice()
      .sort(function (a, b) {
        return (Number(a.sort) || 0) - (Number(b.sort) || 0);
      })
      .forEach(function (f) {
        if (f.active === false) return;
        var name = f.name || '';
        if (!name) return;
        var up = Math.round(Number(f.surcharge) || 0);
        var item = {
          id: name,
          handle: f.handle || '',
          css: FINISH_GRADIENT[f.handle] || f.hex || '#8a8d92',
          dot: f.hex || '#8a8d92',
          image: f.image || '',
          up: up,
          lead: Number(f.lead_time_days) || 0,
          tier: FINISH_GRADIENT[f.handle] ? 'special' : up ? 'standard' : 'included',
          note: FINISH_NOTE[f.handle] || (up ? '' : 'Blackline standard'),
        };
        if (f.part === 'spoke') {
          if (name === 'White') return; /* Supplier does not offer white spokes, 2026-09-15 */
          /* Spoke surcharges are per wheel. A no charge spoke says so, a paid one
             names the charge, and either way the lead time on the row is kept. */
          item.note = up
            ? item.note || 'Powder coat, +' + money(up) + ' per wheel'
            : name === 'Black'
              ? 'Standard'
              : 'No charge';
          spokes.push(item);
        } else if (f.part === 'rim') {
          rims.push(item);
        }
      });
    if (rims.length) RIMS = rims;
    if (spokes.length) SPOKES = spokes;
  }
  buildFinishes();

  /* Price tiers, read off the data rather than written down here. */
  function rimTiers() {
    var tiers = [];
    RIMS.forEach(function (r) {
      var key = r.up || 0;
      for (var i = 0; i < tiers.length; i++)
        if (tiers[i].up === key) {
          tiers[i].items.push(r);
          return;
        }
      tiers.push({ up: key, items: [r] });
    });
    tiers.sort(function (a, b) {
      return a.up - b.up;
    });
    return tiers;
  }

  /* The colors a two-tone pair can be made from: every plain rim color, in the order the
     photo names them. Read off RIMS so a finish row added or retired in the store moves
     this list with it. */
  function twoToneRims() {
    var out = [];
    for (var i = 0; i < TWO_TONE_ORDER.length; i++) {
      for (var j = 0; j < RIMS.length; j++) {
        var r = RIMS[j];
        if (r.tier === 'special') continue;
        if (r.up !== 0 && r.up !== 80) continue;
        if (finishSlug(r.id) !== TWO_TONE_ORDER[i]) continue;
        out.push(r);
        break;
      }
    }
    return out;
  }

  function twoToneEligible(name) {
    var list = twoToneRims();
    for (var i = 0; i < list.length; i++) if (list[i].id === name) return true;
    return false;
  }

  function isTwoTone() {
    return S.rim === TWO_TONE_RIM;
  }

  /* A pair is buildable when both colors are two-tone colors, they differ, and they are
     not one of the near-matching pairs we keep off the list. */
  function twoTonePairAllowed(a, b) {
    if (!a || !b || a === b) return false;
    if (!twoToneEligible(a) || !twoToneEligible(b)) return false;
    var sa = finishSlug(a);
    var sb = finishSlug(b);
    for (var i = 0; i < TWO_TONE_EXCLUDED.length; i++) {
      var x = TWO_TONE_EXCLUDED[i];
      if ((x[0] === sa && x[1] === sb) || (x[0] === sb && x[1] === sa)) return false;
    }
    return true;
  }

  /* The colors the second picker may offer once the first is chosen. */
  function twoTonePartners(a) {
    return twoToneRims().filter(function (r) {
      return twoTonePairAllowed(a, r.id);
    });
  }

  /* The pair written the way the photo files write it, lowest position in the canonical
     order first. A color we do not recognize sorts last rather than throwing. */
  function twoToneSlug(a, b) {
    var sa = finishSlug(a);
    var sb = finishSlug(b);
    var ia = TWO_TONE_ORDER.indexOf(sa);
    var ib = TWO_TONE_ORDER.indexOf(sb);
    if (ia < 0) ia = TWO_TONE_ORDER.length;
    if (ib < 0) ib = TWO_TONE_ORDER.length;
    if (ib < ia) return sb + '-' + sa;
    return sa + '-' + sb;
  }

  function isSplatter() {
    return S.rim === SPLATTER_RIM;
  }

  /* The rim rows a splatter list can be built from, in the order written above. Read off
     RIMS so a finish row added or retired in the store moves these lists with it, and
     kept clear of the finishes that are themselves made of other colors. */
  function splatterRimsIn(order) {
    var out = [];
    for (var i = 0; i < order.length; i++) {
      for (var j = 0; j < RIMS.length; j++) {
        var r = RIMS[j];
        if (r.tier === 'special') continue;
        if (r.up !== 0 && r.up !== 80) continue;
        if (finishSlug(r.id) !== order[i]) continue;
        out.push(r);
        break;
      }
    }
    return out;
  }

  function splatterBases() {
    return splatterRimsIn(SPLATTER_BASE_ORDER);
  }

  /* The splatter colors a base can carry: the standard gloss colors, less the one the
     base would swallow. */
  function splatterColors(base) {
    var baseSlug = finishSlug(base);
    var drop = SPLATTER_BASE_FAMILY[baseSlug] || baseSlug;
    return splatterRimsIn(SPLATTER_COLOR_ORDER).filter(function (r) {
      return finishSlug(r.id) !== drop;
    });
  }

  function inRimList(list, name) {
    for (var i = 0; i < list.length; i++) if (list[i].id === name) return true;
    return false;
  }

  function splatterBaseEligible(name) {
    return inRimList(splatterBases(), name);
  }

  function splatterColorEligible(base, name) {
    return !!base && inRimList(splatterColors(base), name);
  }

  function splatterChosen() {
    return !!S.splatterBase && splatterColorEligible(S.splatterBase, S.splatterColor);
  }

  /* The base first and the splatter over it, the same order the photo file names them. */
  function splatterSlug() {
    return 'splatter-' + finishSlug(S.splatterBase) + '-' + finishSlug(S.splatterColor);
  }

  /* Every place a rim is written out for a person to read. Two-tone names both colors,
     splatter names its base and what was thrown over it, everything else is just the
     finish name. */
  function rimLabel() {
    /* A pair still waiting on its second color says so, rather than ending on a slash. */
    if (isTwoTone() && !twoTonePairAllowed(S.toneA, S.toneB))
      return S.toneA ? TWO_TONE_RIM + ': ' + S.toneA + ', second color not picked' : TWO_TONE_RIM;
    if (isTwoTone()) return TWO_TONE_RIM + ': ' + S.toneA + ' / ' + S.toneB;
    if (isSplatter() && splatterChosen())
      return SPLATTER_RIM + ': ' + S.splatterBase + ' with ' + S.splatterColor + ' splatter';
    return S.rim;
  }

  function money(n) {
    if (n == null || isNaN(n)) return '--';
    return '$' + Number(n).toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  function bikeOf(handle) {
    for (var i = 0; i < BIKES.length; i++) if (BIKES[i].handle === handle) return BIKES[i];
    return null;
  }
  function bikeLabel(b) {
    if (!b) return '';
    return b.grp === 'Altis' ? b.name + ' ' + b.years : b.name;
  }
  function rimOf(id) {
    for (var i = 0; i < RIMS.length; i++) if (RIMS[i].id === id) return RIMS[i];
    return RIMS[0];
  }
  function spokeOf(id) {
    for (var i = 0; i < SPOKES.length; i++) if (SPOKES[i].id === id) return SPOKES[i];
    return SPOKES[0];
  }
  function colorOf(id) {
    for (var i = 0; i < COLORS.length; i++) if (COLORS[i].id === id) return COLORS[i];
    return null;
  }
  function colorHex(id) {
    var c = colorOf(id);
    return c ? c.hex : '#8a8d92';
  }
  /* What a swatch or chip paints. The diagram keeps to colorHex. */
  function colorSwatch(id) {
    var c = colorOf(id);
    return c ? c.swatch || c.hex : '#8a8d92';
  }
  /* The listing color a hub color prices and carts as. A builder only color has no
     variant of its own, so it borrows Black's. This is never written out for a person
     to read. */
  function listingColor(id) {
    var c = colorOf(id);
    return c && c.builderOnly ? 'Black' : id;
  }
  function setupOf(id) {
    for (var i = 0; i < SETUPS.length; i++) if (SETUPS[i].id === id) return SETUPS[i];
    return SETUPS[0];
  }
  /* A set has a front and a rear hub, a single wheel has one. */
  function hubCount() {
    return setupOf(S.setup).pair ? 2 : 1;
  }
  /* The hub color charge for the build in hand, per hub times hubs. */
  function hubCharge(id) {
    var c = colorOf(id);
    return c && c.hubUp ? c.hubUp * hubCount() : 0;
  }
  /* The suffix the hub charge reads as everywhere it is written out. A free hub color
     reads as just its name. */
  function hubSuffix() {
    var c = colorOf(S.color);
    if (!c || !c.hubUp) return '';
    return ' (+' + money(c.hubUp) + ' per hub × ' + hubCount() + ')';
  }
  /* The finishes drawn from a gradient rather than a flat color. The fallback list files
     every $110 rim under 'special', flat ones included, so the tier alone is not enough. */
  function rimGradient(r) {
    return r.tier === 'special' && /gradient/.test(String(r.css || ''));
  }

  /* A near white spoke sits on the white diagram background and disappears without a
     faint outline behind it. Anything darker draws cleanly on its own. */
  function lightFinish(css) {
    var m = /^#([0-9a-f]{6})$/i.exec(String(css == null ? '' : css).trim());
    if (!m) return false;
    var n = parseInt(m[1], 16);
    var r = (n >> 16) & 255;
    var g = (n >> 8) & 255;
    var b = n & 255;
    return (r * 0.299 + g * 0.587 + b * 0.114) / 255 > 0.8;
  }

  /* The finish diagram. Recolors with every choice and is never a photo. */
  function svgWheel(rim, spoke, hub, uid) {
    var r = rimOf(rim);
    var s = spokeOf(spoke);
    var halo = lightFinish(s.css);
    var rimFill = rimGradient(r) ? 'url(#' + uid + '-' + r.id.toLowerCase() + ')' : r.css;
    var spokes = '';
    for (var i = 0; i < 36; i++) {
      var a = (i * 10 * Math.PI) / 180;
      var a2 = ((i * 10 + 22) * Math.PI) / 180;
      var x1 = 150 + 24 * Math.cos(a);
      var y1 = 150 + 24 * Math.sin(a);
      var x2 = 150 + 118 * Math.cos(a2);
      var y2 = 150 + 118 * Math.sin(a2);
      if (halo) {
        spokes +=
          '<line x1="' +
          x1.toFixed(1) +
          '" y1="' +
          y1.toFixed(1) +
          '" x2="' +
          x2.toFixed(1) +
          '" y2="' +
          y2.toFixed(1) +
          '" stroke="rgba(0,0,0,.25)" stroke-width="3.4" stroke-linecap="round"/>';
      }
      spokes +=
        '<line x1="' +
        x1.toFixed(1) +
        '" y1="' +
        y1.toFixed(1) +
        '" x2="' +
        x2.toFixed(1) +
        '" y2="' +
        y2.toFixed(1) +
        '" stroke="' +
        s.css +
        '" stroke-width="2.2" stroke-linecap="round"/><circle cx="' +
        x2.toFixed(1) +
        '" cy="' +
        y2.toFixed(1) +
        '" r="3.6" fill="' +
        colorHex(hub) +
        '" stroke="rgba(0,0,0,.35)" stroke-width=".6"/>';
    }
    return (
      '<svg viewBox="0 0 300 300" role="img" aria-label="Finish diagram, not a photo: ' +
      esc(rim) +
      ' rim, ' +
      esc(spoke) +
      ' spokes, ' +
      esc(hub) +
      ' hub" style="width:100%;height:auto;display:block;background:#fff">' +
      '<defs><linearGradient id="' +
      uid +
      '-chrome" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#ffffff"/><stop offset=".3" stop-color="#b9bec4"/><stop offset=".48" stop-color="#f4f5f6"/><stop offset=".62" stop-color="#7d838a"/><stop offset="1" stop-color="#e6e8ea"/></linearGradient>' +
      '<linearGradient id="' +
      uid +
      '-rainbow" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#ff2d95"/><stop offset=".25" stop-color="#ffb400"/><stop offset=".5" stop-color="#2bff88"/><stop offset=".75" stop-color="#00c8ff"/><stop offset="1" stop-color="#7a4dff"/></linearGradient>' +
      '<linearGradient id="' +
      uid +
      '-two-tone" x1="0" y1="0" x2="1" y2="1"><stop offset=".5" stop-color="' +
      twoToneHex(0) +
      '"/><stop offset=".5" stop-color="' +
      twoToneHex(1) +
      '"/></linearGradient>' +
      '<pattern id="' +
      uid +
      '-splatter" width="14" height="14" patternUnits="userSpaceOnUse"><rect width="14" height="14" fill="' +
      splatterHex('base') +
      '"/><circle cx="4" cy="4" r="2.4" fill="' +
      splatterHex('color') +
      '"/><circle cx="11" cy="9" r="1.5" fill="' +
      splatterHex('color') +
      '"/><circle cx="6.5" cy="11.5" r="1" fill="' +
      splatterHex('color') +
      '"/></pattern></defs>' +
      '<circle cx="150" cy="150" r="136" fill="none" stroke="rgba(0,0,0,.12)" stroke-width="1"/>' +
      '<circle cx="150" cy="150" r="126" fill="none" stroke="' +
      rimFill +
      '" stroke-width="18"/>' +
      '<circle cx="150" cy="150" r="126" fill="none" stroke="rgba(0,0,0,.28)" stroke-width="1"/><circle cx="150" cy="150" r="117" fill="none" stroke="rgba(0,0,0,.28)" stroke-width="1"/><circle cx="150" cy="150" r="135" fill="none" stroke="rgba(0,0,0,.28)" stroke-width="1"/>' +
      spokes +
      '<circle cx="150" cy="150" r="30" fill="' +
      colorHex(hub) +
      '" stroke="rgba(0,0,0,.4)" stroke-width="1"/><circle cx="150" cy="150" r="17" fill="none" stroke="rgba(255,255,255,.35)" stroke-width="1.5"/><circle cx="150" cy="150" r="7" fill="#2a2d32"/>' +
      '<text x="150" y="290" text-anchor="middle" font-family="IBM Plex Mono,monospace" font-size="9.5" letter-spacing="1" fill="#767c86">FINISH DIAGRAM, NOT A PHOTO</text></svg>'
    );
  }

  /* The pair in canonical order, upper half first, the same order the photo file uses. */
  function twoToneNames() {
    var ia = TWO_TONE_ORDER.indexOf(finishSlug(S.toneA));
    var ib = TWO_TONE_ORDER.indexOf(finishSlug(S.toneB));
    if (ia < 0) ia = TWO_TONE_ORDER.length;
    if (ib < 0) ib = TWO_TONE_ORDER.length;
    return ib < ia ? [S.toneB, S.toneA] : [S.toneA, S.toneB];
  }

  /* The diagram only stands in for a photo that will not load, but it still has to show
     the pair, so each half is drawn in its own color. */
  function twoToneHex(half) {
    var name = twoToneNames()[half ? 1 : 0];
    for (var i = 0; i < RIMS.length; i++) if (RIMS[i].id === name) return RIMS[i].dot || RIMS[i].css;
    return '#8a8d92';
  }

  /* Same job for splatter: the diagram draws the base and speckles it in the splatter
     color. A picker that has not been answered yet falls back to a neutral gray, the way
     an unknown finish does. */
  function splatterHex(part) {
    var name = part === 'base' ? S.splatterBase : S.splatterColor;
    for (var i = 0; i < RIMS.length; i++) if (RIMS[i].id === name) return RIMS[i].dot || RIMS[i].css;
    return part === 'base' ? '#1c1c1e' : '#8a8d92';
  }

  /* ---------- finish photos ---------- */

  /* Option ids are written the way a person would say them, so a two word name like
     Light Blue has to become light-blue before it can name a file. */
  function finishSlug(name) {
    return String(name == null ? '' : name)
      .toLowerCase()
      .replace(/^\s+|\s+$/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  /* There is one studio photo per rim, spoke and hub combination, named after the three
     option ids, so the URL is built rather than looked up. The base folder and the file
     pattern both come from the section so the naming lives in one place. */
  /* A plain finish names itself. Two-tone names its pair instead, so one rim id can
     reach eleven times eleven photos, and splatter names its base and its splatter the
     same way. A splatter with a picker still unanswered has no photo to name, so it
     names itself and the diagram stands in until both are chosen. */
  function rimPhotoSlug(rim, slugs) {
    if (rim === TWO_TONE_RIM) return twoTonePairAllowed(S.toneA, S.toneB) ? twoToneSlug(S.toneA, S.toneB) : finishSlug(rim);
    if (rim === SPLATTER_RIM) return splatterChosen() ? splatterSlug() : finishSlug(rim);
    return photoSlug(rim, slugs);
  }

  /* A color whose photos were remade under a new name (desert gold, matched to the
     supplier's finish, Peter 2026-10-26) maps its slug to that name. The map lives in
     the section config, so the old files stay in place for any theme still asking. */
  var PHOTO_SLUG = CONFIG.finish_photo_slugs || {};
  function photoSlug(name, slugs) {
    var map = slugs || PHOTO_SLUG;
    var slug = finishSlug(name);
    return Object.prototype.hasOwnProperty.call(map, slug) ? map[slug] : slug;
  }

  /* Some bikes have a photo set of their own for a setup: the off-road set made from the
     Blackline wheels for the Stark Varg, for the bikes that share its hub style (Peter,
     2026-10-27). A set names its bikes, its setups and its file pattern in the section
     config, so a gas bike joins with one line. Solid rims only: two-tone and splatter, and
     any photo of a set that fails to load, use the main set. */
  var PHOTO_SETS = CONFIG.finish_photo_sets || [];
  function photoSetFor(rim) {
    if (rim === TWO_TONE_RIM || rim === SPLATTER_RIM) return null;
    for (var i = 0; i < PHOTO_SETS.length; i++) {
      var set = PHOTO_SETS[i];
      if ((set.bikes || []).indexOf(S.bike) >= 0 && (set.setups || []).indexOf(S.setup) >= 0) return set;
    }
    return null;
  }

  function finishPhotoUrl(rim, spoke, color, width) {
    var set = photoSetFor(rim);
    if (set && FINISH_PHOTO_MISS[photoUrlFrom(set.pattern, set.slugs || {}, rim, spoke, color, 0)] !== true) {
      return photoUrlFrom(set.pattern, set.slugs || {}, rim, spoke, color, width);
    }
    return photoUrlFrom(CONFIG.finish_photo_pattern, PHOTO_SLUG, rim, spoke, color, width);
  }

  function photoUrlFrom(pattern, slugs, rim, spoke, color, width) {
    var base = String(CONFIG.finish_photo_base == null ? '' : CONFIG.finish_photo_base).trim();
    if (!base) return '';
    base = base.replace(/\/+$/, '') + '/';
    pattern = String(pattern || 'rim-{rim}_spoke-{spoke}_accent-{accent}.jpg');
    var file = pattern
      .split('{rim}')
      .join(rimPhotoSlug(rim, slugs))
      .split('{spoke}')
      .join(finishSlug(spoke))
      .split('{accent}')
      .join(photoSlug(color, slugs));
    var version = String(CONFIG.finish_photo_version == null ? '' : CONFIG.finish_photo_version).trim();
    var query = [];
    if (version) query.push('v=' + encodeURIComponent(version));
    if (width) query.push('width=' + width);
    return base + file + (query.length ? '?' + query.join('&') : '');
  }

  /* A combination whose photo is missing is remembered by its URL, width query stripped,
     so the diagram stands in for that one combination only and the CDN is not asked for
     the same missing file again. Every other combination still gets its photo. */
  var FINISH_PHOTO_MISS = {};

  function finishPhotoKey(rim, spoke, color) {
    return finishPhotoUrl(rim, spoke, color, 0);
  }

  /* Two-tone and splatter are photographed in the eight listed hub colors only. Those
     photos will not be made for a builder only hub color (Peter, 2026-09-29), so that
     combination goes straight to the diagram and the CDN is never asked for a file that
     will not exist. A solid rim in any hub color still asks, and the per-photo fallback
     covers the ones not uploaded yet. */
  function finishPhotoPlanned(rim, color) {
    if (rim !== TWO_TONE_RIM && rim !== SPLATTER_RIM) return true;
    var c = colorOf(color);
    return !(c && c.builderOnly);
  }

  function finishPhotoMissed(rim, spoke, color) {
    if (!finishPhotoPlanned(rim, color)) return true;
    var key = finishPhotoKey(rim, spoke, color);
    return !key || FINISH_PHOTO_MISS[key] === true;
  }

  function finishPhotoAlt() {
    var rimPart = String(S.rim).toLowerCase();
    if (isTwoTone()) {
      rimPart = String(S.toneA).toLowerCase() + ' and ' + String(S.toneB).toLowerCase() + ' two-tone';
    } else if (isSplatter() && splatterChosen()) {
      rimPart = String(S.splatterColor).toLowerCase() + ' splatter on ' + String(S.splatterBase).toLowerCase();
    }
    return (
      'Custom wheelset with ' +
      rimPart +
      ' rims, ' +
      String(S.spoke).toLowerCase() +
      ' spokes and ' +
      String(S.color).toLowerCase() +
      ' hubs'
    );
  }

  function previewCaption(isPhoto) {
    var cap = isPhoto
      ? '<b>Color preview only.</b> Your selected wheel dimensions are listed in the build summary. Finish appearance may vary from the screen preview.'
      : '<b>Color preview only, not a photo.</b> It recolors with every choice and is not drawn to scale. Your selected wheel dimensions are listed in the build summary. Finish appearance may vary from the screen preview.';
    if (isPhoto && isTwoTone()) cap += ' Two-tone color order is shown in the preview and cannot be reversed.';
    if (isPhoto && isSplatter())
      cap += ' Splatter is thrown by hand, so no two sets land the same. The photo shows the pattern we aim for.';
    return cap;
  }

  /* The photos are bound after each render because every render replaces the markup.
     An 'error' event on an img does not bubble, so each one carries its own listener. */
  function bindFinishPhotos(scope) {
    if (!scope || !scope.querySelectorAll) return;
    var imgs = scope.querySelectorAll('[data-rm-finish-photo]');
    for (var i = 0; i < imgs.length; i++) {
      imgs[i].addEventListener('error', finishPhotoFailed);
    }
  }

  function finishPhotoFailed(e) {
    var img = e.currentTarget || e.target;
    var src = img && img.getAttribute ? String(img.getAttribute('src') || '') : '';
    /* Keyed the way finishPhotoKey builds it: only the width query comes off, so the
       version query stays and finishPhotoMissed finds this miss on the next render. */
    var key = src.replace(/([?&])width=\d+(&|$)/, function (m, lead, tail) {
      return tail ? lead : '';
    });
    if (key) FINISH_PHOTO_MISS[key] = true;
    var cell = img && img.parentNode;
    if (cell && cell.classList) {
      var live = cell.classList.contains('rm-bld__livefinish');
      cell.innerHTML = svgWheel(S.rim, S.spoke, S.color, live ? 'rmlv' : 'rmpv') + (live ? '' : '<span>Diagram</span>');
    }
    var cap = root.querySelector('.rm-prev__cap');
    if (cap) cap.innerHTML = previewCaption(false);
  }

  /* ---------- state ---------- */

  var S = {
    step: 1,
    maxStep: 1,
    bike: null, // bike handle
    setup: 'offroad',
    tires: 'none', // none | rtr, the package the build is on
    tiresWant: 'none', // none | rtr, the package the rider asked for, by a link or a tap
    tiresMoved: false, // the package changed since step 4 was last passed, so step 4 is seen again
    sizeKey: null, // row label
    variantBike: null, // option-value sub-choice, e.g. Stark Varg MX
    tireSku: '', // Ready-to-Ride tire choice SKU, '' for the standard tires
    color: 'Black',
    rim: 'Black',
    toneA: 'Black', // two-tone pair, only read when the rim is Two-tone
    toneB: 'Red',
    splatterBase: '', // splatter base and splatter color, only read when the rim is Splatter
    splatterColor: '',
    spoke: 'Black',
    finTab: 'hubs', // the open tab on the phone colors step: hubs | rims | spokes
    confirmed: {},
    buildId: null,
    carted: null, // { id, sig } of the last build this browser added to the cart
    editing: null, // the cart build id being changed from the cart's "Change tires" link
    adding: false,
    cartError: '', // set when an add to cart comes back anything but a clean 2xx
  };

  var ROWS = [];

  function famEffective() {
    var s = setupOf(S.setup);
    return s.pair && S.tires === 'rtr' ? 'rtr_' + S.setup : S.setup;
  }

  /* The store's bike behind a builder bike: stark-varg for the Varg MX and EX, the
     handle itself for every other bike. */
  function fitHandle(b) {
    return b ? b.fit || b.handle : '';
  }

  /* The option values the builder lists as bikes of their own ("Stark Varg MX"). */
  var VARIANT_BIKES = BIKES.map(function (b) {
    return b.variant;
  }).filter(Boolean);

  /* A row another builder bike owns: the EX's rows when the MX is picked. */
  function rowForOther(r, b) {
    return !!b.variant && r.bike !== b.variant && VARIANT_BIKES.indexOf(r.bike) > -1;
  }

  function rowsFor(family) {
    if (!S.bike) return [];
    var b = bikeOf(S.bike);
    if (!b) return [];
    var fit = fitHandle(b);
    var out = [];
    for (var i = 0; i < ROWS.length; i++) {
      var r = ROWS[i];
      if (r.bike_handle === fit && r.family === family && !rowForOther(r, b)) out.push(r);
    }
    return out;
  }

  /* Option-value sub-choice. Only Stark Varg splits into MX and EX, and only on the
     families where the store lists them separately. */
  function variantBikes(family) {
    var seen = [];
    var rows = rowsFor(family);
    for (var i = 0; i < rows.length; i++) if (seen.indexOf(rows[i].bike) === -1) seen.push(rows[i].bike);
    return seen.sort();
  }

  /* The sub-choice in force for one family: its only bike, or the picked one when the
     family splits, or null while a split family waits for a pick. */
  function variantFor(family) {
    var list = variantBikes(family);
    if (list.length <= 1) return list[0] || null;
    return list.indexOf(S.variantBike) > -1 ? S.variantBike : null;
  }

  function activeVariantBike() {
    return variantFor(famEffective());
  }

  /* A family's rows for the sub-choice in force. A split family with no pick yet has
     none. */
  function rowsIn(family) {
    var rows = rowsFor(family);
    if (variantBikes(family).length > 1) {
      var vb = variantFor(family);
      if (!vb) return [];
      rows = rows.filter(function (r) {
        return r.bike === vb;
      });
    }
    return rows;
  }

  function availableRows() {
    return rowsIn(famEffective());
  }

  /* The Ready-to-Ride family for the setup in hand, or '' for a single wheel. */
  function rtrFamily() {
    return setupOf(S.setup).pair ? 'rtr_' + S.setup : '';
  }

  /* Every size step 3 offers for the bike and setup: the wheels-only sizes in the order
     they have always been listed, then any size that comes Ready-to-Ride only, in its own
     order. Matched by label, so one size reads as one card whichever row it ends up on.
     Each entry names the wheels-only row and the Ready-to-Ride rows behind it. When the
     wheels-only family splits by model (the Stark Varg rear wheel) its sizes wait for the
     MX or EX pick on this step. A split Ready-to-Ride family (the Stark Varg supermoto
     set) is not filtered here; its pick waits for step 4. */
  function byLabel(a, b) {
    return rowLabel(a) < rowLabel(b) ? -1 : 1;
  }

  function sizeOptions() {
    var out = [];
    var at = {};
    rowsIn(S.setup)
      .slice()
      .sort(byLabel)
      .forEach(function (r) {
        var k = rowLabel(r);
        if (at[k] != null) return;
        at[k] = out.length;
        out.push({ label: k, wheels: r, rtr: [] });
      });
    var rf = rtrFamily();
    if (rf) {
      var rtrRows = rowsFor(rf).slice().sort(byLabel);
      /* With the wheels-only family still waiting on its model pick, no size shows yet. */
      if (variantBikes(S.setup).length > 1 && !variantFor(S.setup)) rtrRows = [];
      rtrRows.forEach(function (r) {
        var k = rowLabel(r);
        if (at[k] == null) {
          at[k] = out.length;
          out.push({ label: k, wheels: null, rtr: [] });
        }
        out[at[k]].rtr.push(r);
      });
    }
    return out;
  }

  function sizeOption(label) {
    if (!label) return null;
    var list = sizeOptions();
    for (var i = 0; i < list.length; i++) if (list[i].label === label) return list[i];
    return null;
  }

  /* The Ready-to-Ride row to quote for a size: the picked model's where the family
     splits, otherwise the first. */
  function rtrRowOf(opt) {
    if (!opt || !opt.rtr.length) return null;
    var vb = variantFor(rtrFamily());
    for (var i = 0; vb && i < opt.rtr.length; i++) if (opt.rtr[i].bike === vb) return opt.rtr[i];
    return opt.rtr[0];
  }

  /* A split Ready-to-Ride family (the Stark Varg supermoto set) with no MX or EX picked
     yet. The size is chosen but no row is, so nothing is priced as if it were. */
  function rtrModelOpen(fam) {
    return !!fam && variantBikes(fam).length > 1 && !variantFor(fam);
  }

  function modelPending() {
    return S.tires === 'rtr' && !!sizeOption(S.sizeKey) && rtrModelOpen(rtrFamily());
  }

  /* The lowest Ready-to-Ride price for a size across its models, for a "From" price while
     the model is still to pick. */
  /* Steps 3 and 4 come before the colors, so a size and a package are priced at the
     included hub color whatever was picked on an earlier pass, and read as a "From"
     (Peter, 2026-10-17). The colors step shows what a color adds, and the total in the
     summary and the bar is the real one. */
  var BASE_COLOR = 'Black';
  function basePrice(row) {
    return colorPrice(row, BASE_COLOR);
  }

  function rtrFromPrice(opt) {
    var low = NaN;
    (opt ? opt.rtr : []).forEach(function (r) {
      var p = basePrice(r);
      if (!isNaN(p) && (isNaN(low) || p < low)) low = p;
    });
    return low;
  }

  /* The things to confirm for a size: every note on its wheels-only and Ready-to-Ride
     rows, once each by text, so a tick on step 3 holds whichever row step 4 lands on. */
  function sizeNotes(label) {
    var opt = sizeOption(label);
    if (!opt) return [];
    var out = [];
    (opt.wheels ? [opt.wheels] : []).concat(opt.rtr).forEach(function (r) {
      rowNotes(r).forEach(function (n) {
        if (out.indexOf(n) === -1) out.push(n);
      });
    });
    return out;
  }

  /* The tire package has to be one the chosen size is offered in. The rider's own ask
     (tiresWant, from a ?setup=rtror link or a tap on step 4) is kept apart from it: a size
     without that package falls back to the one it has, and the next size that offers it
     brings it back (Peter, 2026-10-16). A Ready-to-Ride only size switches to it without
     changing the ask. With no size yet the build follows the ask. */
  function syncTires() {
    if (!rtrOffered()) {
      S.tires = 'none';
      return;
    }
    var want = S.tiresWant === 'rtr' ? 'rtr' : 'none';
    var opt = sizeOption(S.sizeKey);
    if (!opt) {
      S.tires = want;
      return;
    }
    if (want === 'rtr') S.tires = opt.rtr.length ? 'rtr' : 'none';
    else S.tires = opt.wheels ? 'none' : 'rtr';
  }

  function currentRow() {
    var rows = availableRows();
    for (var i = 0; i < rows.length; i++) if (rowLabel(rows[i]) === S.sizeKey) return rows[i];
    return null;
  }

  function rowLabel(r) {
    if (r.label) return r.label;
    var parts = [];
    if (r.front) parts.push(r.front.replace('x', ' x ') + '" Front');
    if (r.rear) parts.push(r.rear.replace('x', ' x ') + '" Rear');
    return parts.join(' / ');
  }

  /* The size the way a rider reads it: front on one line, rear on the next, and a size
     never split across a line (Phase 3, item 9). Built from the same front and rear the
     label uses. Display only: rowLabel is still the value the cart and the request
     carry. */
  function rowLines(r) {
    var lines = [];
    if (r.front) lines.push(['Front', r.front]);
    if (r.rear) lines.push(['Rear', r.rear]);
    if (!lines.length) return esc(rowLabel(r));
    return lines
      .map(function (l) {
        return (
          '<span class="rm-sizeline">' + l[0] + ' <span class="rm-nowrap">' + esc(l[1].replace('x', ' x ')) + '"</span></span>'
        );
      })
      .join('');
  }

  /* A Ready-to-Ride tire pairing as written on a card, with each tire size kept whole
     so 90/100-21, 4.10-18 or 160/60ZR17 never breaks at its slash or hyphen. Display
     only. */
  function tireHtml(t) {
    return esc(String(t).split('|').join(' · ')).replace(
      /\d+(?:\.\d+)?(?:\/\d+)?(?:-|Z?R)\d+/g,
      '<span class="rm-nowrap">$&</span>'
    );
  }

  function rowNotes(r) {
    if (!r) return [];
    var n = r.notes || [];
    if (typeof n === 'string')
      n = n
        .split(/\||\n/)
        .map(function (x) {
          return x.trim();
        })
        .filter(Boolean);
    n = n.map(function (x) {
      return x.charAt(0).toUpperCase() + x.slice(1);
    });
    /* The Varg off-road sets are one set of rows for the MX and the EX, and the fitment
       data cannot say a 19 inch rear is taller than stock on one and stock on the other.
       The builder knows which Varg it is, so the EX gets the taller-rear note on a rear
       larger than its stock 18 inch, in the same words as the data (Peter, 2026-10-17). */
    var b = bikeOf(S.bike);
    var dia = r.rear ? parseInt(String(r.rear).split('x')[0], 10) : NaN;
    if (b && b.stockRear && dia > b.stockRear && !n.some(function (x) {
      return /larger diameter/i.test(x);
    }))
      n.push(TALLER_REAR);
    return n;
  }

  var TALLER_REAR =
    'Special Note: This rear wheel size is a larger diameter than OEM and may require a longer chain or smaller sprocket for proper fitment and axle alignment.';

  function rtrOffered() {
    var s = setupOf(S.setup);
    if (!s.pair) return false;
    return rowsFor('rtr_' + S.setup).length > 0;
  }

  /* The upcharge product carries the rim color surcharge as a real line. It is a draft
     product until Peter activates it, so nothing here assumes it is buyable: the ids
     come from Liquid when the storefront can see the product, and a load-time probe
     confirms it and picks the ids up if the product is published after this page was
     cached. When it is not there the build still prices and still quotes. */
  /* Every variant slot the builder can charge against: the per-wheel spoke charge, the
     per-wheel and per-set rim pairs, the per-set splatter charge, and the per-hub charge
     for Burnt Blue and Rainbow hubs. The hub slot is its own $20 variant rather than the
     spoke one, so a build with both charges carries two separate lines. */
  var UPCHARGE_KEYS = ['20', '40', '55', '80', '110', '150', 'hub20'];
  var UPCHARGE = { 20: '', 40: '', 55: '', 80: '', 110: '', 150: '', hub20: '', checked: false };
  (function seedUpcharge() {
    var u = CONFIG.upcharge || {};
    UPCHARGE_KEYS.forEach(function (k) {
      UPCHARGE[k] = u[k] ? String(u[k]) : '';
    });
  })();

  /* A set needs the two per-set rim variants, a single wheel needs the two per-wheel
     ones. Only the pair the current build would charge against has to be there. The
     per-wheel spoke variant is checked on its own so a missing spoke variant never
     blocks a rim. */
  function upchargeLive() {
    if (setupOf(S.setup).pair) return !!(UPCHARGE[80] && UPCHARGE[110]);
    return !!(UPCHARGE[40] && UPCHARGE[55]);
  }

  function probeUpcharge() {
    var handle = (CONFIG.upcharge || {}).handle || 'custom-finish-upcharge';
    return fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (prod) {
        UPCHARGE.checked = true;
        if (!prod || !prod.variants) return;
        /* Five rim variants now: the per-set pair, the per-wheel pair and the per-set
           splatter charge. Each one that is really there is picked up on its own, and
           upchargeLive() decides which pair the build in hand needs. */
        var rimSkus = {
          'RM-UPCHARGE-80': '80',
          'RM-UPCHARGE-110': '110',
          'RM-UPCHARGE-40': '40',
          'RM-UPCHARGE-55': '55',
          'RM-UPCHARGE-150': '150',
        };
        UPCHARGE_KEYS.forEach(function (k) {
          UPCHARGE[k] = '';
        });
        prod.variants.forEach(function (v) {
          if (!v.available) return;
          if (rimSkus[v.sku]) UPCHARGE[rimSkus[v.sku]] = String(v.id);
          if (v.sku === 'RM-UPCHARGE-20') UPCHARGE[20] = String(v.id);
          if (v.sku === 'RM-UPCHARGE-HUB20') UPCHARGE.hub20 = String(v.id);
        });
      })
      .catch(function () {
        UPCHARGE.checked = true;
        UPCHARGE_KEYS.forEach(function (k) {
          UPCHARGE[k] = '';
        });
      });
  }

  function upchargeVariant(amount) {
    return UPCHARGE[String(amount)] || '';
  }

  /* The finish rows carry the per-set figure. A single wheel pays half of it, rounded
     to whole dollars, which is the $40 and $55 the store sells as its own variants.
     Splatter has a per-set variant only, so a single splatter wheel prices here and is
     quoted rather than bought online. */
  function rimCharge(rim) {
    var up = (rim && rim.up) || 0;
    if (!up) return 0;
    return setupOf(S.setup).pair ? up : Math.round(up / 2);
  }

  /* How the charge reads wherever it is written out. */
  function rimUnit() {
    return setupOf(S.setup).pair ? 'per set' : 'per wheel';
  }

  /* Every rim color is pickable. Whether it can be bought online in one click is a
     separate question, answered here. */
  function rimCartable(rim) {
    if (!rim.up) return true;
    return upchargeLive() && !!upchargeVariant(rimCharge(rim));
  }

  /* Spokes are charged per wheel, so a single wheel in white spokes is one unit of the
     $20 variant and is fine to buy online. The only question is whether that variant
     exists yet. */
  function spokeCartable(spoke) {
    if (!spoke.up) return true;
    return !!upchargeVariant(20);
  }

  /* The hub charge is per hub, so a set takes two units of the per-hub variant and a
     single wheel takes one. Like the spoke charge, the only question is whether that
     variant exists yet. */
  function hubCartable(id) {
    if (!hubCharge(id)) return true;
    return !!upchargeVariant('hub20');
  }

  /* The suffix the spoke charge reads as everywhere it is written out. */
  function spokeSuffix(spoke) {
    if (spoke.up) return ' (+' + money(spoke.up) + ' per wheel)';
    return spoke.id === 'Black' ? ' (standard)' : ' (no charge)';
  }

  /* ---------- price ---------- */

  function price() {
    var row = currentRow();
    if (!row) return { total: null, status: 'incomplete', base: null, up: 0, spokeUp: 0, hubUp: 0 };
    /* A builder only hub color prices off the Black variant and adds its own per-hub
       charge, if it has one, on top. */
    var listed = listingColor(S.color);
    var base = row.prices ? Number(row.prices[listed]) : NaN;
    var variantId = row.variants ? row.variants[listed] : null;
    var hubUp = hubCharge(S.color);
    var rim = rimOf(S.rim);
    var spoke = spokeOf(S.spoke);
    var up = rimCharge(rim);
    /* The rim charge is per set on a set and half that on a single wheel. The spoke
       charge is per wheel, so a front and rear set carries it twice. */
    var spokeUp = (spoke.up || 0) * (setupOf(S.setup).pair ? 2 : 1);
    var tirePick = chosenTireChoice();
    var tireUp = tirePick ? tirePick.cents / 100 : 0;
    if (isNaN(base)) return { total: null, status: 'incomplete', base: null, up: up, spokeUp: spokeUp, hubUp: hubUp, tireUp: tireUp };
    /* Verified only when the variant really exists. Otherwise it is an estimate and the
       build becomes a request. */
    var status = variantId ? 'verified' : 'estimate';
    if (status === 'verified' && up && !rimCartable(rim)) status = 'quote';
    if (status === 'verified' && spokeUp && !spokeCartable(spoke)) status = 'quote';
    if (status === 'verified' && hubUp && !hubCartable(S.color)) status = 'quote';
    return {
      total: base + up + spokeUp + hubUp + tireUp,
      status: status,
      base: base,
      up: up,
      spokeUp: spokeUp,
      hubUp: hubUp,
      tireUp: tireUp,
      variantId: variantId ? String(variantId) : null,
    };
  }

  /* What a listing row costs in one hub color, the per-hub charge included, for the
     size cards and the hub swatches. */
  function colorPrice(row, id) {
    var p = row && row.prices ? Number(row.prices[listingColor(id)]) : NaN;
    return isNaN(p) ? NaN : p + hubCharge(id);
  }

  /* What a hub color adds over Black on the size row in hand, read off the variant
     prices and the per-hub charge, so a hub swatch reads like a rim one (Phase 3, item
     10). Magnesium's comes out of its own variant prices, so it follows the listings.
     Display only: price() is still what the build costs. */
  function colorAddOn(row, id) {
    var base = colorPrice(row, 'Black');
    var p = colorPrice(row, id);
    return isNaN(base) || isNaN(p) ? NaN : p - base;
  }

  /* The swatch line for an add-on: "incl." when it costs nothing extra, "+$30" when it
     does. A listing priced under Black says so rather than reading as included. */
  function addOnText(n) {
    if (n == null || isNaN(n)) return '';
    if (!n) return 'incl.';
    return (n > 0 ? '+' : '−') + money(Math.abs(n));
  }

  function leadLines() {
    var out = [];
    out.push(S.tires === 'rtr' ? LEAD.rtr : LEAD.wheels);
    var rim = rimOf(S.rim);
    if (rim.lead) {
      out.push(rim.id + ' rims add about ' + rim.lead + ' business days');
    } else if (S.color === 'Magnesium') {
      out.push(LEAD.mag);
    }
    var spoke = spokeOf(S.spoke);
    if (spoke.lead) out.push(spoke.id + ' spokes add about ' + spoke.lead + ' business days');
    return out;
  }

  /* ---------- step completion ---------- */

  function stepDone(n) {
    if (n === 1) return !!S.bike;
    /* A bike with no sizes listed in any setup stops here, with a request instead. */
    if (n === 2) return !!S.setup && rowsFor(S.setup).length > 0;
    /* Step 3 is the size and every note for it ticked. */
    if (n === 3) {
      if (!sizeOption(S.sizeKey)) return false;
      var notes = sizeNotes(S.sizeKey);
      for (var i = 0; i < notes.length; i++) if (!S.confirmed[noteKey(S.sizeKey, notes[i])]) return false;
      return true;
    }
    /* Step 4 is a tire package the size is offered in, which is what lands the row (and,
       on a split Ready-to-Ride family, the MX or EX pick). */
    if (n === 4) return !!currentRow() && tireChoiceConfirmed();
    if (n === 5) {
      if (!S.color || !S.rim || !S.spoke) return false;
      /* A two-tone rim needs two different colors before it is a buildable wheel. */
      if (isTwoTone() && !twoTonePairAllowed(S.toneA, S.toneB)) return false;
      /* A splatter rim is not a wheel until both the base and the splatter are named. */
      if (isSplatter() && !splatterChosen()) return false;
      return true;
    }
    return true;
  }

  /* A tick belongs to the bike, the setup, the size and the words of the note, not to a
     row, so it still counts on whichever tire package step 4 picks. Ticks saved under the
     old row-and-index keys simply no longer match. */
  function noteKey(label, text) {
    return S.bike + '|' + S.setup + '|' + label + '|' + text;
  }

  /* A build that can go in the cart or a request: a size with its notes ticked and a
     row behind it. */
  function buildReady() {
    return stepDone(3) && stepDone(4);
  }

  function maxReachable() {
    var n = 1;
    while (n < 6 && stepDone(n)) n++;
    return n;
  }

  /* How far the step tabs reach. A step already visited stays open, except that nothing
     past the size and tires opens while either is unfinished, so a new size with an
     unticked note cannot be skipped from the tabs to a Review that lists it as
     confirmed. */
  function reachLimit() {
    var m = maxReachable();
    var lim = m <= 4 ? m : Math.max(S.maxStep, m);
    /* A package that changed under the rider keeps the later steps shut until step 4 has
       been seen and passed again. */
    return S.tiresMoved ? Math.min(lim, 4) : lim;
  }

  /* Called after anything that can move the package without the rider tapping it. A
     rider who had already got past step 4 sees it again before colors and review. */
  function tiresMovedCheck(before) {
    if (S.tires === before || S.maxStep < 4) return;
    S.tiresMoved = true;
    S.maxStep = Math.min(S.maxStep, 4);
  }

  /* ---------- render ---------- */

  var elSteps = root.querySelector('[data-rm-steps]');
  var elPanel = root.querySelector('[data-rm-panel]');
  var elSummary = root.querySelector('[data-rm-summary]');
  var elMob = root.querySelector('[data-rm-mobbar]');
  var elRequest = root.querySelector('[data-rm-request]');
  var elLive = root.querySelector('[data-rm-live]');

  /* One polite line carries step progress to a screen reader. */
  function announceStep() {
    if (!elLive) return;
    var name = STEP_NAMES[S.step - 1] || '';
    elLive.textContent = 'Step ' + S.step + ' of ' + STEP_NAMES.length + ': ' + name;
  }

  function prefersReducedMotion() {
    return (
      typeof window.matchMedia === 'function' &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    );
  }

  function optCard(opts) {
    /* opts: name, value, checked, disabled, html, cls, attrs (extra label attributes) */
    return (
      '<label class="rm-opt ' +
      (opts.cls || '') +
      '"' +
      (opts.attrs || '') +
      '><input type="radio" name="' +
      opts.name +
      '" value="' +
      esc(opts.value) +
      '"' +
      (opts.checked ? ' checked' : '') +
      (opts.disabled ? ' disabled' : '') +
      '><span>' +
      opts.html +
      '</span></label>'
    );
  }

  function renderSteps() {
    var reach = reachLimit();
    var html = '';
    for (var i = 0; i < STEP_NAMES.length; i++) {
      var n = i + 1;
      var done = n < S.step && stepDone(n);
      html +=
        '<button type="button" data-step="' +
        n +
        '"' +
        (n === S.step ? ' aria-current="step"' : '') +
        (done ? ' class="is-done"' : '') +
        (n > reach ? ' disabled' : '') +
        '><i>' +
        (done ? '✓' : n) +
        '</i><span>' +
        esc(STEP_NAMES[i]) +
        '</span></button>';
    }
    elSteps.innerHTML = html;
    scrollStepIntoView();
    renderStepMenu();
  }

  /* On a phone the sideways tab strip is replaced by one line, "Step 3 of 6: Wheel
     size", over a six part bar (Peter, 2026-10-14). Tapping it opens the same
     step buttons as a list, so going back a step still works. */
  var elMStep = root.querySelector('[data-rm-mstep]');
  var elStepNav = root.querySelector('.rm-bld__steps');

  function renderStepMenu() {
    if (!elMStep) return;
    var n = STEP_NAMES.length;
    var bars = '';
    for (var i = 1; i <= n; i++) bars += '<i class="' + (i < S.step ? 'is-done' : i === S.step ? 'is-now' : '') + '"></i>';
    elMStep.innerHTML =
      '<span class="rm-bld__mstep-txt"><small>Step ' + S.step + ' of ' + n + '</small><b>' + esc(STEP_NAMES[S.step - 1]) + '</b></span>' +
      '<span class="rm-bld__mstep-chev" aria-hidden="true"></span>' +
      '<span class="rm-bld__mstep-bar" aria-hidden="true">' + bars + '</span>';
    elMStep.setAttribute('aria-label', 'Step ' + S.step + ' of ' + n + ', ' + STEP_NAMES[S.step - 1] + '. Show all steps');
  }

  function setStepMenu(open) {
    if (!elStepNav || !elMStep) return;
    elStepNav.classList.toggle('is-open', !!open);
    elMStep.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  if (elMStep) {
    elMStep.addEventListener('click', function () {
      setStepMenu(!elStepNav.classList.contains('is-open'));
    });
  }

  /* The strip scrolls sideways on a phone. Keep the current step visible
     without scrolling the page itself. */
  function scrollStepIntoView() {
    var scroller = elSteps.closest('.rm-bld__steps-scroll');
    if (!scroller) return;
    var current = elSteps.querySelector('[aria-current="step"]');
    if (!current) return;
    /* Measured against the scroll box rather than offsetLeft, because the box
       is now the page container and no longer starts at the viewport edge. */
    var pad = 16;
    var stepBox = current.getBoundingClientRect();
    var scrollBox = scroller.getBoundingClientRect();
    var left = scroller.scrollLeft + (stepBox.left - scrollBox.left) - pad;
    var right = scroller.scrollLeft + (stepBox.right - scrollBox.left) + pad;
    if (left < scroller.scrollLeft) {
      scroller.scrollLeft = Math.max(0, left);
    } else if (right > scroller.scrollLeft + scroller.clientWidth) {
      scroller.scrollLeft = right - scroller.clientWidth;
    }
  }

  /* Step 1 works like the bike picker in the site header (Peter, 2026-10-15): a search
     box over one accordion row per brand, one brand open at a time. The rows inside are
     still the one radio group inside one fieldset, so state, preselect and the change
     handler are the same as before. The brand rule and the brand order are the header's
     (snippets/rm-bike-brand.liquid), so the two lists read alike. SRPNT and Stark stay
     their own brands. */
  var BRAND_ORDER = ['Sur-Ron', 'Talaria', 'E-Ride Pro', 'Altis', 'Stark', 'SRPNT', 'Arctic Leopard', 'Vetra'];
  var BIKE_ASK_URL = '/pages/contact-us';

  /* The search text and the open brand live here rather than in the markup, so a render
     on step 1 (a pick, the upcharge probe) puts both back as they were. */
  var bikeQuery = '';
  var bikeOpen = null;
  /* The brand to open on step 1 when the header names a bike the builder splits in two
     (stark-varg: the Varg MX or the EX), so the rider sees both and picks one. */
  var bikeHint = null;
  var bikePanelStep = 0;
  var bikeCountTimer = 0;
  /* A bike from the header that the builder does not list (E-Ride Pro S, the Rawrr
     bikes, every gas bike), as { handle, label }. Step 1 names it in a notice until a
     builder bike is picked. */
  var bikeForeign = null;

  /* A bike's brand is its group, except "Other", which becomes the first word of the
     name. "Arctic Leopard" is the one two-word brand. */
  function brandOf(b) {
    var g = String(b.grp || '').trim();
    if (g && g.toLowerCase() !== 'other') return g;
    var name = String(b.name || '').trim();
    if (name.toLowerCase().indexOf('arctic leopard') === 0) return 'Arctic Leopard';
    return name.split(' ')[0];
  }

  /* The model as the header shows it, without the brand in front: "Light Bee X 2026",
     "Sigma 2025 LE". */
  function bikeShort(b) {
    var label = bikeLabel(b);
    var brand = brandOf(b);
    return label.toLowerCase().indexOf(brand.toLowerCase() + ' ') === 0 ? label.slice(brand.length + 1) : label;
  }

  function brandSlug(grp) {
    return String(grp)
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '');
  }

  /* The builder bikes behind one store bike, when the builder splits it (stark-varg). */
  function bikesFor(fit) {
    return BIKES.filter(function (b) {
      return b.fit === fit;
    });
  }

  /* A store bike the builder splits in two, named without saying which one. */
  function sharedFit(x) {
    return !!x && !bikeOf(x) && bikesFor(x).length > 0;
  }

  /* A handle or a store option value ("Sur-Ron LBX 2026") to a builder bike, or null. A
     store bike the builder splits resolves to the one already picked, if it is one of
     them, and otherwise to null, so the rider picks MX or EX on step 1. */
  function resolveBike(x) {
    if (!x) return null;
    var b = bikeOf(x);
    for (var i = 0; !b && i < BIKES.length; i++) if (BIKES[i].id === x) b = BIKES[i];
    if (!b && sharedFit(x)) {
      var cur = bikeOf(S.bike);
      b = cur && cur.fit === x ? cur : null;
    }
    return b;
  }

  /* The header picker's name for a bike, read off its button, or the handle when the
     picker is not on the page. */
  function headerBikeLabel(handle) {
    var sel = '[data-bike-handle="' + (window.CSS && CSS.escape ? CSS.escape(handle) : handle) + '"]';
    var btn = null;
    try {
      btn = document.querySelector(sel);
    } catch (err) {
      btn = null;
    }
    return (btn && btn.getAttribute('data-bike-label')) || handle;
  }

  function bikeBrands() {
    var order = BRAND_ORDER.slice();
    var byBrand = {};
    BIKES.forEach(function (b) {
      var brand = brandOf(b);
      if (order.indexOf(brand) === -1) order.push(brand);
      (byBrand[brand] = byBrand[brand] || []).push(b);
    });
    return order
      .filter(function (brand) {
        return byBrand[brand];
      })
      .map(function (brand) {
        return { brand: brand, bikes: byBrand[brand] };
      });
  }

  function modelCount(n) {
    return n + (n === 1 ? ' model' : ' models');
  }

  /* Each bike's side-profile render, by builder handle (spec, 2026-10-16). The slugs are
     the theme's assets/rm-bike-<slug>.jpg files and the section outputs their URLs, so a
     slug with no file, or a bike missing here, gets an empty space the same size and the
     row still lines up. The MX3 and the MX4 / XXX share a render, as do the three Altis
     Sigma rows and both Arctic Leopard rows. */
  var BIKE_IMAGE = {
    'sur-ron-lbx': 'sur-ron-light-bee-x',
    'sur-ron-lbx-2026': 'sur-ron-light-bee-x-2026',
    'sur-ron-light-bee-2': 'sur-ron-light-bee-2',
    'sur-ron-ultra-bee': 'sur-ron-ultra-bee',
    'srpnt-z27-x8': 'srpnt-z27-x8',
    'talaria-mx3': 'talaria-mx3-mx4-xxx',
    'talaria-mx4-xxx': 'talaria-mx3-mx4-xxx',
    'talaria-mx5': 'talaria-mx5',
    'talaria-komodo': 'talaria-komodo',
    'e-ride-pro-ss-2-0': 'e-ride-pro-ss-2-0',
    'e-ride-pro-3-0-sr': 'e-ride-pro-3-0-sr',
    'e-ride-pro-4-0': 'e-ride-pro-4-0',
    'altis-sigma-2025': 'altis-sigma',
    'altis-sigma-2025-le': 'altis-sigma',
    'altis-sigma-2026': 'altis-sigma',
    'stark-varg-mx': 'stark-varg',
    'stark-varg-ex': 'stark-varg',
    'arctic-leopard-xe-pro-s': 'arctic-leopard-xe-pro-s',
    'arctic-leopard-xe-pro-r': 'arctic-leopard-xe-pro-s',
    'vetra-blazer': 'vetra-blazer',
  };

  function bikeImageUrl(b) {
    var slug = b && BIKE_IMAGE[b.handle];
    return (slug && (CONFIG.bike_images || {})[slug]) || '';
  }

  /* The picture box is always there, with or without a picture, so every row lines up.
     The name is the label, so the picture says nothing to a screen reader. Closed brands
     are display none, so lazy loading fetches only the open brand's pictures. */
  function bikeImageHtml(b) {
    var url = bikeImageUrl(b);
    return (
      '<span class="rm-bld__bimg" aria-hidden="true">' +
      (url ? '<img src="' + esc(url) + '" width="720" height="420" alt="" loading="lazy" decoding="async">' : '') +
      '</span>'
    );
  }

  /* A render that is not on the theme, or fails to load, leaves the box empty rather
     than a broken image, so the row still lines up. */
  function bindBikePics(scope) {
    scope.querySelectorAll('.rm-bld__bimg img').forEach(function (img) {
      var drop = function () {
        if (img.parentNode) img.parentNode.removeChild(img);
      };
      if (img.complete && img.getAttribute('src') && !img.naturalWidth) drop();
      else img.addEventListener('error', drop);
    });
  }

  function panelBike() {
    var row = function (b) {
      /* What the search matches: the brand, the model and the first sentence of the
         years line, so "2026" finds the 2026 bikes and not the line that says the 2026
         is different. A sentence about a shared fitment is left out, as the header
         leaves it out, so "sur-ron" does not find the SRPNT and "3.0" does not find the
         E-Ride Pro 4.0. Two aliases riders type are added to the search text only:
         the brand without its hyphen or spaces ("surron") and "lbx" for a Light Bee X. */
      var years = String(b.years || '').split('. ')[0];
      if (/\bshares?\b/i.test(years)) years = '';
      var brand = brandOf(b);
      var alias = brand.replace(/[^a-z0-9]/gi, '');
      if (/light bee x/i.test(b.name)) alias += ' lbx';
      var q = (brand + ' ' + bikeLabel(b) + ' ' + years + ' ' + alias).toLowerCase();
      return optCard({
        name: 'rm-bike',
        value: b.handle,
        checked: S.bike === b.handle,
        cls: 'rm-bld__bike',
        attrs: ' data-q="' + esc(q) + '"',
        html:
          bikeImageHtml(b) +
          '<span class="rm-bld__btext"><b>' +
          esc(bikeShort(b)) +
          '</b>' +
          /* The Altis labels already end in their years line ("Sigma 2025 LE"). */
          (bikeShort(b).slice(-String(b.years).length) === b.years ? '' : '<small>' + esc(b.years) + '</small>') +
          (b.status === 'check'
            ? '<span class="rm-opt__flag">Fitment confirmed before build</span>'
            : '') +
          '</span>',
      });
    };
    var brands = bikeBrands()
      .map(function (g) {
        var slug = brandSlug(g.brand);
        var n = g.bikes.length;
        return (
          '<div class="rm-bld__acc" data-rm-acc="' + esc(g.brand) + '">' +
          '<button type="button" class="rm-bld__acc-head" id="rm-acc-h-' + slug + '" aria-expanded="false" aria-controls="rm-acc-b-' + slug + '" data-rm-acc-head>' +
          '<span class="rm-bld__acc-name">' + esc(g.brand) + '</span>' +
          '<small data-rm-acc-count data-n="' + n + '">' + modelCount(n) + '</small>' +
          '<small class="rm-bld__acc-pick" data-rm-acc-pick hidden></small>' +
          '</button>' +
          '<div class="rm-bld__acc-body" id="rm-acc-b-' + slug + '" role="group" aria-labelledby="rm-acc-h-' + slug + '">' +
          g.bikes.map(row).join('') +
          '</div></div>'
        );
      })
      .join('');
    return (
      '<h2>Which bike are we building for?</h2>' +
      '<p class="rm-bld__help">Select your bike model first so we can determine the correct axle diameter and hub size so your bike\'s brake rotors and sprockets can swap over.</p>' +
      (bikeForeign
        ? '<p class="rm-note rm-note--warn rm-bld__bforeign" data-rm-bike-foreign>We don\'t list wheels for <b>' +
          esc(bikeForeign.label) +
          '</b> yet. Pick a bike below, or <a href="' +
          BIKE_ASK_URL +
          '">ask us</a> and we\'ll check fitment.</p>'
        : '') +
      '<div class="rm-bld__bsearch">' +
      '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true" focusable="false"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/></svg>' +
      '<input type="text" data-rm-bike-q value="' + esc(bikeQuery) + '" placeholder="Type your bike, e.g. MX5" aria-label="Filter bikes" autocomplete="off" spellcheck="false">' +
      '</div>' +
      '<fieldset class="rm-bld__fieldset rm-bld__bikes"><legend class="rm-visually-hidden rm-bld__legend">Bike</legend>' +
      brands +
      '<p class="rm-bld__bnone" data-rm-bike-none hidden>No match. Try the brand name, or <a href="' + BIKE_ASK_URL + '">ask us</a>.</p>' +
      '</fieldset>'
    );
  }

  function bikeTokens() {
    var q = bikeQuery.trim().toLowerCase();
    return q ? q.split(/\s+/) : [];
  }

  function setAcc(acc, on) {
    /* A brand that closes with focus on one of its bikes hands focus to its head, so it
       is never left inside a hidden body. */
    var a = document.activeElement;
    if (!on && a && a !== document.body && acc.contains(a) && !a.hasAttribute('data-rm-acc-head')) {
      var h = acc.querySelector('[data-rm-acc-head]');
      if (h) h.focus({ preventScroll: true });
    }
    acc.classList.toggle('is-open', on);
    var head = acc.querySelector('[data-rm-acc-head]');
    if (head) head.setAttribute('aria-expanded', on ? 'true' : 'false');
  }

  /* Puts the list in the state the closure holds, without a render. With text in the box
     every brand with a match opens and shows how many it has; with none, only bikeOpen
     is open. A closed brand that holds the picked bike names it in place of its count,
     so the pick shows without opening the brand. Returns the number of matches. */
  function syncBikeList() {
    var tokens = bikeTokens();
    var total = 0;
    var picked = S.bike ? bikeOf(S.bike) : null;
    elPanel.querySelectorAll('[data-rm-acc]').forEach(function (acc) {
      var brand = acc.getAttribute('data-rm-acc');
      var hits = 0;
      acc.querySelectorAll('.rm-bld__bike').forEach(function (row) {
        var text = row.getAttribute('data-q') || '';
        var ok = tokens.every(function (t) {
          return text.indexOf(t) !== -1;
        });
        row.hidden = !ok;
        if (ok) hits++;
      });
      acc.hidden = hits === 0;
      total += hits;
      var open = tokens.length ? hits > 0 : brand === bikeOpen;
      setAcc(acc, open);
      var count = acc.querySelector('[data-rm-acc-count]');
      var pick = acc.querySelector('[data-rm-acc-pick]');
      var showPick = !open && !!picked && brandOf(picked) === brand;
      if (count) {
        count.textContent = modelCount(tokens.length ? hits : Number(count.getAttribute('data-n')) || 0);
        count.hidden = showPick;
      }
      if (pick) {
        pick.hidden = !showPick;
        pick.innerHTML = showPick
          ? '<span class="rm-visually-hidden">, selected: </span>' + esc(bikeShort(picked))
          : '';
      }
    });
    var none = elPanel.querySelector('[data-rm-bike-none]');
    if (none) none.hidden = total > 0;
    return total;
  }

  /* Opening a brand moves the page only as far as its bikes need to be on screen, under
     the site header and above the phone bar, and never so far that its head goes off
     the top. A bike that takes focus from a script is brought on screen the same way. */
  function revealAcc(acc) {
    revealNearest(acc);
  }

  function revealNearest(el) {
    var sc = pageScroller();
    var box = el.getBoundingClientRect();
    var top = headerOffset() + 8;
    var bar = root.querySelector('.rm-bld__mobbar');
    var foot = window.innerHeight - (bar && !bar.hidden ? bar.offsetHeight : 0) - 8;
    var delta = 0;
    if (box.top < top) delta = box.top - top;
    else if (box.bottom > foot) delta = Math.min(box.bottom - foot, box.top - top);
    if (Math.abs(delta) < 2) return;
    sc.scrollTo({ top: Math.max(0, sc.scrollTop + delta), behavior: scrollBehavior() });
  }

  function announceBikeCount(total) {
    clearTimeout(bikeCountTimer);
    if (!elLive) return;
    bikeCountTimer = setTimeout(function () {
      if (!bikeTokens().length) return;
      elLive.textContent = total === 0 ? 'No bikes match' : total === 1 ? '1 bike matches' : total + ' bikes match';
    }, 450);
  }

  /* Typing filters the list in place. It never renders, so focus and the caret stay
     where they are. */
  elPanel.addEventListener('input', function (e) {
    var t = e.target;
    if (!(t instanceof Element) || !t.hasAttribute('data-rm-bike-q')) return;
    bikeQuery = t.value;
    var total = syncBikeList();
    if (bikeTokens().length) {
      announceBikeCount(total);
    } else {
      /* An empty box takes its last count ("No bikes match") with it. */
      clearTimeout(bikeCountTimer);
      if (elLive) elLive.textContent = '';
    }
  });

  /* A brand head opens its brand and closes the others, or closes it when it is open. */
  elPanel.addEventListener('click', function (e) {
    var head = e.target instanceof Element ? e.target.closest('[data-rm-acc-head]') : null;
    if (!head || !elPanel.contains(head)) return;
    var acc = head.closest('[data-rm-acc]');
    var willOpen = !acc.classList.contains('is-open');
    elPanel.querySelectorAll('[data-rm-acc]').forEach(function (other) {
      setAcc(other, false);
    });
    setAcc(acc, willOpen);
    bikeOpen = willOpen ? acc.getAttribute('data-rm-acc') : null;
    /* The closed brands' heads change from a count to the pick, or back. */
    if (!bikeTokens().length) syncBikeList();
    if (willOpen) revealAcc(acc);
  });

  /* All the bikes are one radio group, and a browser only lets Tab into a radio group at
     its checked radio. With the picked bike in a closed brand, Tab from an open brand's
     head jumped straight past its bikes, and Shift+Tab from below landed on the head.
     In those two cases focus goes to the open brand's first bike instead, without
     picking it, and the arrow keys take it from there. */
  function strandedRadio(acc) {
    if (!acc || !acc.classList.contains('is-open')) return null;
    var visible = [];
    acc.querySelectorAll('input[name="rm-bike"]').forEach(function (r) {
      if (!r.closest('.rm-bld__bike').hidden) visible.push(r);
    });
    if (!visible.length) return null;
    for (var i = 0; i < visible.length; i++) if (visible[i].checked) return null;
    return elPanel.querySelector('input[name="rm-bike"]:checked') ? visible[0] : null;
  }

  /* Focus a bike from a script and bring its row on screen, clear of the site header
     and the phone bar. preventScroll alone left a row under the bar. */
  function focusBike(radio) {
    radio.focus({ preventScroll: true });
    revealNearest(radio.closest('label') || radio);
  }

  /* The Shift+Tab redirect acts only on the focus move that the key press itself makes.
     The time of the press is kept, and any pointer press or key release clears it, so a
     mouse click on a head never sends focus into a bike. */
  var bikeShiftTabAt = 0;
  document.addEventListener(
    'keydown',
    function (e) {
      bikeShiftTabAt = e.key === 'Tab' && e.shiftKey ? Date.now() : 0;
    },
    true
  );
  document.addEventListener(
    'keyup',
    function () {
      bikeShiftTabAt = 0;
    },
    true
  );
  document.addEventListener(
    'pointerdown',
    function () {
      bikeShiftTabAt = 0;
    },
    true
  );
  elPanel.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab' || e.shiftKey) return;
    var head = e.target instanceof Element && e.target.hasAttribute('data-rm-acc-head') ? e.target : null;
    if (!head) return;
    var radio = strandedRadio(head.closest('[data-rm-acc]'));
    if (!radio) return;
    e.preventDefault();
    focusBike(radio);
  });
  elPanel.addEventListener('focusin', function (e) {
    var shift = bikeShiftTabAt && Date.now() - bikeShiftTabAt < 100;
    bikeShiftTabAt = 0;
    var head = e.target instanceof Element && e.target.hasAttribute('data-rm-acc-head') ? e.target : null;
    var from = e.relatedTarget;
    if (!head || !shift || !(from instanceof Element)) return;
    var acc = head.closest('[data-rm-acc]');
    if (acc.contains(from) || !(acc.compareDocumentPosition(from) & Node.DOCUMENT_POSITION_FOLLOWING)) return;
    var radio = strandedRadio(acc);
    if (radio) focusBike(radio);
  });

  /* A pick makes its brand the open one, so clearing the search afterwards leaves the
     list open on the bike just picked. This runs before the builder's own change
     handler on the root renders. */
  elPanel.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.name === 'rm-bike') {
      var b = bikeOf(t.value);
      if (b) bikeOpen = brandOf(b);
      bikeForeign = null;
    }
  });

  /* What step 2 and the bar say for a bike we list no wheel sizes for. The bar's line is
     the short form, since the whole sentence took four lines of the phone bar. */
  var NO_SETUP_TEXT = "We don't list wheel sizes for this bike yet. Request a quote and we'll check fitment.";
  var NO_SETUP_BAR = 'No sizes listed yet. Request a quote';

  function barText(t) {
    return t === NO_SETUP_TEXT ? NO_SETUP_BAR : t;
  }

  /* Step 2 icons (Peter, 2026-10-16: "off-road and pavement icons" in place of photos;
     redrawn the same day so supermoto reads as pavement and the single wheels tell
     apart without their titles). One line style throughout: 2px strokes, rounded ends,
     on a 72 x 48 grid, the neutral lines in currentColor and the wheels that matter in
     rm-sicon__key, which the stylesheet paints green when the card is selected.
     - Off-road: the bike (tail, seat and tank, bars, fork, battery box, swingarm) with a
       high front fender, big knobs on both tires, bumpy dirt and a little roost.
     - Supermoto: the same bike sat lower on smaller, fatter slicks with no tread, a low
       fender hugging the front tire, slanted 14 degrees as it leans into the turn, on a
       flat road with a kerb of alternating filled and empty blocks and a centre dash.
     - Front only: one wheel with the fork, bars and fender above it, "F" under it.
     - Rear only: one wheel with the swingarm, shock, chain and sprocket, "R" under it. */
  var STYLE_FRAME =
    'M8 17.5L22 20.5L37 19.5L44 14.5M40.5 10.5L47.5 12M45.5 12L55 33' +
    'M25 21L40 20L35.5 29.5L29.5 29.5ZM30.5 29.5L17 33';

  function iconCircle(cx, cy, r, extra) {
    return '<circle cx="' + cx + '" cy="' + cy + '" r="' + r + '"' + (extra || '') + '/>';
  }

  function iconLabel(x, t) {
    return '<text x="' + x + '" y="46.5" text-anchor="middle">' + t + '</text>';
  }

  function styleIcon(id) {
    var K = '<g class="rm-sicon__key">';
    var DOT = ' fill="currentColor" stroke="none"';
    var art = '';
    if (id === 'offroad') {
      var knobby = function (cx) {
        return K + iconCircle(cx, 33, 8.5) + iconCircle(cx, 33, 10.4, ' stroke-width="3" stroke-dasharray="2.2 2.2"') + iconCircle(cx, 33, 4) + '</g>';
      };
      art =
        '<path d="' + STYLE_FRAME + 'M47.5 19.5L62.5 16.5"/>' +
        knobby(17) +
        knobby(55) +
        '<path d="M1 44H8Q12 44 14 43.5H27Q32 43.5 35 40.5Q38 38 41 40.5Q44 43.5 48 43.5H63Q67 43.5 69 41.5Q70.5 40.5 71 41.5"/>' +
        '<path d="M3.5 35.5h.1M1.5 30h.1M5.5 28h.1" stroke-width="2.4"/>';
    } else if (id === 'supermoto') {
      var slick = function (cx) {
        return K + iconCircle(cx, 35, 8) + iconCircle(cx, 35, 4.6) + '</g>' + iconCircle(cx, 35, 1.2, DOT);
      };
      art =
        '<g transform="translate(0 43) skewX(-14) translate(0 -43)">' +
        '<path transform="translate(0 2)" d="' + STYLE_FRAME + '"/>' +
        slick(17) +
        slick(55) +
        '<path d="M45.4 31.5A9.5 9.5 0 0 1 61.5 29"/>' +
        '</g>' +
        '<path d="M1 43.5H71"/>' +
        '<path d="M2 45h5v2.5H2zM12 45h5v2.5h-5zM22 45h5v2.5h-5z"' + DOT + '/>' +
        '<path d="M7 45h5v2.5H7zM17 45h5v2.5h-5z" stroke-width="1"/>' +
        '<path d="M34 46.5H70" stroke-dasharray="5 4"/>';
    } else if (id === 'front_single') {
      art =
        '<path d="M30.5 4.5L37 26M25.5 4L34.5 3M26.5 15.5L46.5 12.5"/>' +
        K + iconCircle(37, 26, 11) + iconCircle(37, 26, 5.5) + '</g>' +
        iconCircle(37, 26, 1.4, DOT) +
        iconLabel(37, 'F');
    } else if (id === 'rear_single') {
      art =
        '<path d="M34 26L58 21M34 20.6L57 18.4M34 31.4L57 23.6M48 23L52 8"/>' +
        iconCircle(58, 21, 2.6) +
        K + iconCircle(34, 26, 11) + '</g>' +
        iconCircle(34, 26, 5.4, ' stroke-width="2.4" stroke-dasharray="1.4 1.4"') +
        iconCircle(34, 26, 1.6, DOT) +
        iconLabel(34, 'R');
    }
    return (
      '<svg class="rm-sicon" viewBox="0 0 72 48" width="72" height="48" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' +
      art +
      '</svg>'
    );
  }

  /* A single wheel's card names the diameters this bike is listed in ("Choose from 19"
     and 21" sizes."), so it never offers a size the next step does not have. A bike
     with none listed keeps the general line. */
  function setupBlurb(s) {
    if (!s.end) return s.blurb;
    var seen = [];
    rowsFor(s.id).forEach(function (r) {
      var d = r[s.end] ? parseInt(String(r[s.end]).split('x')[0], 10) : NaN;
      if (!isNaN(d) && seen.indexOf(d) === -1) seen.push(d);
    });
    if (!seen.length) return s.blurb;
    seen.sort(function (a, b) {
      return a - b;
    });
    var list = seen.map(function (d) {
      return d + '"';
    });
    if (list.length === 1) return 'Available in ' + list[0] + '.';
    return 'Choose from ' + list.slice(0, -1).join(', ') + ' and ' + list[list.length - 1] + ' sizes.';
  }

  function panelSetup() {
    var cards = SETUPS.map(function (s) {
      var has = rowsFor(s.id).length > 0;
      return optCard({
        name: 'rm-setup',
        value: s.id,
        checked: S.setup === s.id,
        disabled: !has,
        cls: 'rm-opt--media rm-bld__style',
        html:
          styleIcon(s.id) +
          '<span class="rm-opt__body"><b>' +
          esc(s.title) +
          '</b><small>' +
          esc(setupBlurb(s)) +
          '</small>' +
          (has ? '' : '<span class="rm-opt__flag">Not listed for this bike</span>') +
          '</span>',
      });
    }).join('');
    var none = !SETUPS.some(function (s) {
      return rowsFor(s.id).length > 0;
    });
    return (
      '<h2>What type of wheelset do you need?</h2>' +
      '<p class="rm-bld__help">Select your setup type below and see available sizing for your bike on the next page.</p>' +
      (none
        ? '<div class="rm-note rm-note--warn" data-rm-nosetup><p style="margin:0 0 10px">' +
          esc(NO_SETUP_TEXT) +
          '</p><button type="button" class="rm-btn rm-btn--primary" data-request>Request a quote</button></div>'
        : '') +
      '<fieldset class="rm-bld__fieldset"><legend class="rm-bld__legend">Setup</legend>' +
      '<div class="rm-bld__setup">' +
      cards +
      '</div></fieldset>'
    );
  }

  /* The MX or EX pick, on whichever step the split family is chosen on: step 3 when the
     wheels-only family splits, step 4 when only Ready-to-Ride does. */
  function modelPick(family) {
    var vlist = variantBikes(family);
    if (vlist.length <= 1) return '';
    return (
      '<fieldset class="rm-bld__fieldset" style="margin-bottom:18px" data-rm-model><legend class="rm-bld__legend">Which model?</legend>' +
      '<div class="rm-bld__sub">The store lists this size separately for the MX and the EX.</div>' +
      '<div class="rm-bld__setup">' +
      vlist
        .map(function (v) {
          return optCard({
            name: 'rm-variantbike',
            value: v,
            checked: variantFor(family) === v,
            html: '<b>' + esc(v) + '</b>',
          });
        })
        .join('') +
      '</div></fieldset>'
    );
  }

  /* What a size card says it comes in. */
  function sizeKind(opt) {
    if (opt.wheels && opt.rtr.length) return 'Wheels only or Ready-to-Ride';
    if (opt.rtr.length) return 'Ready-to-Ride only';
    return 'Wheels only';
  }

  /* The size card's sense of scale: the front and rear wheels side by side, standing on
     one line, each drawn as a tire round a rim. A wheel is the rim's inches times 25.4
     plus two tire heights, 75 mm for knobbies and 65 mm for supermoto widths, so every
     card shares one scale and 21/18 stands visibly taller than 17/14. Not a spec, and
     not for a screen reader, since the size is written out beside it. One scale fits
     the largest wheel we list, a 21 inch knobby, in 30 of the 40 units. */
  var WHEEL_ART_SCALE = 30 / (21 * 25.4 + 2 * 75);

  function wheelArt(r) {
    var tire = S.setup === 'supermoto' ? 65 : 75;
    var list = [];
    if (r && r.front) list.push(['F', parseFloat(r.front)]);
    if (r && r.rear) list.push(['R', parseFloat(r.rear)]);
    list = list.filter(function (w) {
      return w[1] > 0;
    });
    if (!list.length) return '';
    var g = '';
    list.forEach(function (w, i) {
      var cx = list.length === 1 ? 32 : i ? 48 : 16;
      var rimR = (w[1] * 25.4 * WHEEL_ART_SCALE) / 2;
      var outR = ((w[1] * 25.4 + 2 * tire) * WHEEL_ART_SCALE) / 2;
      var cy = 31 - outR;
      g +=
        '<circle cx="' + cx + '" cy="' + cy.toFixed(2) + '" r="' + outR.toFixed(2) + '"/>' +
        '<circle class="rm-wsize__rim" cx="' + cx + '" cy="' + cy.toFixed(2) + '" r="' + rimR.toFixed(2) + '"/>' +
        '<text x="' + cx + '" y="39.5" text-anchor="middle">' + w[0] + '</text>';
    });
    return (
      '<svg class="rm-wsize" viewBox="0 0 64 40" width="64" height="40" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true" focusable="false">' +
      g +
      '</svg>'
    );
  }

  /* Step 3. Every size for the bike and setup, each card saying what comes in it. The
     price follows the tire package asked for, so the cards and the bar agree: the
     Ready-to-Ride price where Ready-to-Ride is asked for and the size has it, otherwise
     the price of the package the size comes in (Peter, 2026-10-16). */
  function panelSize() {
    var split = variantBikes(S.setup).length > 1;
    var sub = split ? modelPick(S.setup) : '';
    var opts = sizeOptions();
    var body = '';
    if (!opts.length) {
      body =
        '<p class="rm-note rm-note--info">' +
        (split && !variantFor(S.setup)
          ? 'Pick MX or EX above to see the sizes.'
          : 'We do not list this setup for that bike yet. Go back a step, or send us a build request and we will tell you what is possible.') +
        '</p>';
    } else {
      body =
        '<fieldset class="rm-bld__fieldset"><legend class="rm-bld__legend">Size</legend><div class="rm-bld__sizes">' +
        opts
          .map(function (o) {
            var useRtr = (S.tiresWant === 'rtr' && o.rtr.length) || !o.wheels;
            var r = useRtr ? rtrRowOf(o) : o.wheels;
            /* With MX or EX still to pick the price is a "From", the lowest model's. */
            var from = useRtr && rtrModelOpen(rtrFamily());
            var p = from ? rtrFromPrice(o) : basePrice(r);
            var notes = sizeNotes(o.label);
            var card = optCard({
              name: 'rm-size',
              value: o.label,
              checked: S.sizeKey === o.label,
              cls: 'rm-opt--media rm-opt--art-end',
              html:
                '<span class="rm-opt__body">' +
                (popularSize(o.label) ? POP_BADGE : '') +
                '<span class="rm-opt__size">' +
                rowLines(r) +
                '</span>' +
                (isNaN(p)
                  ? ''
                  : '<span class="rm-opt__price">From ' + esc(money(p)) + '</span>') +
                '<small>' + sizeKind(o) + '</small>' +
                (notes.length ? '<span class="rm-opt__flag">' + notes.length + ' thing' + (notes.length > 1 ? 's' : '') + ' to confirm</span>' : '') +
                '</span>' +
                wheelArt(r),
            });
            /* The tick boxes sit straight under the size they belong to. Below the
               whole list they were a screen or more away on a phone, with Continue
               greyed out and nothing saying why. */
            return S.sizeKey === o.label && notes.length ? card + confirmBlock(o.label, notes) : card;
          })
          .join('') +
        '</div></fieldset>';
    }

    return (
      '<h2>Pick your size</h2>' +
      '<p class="rm-bld__help">Choose your wheel set size for your ' +
      esc(bikeLabel(bikeOf(S.bike))) +
      '. Options shown below are confirmed to fit your bike - options with a note need a confirmation tick before you can continue.</p>' +
      sub +
      body
    );
  }

  function confirmBlock(label, notes) {
    return (
          '<div class="rm-confirm rm-confirm--inline" data-rm-confirm>' +
          '<h3 class="rm-bld__legend">Confirm before you continue</h3>' +
          notes
            .map(function (n) {
              var k = noteKey(label, n);
              return (
                '<label><input type="checkbox" data-note="' +
                esc(k) +
                '"' +
                (S.confirmed[k] ? ' checked' : '') +
                '><span>' +
                esc(n) +
                '</span></label>'
              );
            })
            .join('') +
          '</div>'
    );
  }

  /* Step 4. Only the tire packages the chosen size comes in. Ready-to-Ride shows its tire
     pairing and what it adds over wheels only; on a size that is Ready-to-Ride only it
     shows the set price instead. With one package the size decides it, and a short note
     says why. */
  /* A Ready-to-Ride row with no tire pairing on file yet (Peter and the redesign chat
     own the data). The rider is told it is settled with them rather than shown a gap. */
  /* Only Ready-to-Ride supermoto sets are dynamically balanced before they ship, not the
     off-road ones (Peter, 2026-10-12; knowledge base E-moto wheels). */
  function rtrMountText() {
    return S.setup === 'supermoto'
      ? 'Rim strips, tubes and tires professionally mounted & dynamically balanced before shipment'
      : 'Rim strips, tubes and tires professionally mounted before shipment';
  }
  var TIRE_TBC = 'Tire pairing confirmed with you before the build';

  /* Step 4 pictures (spec, 2026-10-16; two fix rounds the same day). Step 4 comes before
     the colors, so a first pass is all black, and the pictures follow the colors once
     they are picked.
     - Ready-to-Ride, and Wheels only on a single wheel, show the product photo of the
       hub color while rim and spokes are Black. The photo is, in order: the featured
       image of the exact variant the build carts (the row's variant for the hub color;
       a builder-only hub color carts the Black variant, so it skips this), then the
       product image whose file name carries the hub color as a whole word, the longest
       color name winning so "light-blue" is not taken for "blue".
     - Failing those, or with a colored rim or spokes, the finish photo for the colors
       in hand stands in, marked "Shown without tires" on Ready-to-Ride and "Shown as a
       pair" on a single wheel.
     - Wheels only on a set always shows the finish photo.
     A rim still waiting on a two-tone or splatter color asks for no finish photo, the
     same check the stage makes. Each product is asked for once a visit, and a picture
     that fails is never asked for again: the card reads as text only straight away. The
     package name is the label, so the pictures say nothing to a screen reader. */
  var PRODUCT_PICS = {}; /* handle to { variants: { id: url }, images: [url] }, or null */
  var PRODUCT_PICS_WAIT = {};
  var PIC_FAILED = {}; /* picture URLs that failed to load this visit */

  function shopifyImageWidth(src, w) {
    var url = String(src || '');
    if (!url) return '';
    if (url.indexOf('//') === 0) url = 'https:' + url;
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function imageSrc(img) {
    return img && typeof img === 'object' ? img.src || '' : img || '';
  }

  function loadProductPics(handle) {
    if (!handle || PRODUCT_PICS.hasOwnProperty(handle) || PRODUCT_PICS_WAIT[handle]) return;
    PRODUCT_PICS_WAIT[handle] = true;
    fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (prod) {
        if (!prod) {
          PRODUCT_PICS[handle] = null;
          return;
        }
        var variants = {};
        (prod.variants || []).forEach(function (v) {
          var src = imageSrc(v.featured_image);
          if (src) variants[String(v.id)] = shopifyImageWidth(src, 400);
        });
        var images = (prod.images || []).map(imageSrc).filter(Boolean);
        PRODUCT_PICS[handle] = { variants: variants, images: images };
      })
      .catch(function () {
        PRODUCT_PICS[handle] = null;
      })
      .then(function () {
        delete PRODUCT_PICS_WAIT[handle];
        if (S.step !== 4) return;
        elPanel.querySelectorAll('[data-rm-pic-wait]').forEach(function (box) {
          if (box.getAttribute('data-rm-pic-wait') === handle) repaintPic(box);
        });
      });
  }

  /* The hub color a file name carries, as a whole word between -, _, a space or the
     extension, the longest color name winning. '' when it names none. */
  function fileColor(url) {
    var name = String(url).split('?')[0].split('/').pop();
    try {
      name = decodeURIComponent(name);
    } catch (e) {
      /* keep it as it is */
    }
    name = name.toLowerCase();
    var best = '';
    COLORS.forEach(function (c) {
      var word = String(c.id)
        .toLowerCase()
        .replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
        .replace(/\s+/g, '[-_ ]');
      if (new RegExp('(^|[-_ ])' + word + '(?=$|[-_ .])').test(name) && c.id.length > best.length) best = c.id;
    });
    return best;
  }

  /* The product photo for the hub color, as { url, from }, or null to fall back. */
  function productPic(handle, row) {
    var pics = PRODUCT_PICS[handle];
    if (!pics) return null;
    var c = colorOf(S.color);
    var vid = !(c && c.builderOnly) && row && row.variants ? row.variants[S.color] : null;
    var v = vid ? pics.variants[String(vid)] : '';
    if (v && !PIC_FAILED[v]) return { url: v, from: 'variant' };
    for (var i = 0; i < pics.images.length; i++) {
      if (fileColor(pics.images[i]) !== S.color) continue;
      var u = shopifyImageWidth(pics.images[i], 400);
      if (!PIC_FAILED[u]) return { url: u, from: 'filename' };
    }
    return null;
  }

  /* The finish photo for the colors in hand, or '' when there is none to ask for. */
  function finishPicUrl() {
    if (rimUnfinished() || finishPhotoMissed(S.rim, S.spoke, S.color)) return '';
    var url = finishPhotoUrl(S.rim, S.spoke, S.color, 400);
    return url && !PIC_FAILED[url] ? url : '';
  }

  function picBox(kind, url, cap, from, waitHandle) {
    return (
      '<span class="rm-opt__pic' + (url && cap ? ' has-cap' : '') + '" aria-hidden="true" data-rm-pic="' + kind + '"' +
      (from ? ' data-rm-pic-from="' + from + '"' : '') +
      (waitHandle ? ' data-rm-pic-wait="' + esc(waitHandle) + '"' : '') +
      '>' +
      (url ? '<img src="' + esc(url) + '" width="400" height="400" alt="" decoding="async">' : '') +
      (url && cap ? '<span class="rm-opt__pic-cap">' + esc(cap) + '</span>' : '') +
      '</span>'
    );
  }

  /* kind is 'wheels' or 'rtr'. Returns the picture box, a reserved empty box while the
     product is asked for, or '' for a text-only card. */
  function tirePicHtml(kind) {
    var opt = sizeOption(S.sizeKey);
    var single = !setupOf(S.setup).pair;
    var row = null;
    var cap = '';
    if (kind === 'rtr') {
      row = rtrRowOf(opt);
      cap = 'Shown without tires';
    } else if (single) {
      row = opt && opt.wheels;
      cap = 'Shown as a pair';
    }
    var handle = (row && row.handle) || '';
    if (handle && S.rim === 'Black' && S.spoke === 'Black') {
      if (!PRODUCT_PICS.hasOwnProperty(handle)) {
        loadProductPics(handle);
        return picBox(kind, '', '', '', handle);
      }
      var p = productPic(handle, row);
      if (p) return picBox(kind, p.url, '', p.from);
    }
    var f = finishPicUrl();
    return f ? picBox(kind, f, row ? cap : '', 'finish') : '';
  }

  /* Tire photos beside the Ready-to-Ride picture (Peter, 2026-10-17). The pairing in
     the fitment data ("Bridgestone Battlecross X30 | 70/100-19 | 90/100-16") is matched
     by name to the store's tire products, and each tire size to the variant of that size,
     so the photo is the tire that ships. A pairing named "A / B" is A on the front and B
     on the rear. A tire with no product on the store shows no photo, and when the front
     and the rear are the same photo it shows once. The pairing text is the label, so the photos say
     nothing to a screen reader. The name to product map lives in snippets/rm-tire-info.liquid,
     shared with the product pages. */
  var TIRE_DATA = CONFIG.tire_info || {};
  var TIRE_PRODUCT = TIRE_DATA.products || {};
  var TIRE_PICS = {}; /* handle to { sizes: [[variant title, url]], url }, or null */
  var TIRE_PICS_WAIT = {};

  function loadTirePics(handle) {
    if (!handle || TIRE_PICS.hasOwnProperty(handle) || TIRE_PICS_WAIT[handle]) return;
    TIRE_PICS_WAIT[handle] = true;
    fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .catch(function () {
        return null;
      })
      .then(function (prod) {
        delete TIRE_PICS_WAIT[handle];
        TIRE_PICS[handle] = prod
          ? {
              sizes: (prod.variants || []).map(function (v) {
                return [String(v.title || ''), imageSrc(v.featured_image)];
              }),
              url: imageSrc(prod.featured_image),
              images: (prod.images || []).map(imageSrc),
            }
          : null;
        if (S.step === 4) render();
      });
  }

  /* The pairing's two tires as [{ pos, handle, size }], front then rear. */
  function tireParts(row) {
    var p = String((row && row.rtr_tire) || '').split('|').map(function (x) {
      return x.trim();
    });
    if (!p[0] || !p[1] || !p[2]) return [];
    var names = p[0].split(' / ');
    var frontName = names[0].trim().toLowerCase();
    var rearName = (names[1] || names[0]).trim().toLowerCase();
    var f = TIRE_PRODUCT[frontName];
    var r = TIRE_PRODUCT[rearName];
    return [
      { pos: 'F', handle: f && f.front, size: p[1] },
      { pos: 'R', handle: r && (r.rear || r.front), size: p[2] },
    ];
  }

  /* "120/70-17", "120/70ZR17" and "120/70R17" are one tire size, so the fitment data
     and a variant title ("120/70ZR17 58W Front") match whichever way each writes it. */
  function tireSizeKey(t) {
    return String(t || '')
      .toUpperCase()
      .replace(/\s*(?:ZR|R|-|X)\s*(\d{2})(?=\b)/, ' $1')
      .trim();
  }

  /* The photo of that size's variant; failing that, a product photo named for the end
     ("...-rear-tire-..."), not one of both tires; failing that, the main photo. */
  function tirePicUrl(handle, size, pos) {
    var pics = TIRE_PICS[handle];
    if (!pics) return '';
    var want = tireSizeKey(size);
    for (var i = 0; i < pics.sizes.length; i++) {
      var t = tireSizeKey(pics.sizes[i][0]);
      if ((t === want || t.indexOf(want + ' ') === 0) && pics.sizes[i][1]) return pics.sizes[i][1];
    }
    var end = pos === 'R' ? 'rear' : 'front';
    var named = (pics.images || []).filter(function (u) {
      var f = String(u).split('?')[0].split('/').pop().toLowerCase();
      return f.indexOf(end) > -1 && f.indexOf('front-and-rear') === -1;
    });
    return named[0] || pics.url || '';
  }

  /* A tire choice's two tires, by its name where the map knows it (MOTOZ is two
     products), else its own tire product for both ends. */
  function choiceParts(o) {
    var m = TIRE_PRODUCT[String(o.label || '').toLowerCase()];
    return [
      { pos: 'F', handle: (m && m.front) || o.tire_handle, size: o.front },
      { pos: 'R', handle: (m && (m.rear || m.front)) || o.tire_handle, size: o.rear },
    ];
  }

  /* The photo column for a Ready-to-Ride row's standard tires: a reserved column while a
     tire product is asked for, the photos once known, or '' when the pairing has none.
     The package card always shows the standard tires, in words and photos; a tire
     choice is shown, and picked, in the list under it. */
  function tirePicsHtml(row) {
    return partsPicsHtml(tireParts(row));
  }

  function partsPicsHtml(allParts) {
    var parts = allParts.filter(function (t) {
      return t.handle;
    });
    if (!parts.length) return '';
    var waiting = false;
    parts.forEach(function (t) {
      if (!TIRE_PICS.hasOwnProperty(t.handle)) {
        loadTirePics(t.handle);
        waiting = true;
      }
    });
    var shots = [];
    if (!waiting) {
      parts.forEach(function (t) {
        var url = tirePicUrl(t.handle, t.size, t.pos);
        if (!url || PIC_FAILED[shopifyImageWidth(url, 160)]) return;
        if (shots.some(function (x) {
          return x.url === url;
        }))
          return;
        shots.push({ pos: t.pos, url: url });
      });
      if (!shots.length) return '';
      /* One photo for both ends names neither. */
      if (shots.length === 1 && parts.length === 2) shots[0].pos = '';
    }
    return (
      '<span class="rm-opt__tires" aria-hidden="true" data-rm-tirepics>' +
      shots
        .map(function (x) {
          return (
            '<span class="rm-opt__tire"><img src="' + esc(shopifyImageWidth(x.url, 160)) + '" width="160" height="160" alt="" decoding="async">' +
            (x.pos ? '<b>' + x.pos + '</b>' : '') +
            '</span>'
          );
        })
        .join('') +
      '</span>'
    );
  }

  function bindTireShots(scope) {
    scope.querySelectorAll('.rm-opt__tire img').forEach(function (img) {
      if (img.__rmBound) return;
      img.__rmBound = true;
      img.addEventListener('error', function () {
        PIC_FAILED[img.getAttribute('src') || ''] = true;
        if (S.step === 4) render();
      });
    });
  }

  /* ---------- Ready-to-Ride tire choice (Peter, 2026-10-20) ----------
     The same choices the Ready-to-Ride product pages offer. assets/rm-rtr-tires.json
     (the redesign session's file) lists, per bike and size, the standard pairing and
     the options, and only options the hidden "Ready-to-Ride tire choice" product sells
     right now are shown: /products/rtr-tire-choice.js is read once and each option is
     matched to its variant by SKU, so the id and the price always come from the store.
     A choice goes in the cart as its own line beside the wheelset, carrying For, Tires
     and the build id, the way the product pages and the cart expect. Without the file
     or the product, step 4 is exactly as it was: the standard tires only. */
  var TIRE_CHOICE = { data: null, variants: null, loading: false };

  function loadTireChoices() {
    if (TIRE_CHOICE.loading || TIRE_CHOICE.data !== null || !CONFIG.rtr_tires_asset) return;
    TIRE_CHOICE.loading = true;
    fetch(CONFIG.rtr_tires_asset)
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (d) {
        if (!d || !d.bikes || !d.rows) throw new Error('no tire data');
        return fetch('/products/' + encodeURIComponent(d.product_handle || 'rtr-tire-choice') + '.js', {
          headers: { Accept: 'application/json' },
        })
          .then(function (r) {
            return r.ok ? r.json() : null;
          })
          .then(function (prod) {
            var map = {};
            ((prod && prod.variants) || []).forEach(function (v) {
              if (v && v.sku) map[v.sku] = { id: v.id, cents: Number(v.price), available: !!v.available };
            });
            TIRE_CHOICE.variants = map;
            TIRE_CHOICE.data = d;
          });
      })
      .catch(function () {
        TIRE_CHOICE.data = false;
      })
      .then(function () {
        TIRE_CHOICE.loading = false;
        if (S.step >= 4) render();
      });
  }

  function tireChoiceRow() {
    var d = TIRE_CHOICE.data;
    if (!d || !TIRE_CHOICE.variants) return null;
    var rtr = rtrRowOf(sizeOption(S.sizeKey));
    if (!rtr) return null;
    var sizes = d.bikes[fitHandle(bikeOf(S.bike))];
    var rowId = sizes ? sizes[rowLabel(rtr)] : null;
    var row = rowId ? d.rows[rowId] : null;
    return row ? { id: rowId, row: row } : null;
  }

  function tireChoices() {
    var hit = tireChoiceRow();
    if (!hit) return [];
    var out = [];
    hit.row.options.forEach(function (o) {
      if (!o.enabled) return;
      var v = TIRE_CHOICE.variants[o.sku];
      if (!v || !v.available) return;
      out.push({ opt: o, id: v.id, cents: v.cents });
    });
    return out;
  }

  /* The chosen option, or null for the standard tires, wheels only, or a choice the size
     in hand does not offer. */
  function chosenTireChoice() {
    if (S.tires !== 'rtr' || !S.tireSku) return null;
    var list = tireChoices();
    for (var i = 0; i < list.length; i++) if (list[i].opt.sku === S.tireSku) return list[i];
    return null;
  }

  function tireNoteKey(sku) {
    return 'tire|' + S.bike + '|' + sku;
  }

  /* A close-fit choice is confirmed like a size note before the step is done. */
  function tireChoiceConfirmed() {
    var c = chosenTireChoice();
    return !c || !c.opt.close_fit || !c.opt.fit_note || !!S.confirmed[tireNoteKey(c.opt.sku)];
  }

  /* The Tires line property: the chosen pairing, or the standard one. */
  function tiresText() {
    var c = chosenTireChoice();
    if (c) return c.opt.tires_text;
    var hit = tireChoiceRow();
    if (hit && hit.row.standard && hit.row.standard.tires_text) return hit.row.standard.tires_text;
    var row = currentRow();
    var p = String((row && row.rtr_tire) || '').split('|').map(function (x) {
      return x.trim();
    });
    if (!p[0] || !p[1] || !p[2]) return '';
    var names = p[0].split(' / ');
    return names.length > 1 ? names[0] + ' ' + p[1] + ' / ' + names[1] + ' ' + p[2] : p[0] + ' ' + p[1] + ' / ' + p[2];
  }

  /* The ground each tire is made for, one line on each tire choice card, and a short
     description in its Info popup (Peter, 2026-10-20). The text lives in
     snippets/rm-tire-info.liquid, shared with the product pages. Keyed by the lowercase name
     in rm-rtr-tires.json. A tire not listed shows no line, and a pair ("X30 / Kenda
     Washougal III") takes each tire's description in turn. */
  var TIRE_USE = TIRE_DATA.use || {};
  var TIRE_INFO = TIRE_DATA.info || {};
  function tireUse(name) {
    return TIRE_USE[String(name || '').toLowerCase().trim()] || '';
  }
  /* [{ name, text }] for the popup: the whole name first, else each tire of a pair. */
  function tireInfo(name) {
    var key = String(name || '').toLowerCase().trim();
    if (TIRE_INFO[key]) return [{ name: name, text: TIRE_INFO[key] }];
    return String(name || '')
      .split(' / ')
      .map(function (n) {
        return { name: n.trim(), text: TIRE_INFO[n.trim().toLowerCase()] || '' };
      })
      .filter(function (x) {
        return x.text;
      });
  }

  /* "Most popular" (Peter, 2026-10-20). Which sizes and tires carry it, and the sales
     behind it, live in snippets/rm-popular.liquid, shared with the product pages. */
  var POPULAR = CONFIG.popular || {};
  function popKey(t) {
    return String(t || '').toLowerCase().replace(/["\s]/g, '');
  }
  function popularSize(label) {
    return (POPULAR.sizes || []).some(function (p) {
      return p.setup === S.setup && popKey(p.size) === popKey(label) && (!p.bike || String(S.bike || '').indexOf(p.bike) > -1);
    });
  }
  function popularStdTire(rowId) {
    return (POPULAR.standard_tire_rows || []).indexOf(rowId) > -1;
  }
  var POP_BADGE =
    '<span class="rm-pop"><svg viewBox="0 0 16 16" width="13" height="13" aria-hidden="true" focusable="false">' +
    '<path fill="currentColor" d="M8 1.1l2.1 4.4 4.8.6-3.5 3.3.9 4.8L8 11.9l-4.3 2.3.9-4.8L1.1 6.1l4.8-.6z"/></svg>Most popular</span>';

  function tireChoiceHtml() {
    if (S.tires !== 'rtr') return '';
    var hit = tireChoiceRow();
    var list = tireChoices();
    if (!hit || !list.length) return '';
    var std = hit.row.standard;
    var opt = function (value, checked, name, sizes, metas, priceText, parts, popular) {
      var bare = name.replace(/ \(standard\)$/, '');
      var use = tireUse(bare);
      var info = tireInfo(bare).length
        ? '<button type="button" class="rm-tireinfo" data-tireinfo="' + esc(value) + '" aria-haspopup="dialog">' +
          'Info<span class="visually-hidden"> about ' + esc(bare) + '</span></button>'
        : '';
      var pics = partsPicsHtml(parts);
      return optCard({
        name: 'rm-tirechoice',
        value: value,
        checked: checked,
        cls: 'rm-tirechoice' + (pics ? ' rm-opt--media rm-opt--pic rm-opt--tires rm-opt--tiresonly' : ''),
        html:
          pics +
          '<span class="rm-opt__body">' +
          (popular ? POP_BADGE : '') +
          '<b>' + esc(name) + '</b>' +
          (use ? '<small class="rm-tirechoice__use">' + esc(use) + '</small>' : '') +
          '<small>' + esc(sizes) + '</small>' +
          metas
            .filter(Boolean)
            .map(function (m) {
              return '<small class="rm-tirechoice__meta">' + esc(m) + '</small>';
            })
            .join('') +
          '<span class="rm-opt__price">' + esc(priceText) + '</span>' + info + '</span>',
      });
    };
    var chosen = chosenTireChoice();
    var html = opt('', !chosen, std.name + ' (standard)', std.front + ' front / ' + std.rear + ' rear', [], 'Included', tireParts(currentRow() || rtrRowOf(sizeOption(S.sizeKey))), popularStdTire(hit.id));
    list.forEach(function (t) {
      var o = t.opt;
      html += opt(o.sku, !!chosen && chosen.opt.sku === o.sku, o.label, o.front + ' front / ' + o.rear + ' rear', [o.availability, o.fit_note],
        t.cents > 0 ? '+' + money(t.cents / 100) : 'No extra charge', choiceParts(o));
    });
    var confirm = '';
    if (chosen && chosen.opt.close_fit && chosen.opt.fit_note) {
      var k = tireNoteKey(chosen.opt.sku);
      confirm =
        '<div class="rm-confirm rm-confirm--inline" data-rm-confirm>' +
        '<h3 class="rm-bld__legend">Confirm before you continue</h3>' +
        '<label><input type="checkbox" data-note="' + esc(k) + '"' + (S.confirmed[k] ? ' checked' : '') + '><span>' +
        esc(chosen.opt.fit_note) + '</span></label></div>';
    }
    return (
      '<fieldset class="rm-bld__fieldset rm-bld__tirechoice" style="margin-top:18px"><legend class="rm-bld__legend">Tire choice</legend>' +
      (S.editing ? '<p class="rm-note rm-note--info">' + esc(EDIT_NOTE) + '</p>' : '') +
      '<div class="rm-bld__sub">Ready-to-Ride comes with the standard tires. These fit the same rims and are mounted the same way.</div>' +
      '<div class="rm-bld__tirechoices">' + html + '</div>' +
      confirm +
      '</fieldset>'
    );
  }

  /* The Info popup on a tire choice: the tire's photos large, the ground it suits, and a
     short description, with a button that picks it (Peter, 2026-10-20). The dialog lives
     inside the builder so it takes the builder's type and colors. */
  var tireDlg = null;
  function tireInfoFor(value) {
    var hit = tireChoiceRow();
    if (!hit) return null;
    if (!value) {
      var std = hit.row.standard;
      return { value: '', name: std.name, front: std.front, rear: std.rear, parts: tireParts(currentRow() || rtrRowOf(sizeOption(S.sizeKey))) };
    }
    var c = tireChoices().filter(function (t) {
      return t.opt.sku === value;
    })[0];
    return c ? { value: value, name: c.opt.label, front: c.opt.front, rear: c.opt.rear, parts: choiceParts(c.opt) } : null;
  }
  function openTireInfo(value) {
    var t = tireInfoFor(value);
    if (!t) return;
    if (!tireDlg) {
      tireDlg = document.createElement('dialog');
      tireDlg.className = 'rm-tdlg';
      tireDlg.setAttribute('aria-labelledby', 'rm-tdlg-title');
      root.appendChild(tireDlg);
      tireDlg.addEventListener('click', function (e) {
        /* A click on the backdrop lands on the dialog itself. */
        if (e.target === tireDlg || e.target.closest('[data-tdlg-close]')) return tireDlg.close();
        var pick = e.target.closest('[data-tdlg-pick]');
        if (!pick) return;
        var v = pick.getAttribute('data-tdlg-pick');
        tireDlg.close();
        var input = [].filter.call(elPanel.querySelectorAll('input[name="rm-tirechoice"]'), function (i) {
          return i.value === v;
        })[0];
        if (input && !input.checked) input.click();
      });
    }
    var shots = [];
    t.parts.forEach(function (p) {
      if (!p.handle) return;
      var url = tirePicUrl(p.handle, p.size, p.pos);
      if (!url) return;
      var same = shots.filter(function (x) {
        return x.url === url;
      })[0];
      /* One photo for both ends (a tire sold for either) names both sizes. */
      if (same) same.cap = 'Front ' + t.front + ' / Rear ' + t.rear;
      else shots.push({ url: url, cap: (p.pos === 'R' ? 'Rear ' : 'Front ') + p.size });
    });
    var bare = t.name.replace(/ \(standard\)$/, '');
    var use = tireUse(bare);
    var info = tireInfo(bare);
    var chosen = chosenTireChoice();
    var isChosen = chosen ? chosen.opt.sku === t.value : t.value === '';
    tireDlg.innerHTML =
      '<div class="rm-tdlg__head"><h3 id="rm-tdlg-title">' + esc(bare) + '</h3>' +
      '<button type="button" class="rm-tdlg__x" data-tdlg-close aria-label="Close">' +
      '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/></svg></button></div>' +
      (use ? '<p class="rm-tdlg__use">' + esc(use) + '</p>' : '') +
      (shots.length
        ? '<div class="rm-tdlg__pics">' +
          shots
            .map(function (x) {
              return (
                '<figure><img src="' + esc(shopifyImageWidth(x.url, 600)) + '" alt="' + esc(bare + ' tire') + '" width="300" height="300" loading="lazy">' +
                '<figcaption>' + esc(x.cap) + '</figcaption></figure>'
              );
            })
            .join('') +
          '</div>'
        : '') +
      (shots.length ? '' : '<p class="rm-tdlg__sizes">' + esc(t.front + ' front / ' + t.rear + ' rear') + '</p>') +
      info
        .map(function (x) {
          return '<p class="rm-tdlg__text">' + (info.length > 1 ? '<b>' + esc(x.name) + '.</b> ' : '') + esc(x.text) + '</p>';
        })
        .join('') +
      '<div class="rm-tdlg__foot">' +
      (isChosen
        ? '<button type="button" class="rm-btn rm-btn--primary rm-btn--wide" data-tdlg-close>Close</button>'
        : '<button type="button" class="rm-btn rm-btn--primary rm-btn--wide" data-tdlg-pick="' + esc(t.value) + '">Choose these tires</button>') +
      '</div>';
    if (typeof tireDlg.showModal === 'function') tireDlg.showModal();
    else tireDlg.setAttribute('open', '');
  }
  /* The Info button sits inside the card's label, so its click must not pick the card. */
  elPanel.addEventListener('click', function (e) {
    var b = e.target.closest('[data-tireinfo]');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    openTireInfo(b.getAttribute('data-tireinfo'));
  });

  /* The card loses its picture column and reads as it did before pictures. */
  function dropPic(box) {
    var card = box.closest('.rm-opt');
    if (card) card.classList.remove('rm-opt--media', 'rm-opt--pic');
    if (box.parentNode) box.parentNode.removeChild(box);
  }

  /* Draws a box again from the state and the caches: after a product answers, or after
     its picture fails and the next choice down is taken. */
  function repaintPic(box) {
    var html = tirePicHtml(box.getAttribute('data-rm-pic'));
    if (!html) {
      dropPic(box);
      return;
    }
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var fresh = tmp.firstChild;
    box.parentNode.replaceChild(fresh, box);
    bindTirePics(fresh.parentNode);
  }

  /* An img error does not bubble, so each picture carries its own listener. A finish
     photo that fails is also remembered as missing, the way the preview remembers it. */
  function bindTirePics(scope) {
    scope.querySelectorAll('.rm-opt__pic img').forEach(function (img) {
      if (img.__rmBound) return;
      img.__rmBound = true;
      img.addEventListener('error', function () {
        var src = img.getAttribute('src') || '';
        PIC_FAILED[src] = true;
        if (src === finishPhotoUrl(S.rim, S.spoke, S.color, 400)) FINISH_PHOTO_MISS[finishPhotoKey(S.rim, S.spoke, S.color)] = true;
        var box = img.closest('.rm-opt__pic');
        if (box && box.parentNode) repaintPic(box);
      });
    });
  }

  function panelTires() {
    var opt = sizeOption(S.sizeKey);
    var single = !setupOf(S.setup).pair;
    var hasWheels = !!(opt && opt.wheels);
    var rtrRow = rtrRowOf(opt);
    var wheelsPrice = hasWheels ? basePrice(opt.wheels) : NaN;
    var rtrPrice = rtrRow ? basePrice(rtrRow) : NaN;
    var cards = '';
    if (hasWheels) {
      var wheelsPic = tirePicHtml('wheels');
      cards += optCard({
        name: 'rm-tires',
        value: 'none',
        checked: S.tires !== 'rtr',
        cls: wheelsPic ? 'rm-opt--media rm-opt--pic' : '',
        html:
          wheelsPic +
          '<span class="rm-opt__body"><b>Wheels only</b><small>Rim strips included. Tires and tubes not included. ' +
          esc(LEAD.wheels) +
          '.</small>' +
          (isNaN(wheelsPrice) ? '' : '<span class="rm-opt__price">From ' + esc(money(wheelsPrice)) + '</span>') +
          '</span>',
      });
    }
    if (rtrRow) {
      /* With MX or EX still to pick, the lowest model's price stands as a "From". */
      var from = rtrModelOpen(rtrFamily());
      if (from) rtrPrice = rtrFromPrice(opt);
      var diff = wheelsPrice > 0 && rtrPrice > 0 ? rtrPrice - wheelsPrice : NaN;
      var rtrPic = tirePicHtml('rtr');
      var tirePics = tirePicsHtml(rtrRow);
      cards += optCard({
        name: 'rm-tires',
        value: 'rtr',
        checked: S.tires === 'rtr',
        cls: (rtrPic || tirePics ? 'rm-opt--media rm-opt--pic' : '') + (tirePics ? ' rm-opt--tires' : '') + (tirePics && !rtrPic ? ' rm-opt--tiresonly' : ''),
        html:
          rtrPic +
          tirePics +
          '<span class="rm-opt__body"><b>Ready-to-Ride</b><small>' + esc(rtrMountText()) + '. ' +
          esc(LEAD.rtr) +
          '.</small>' +
          '<span class="rm-opt__price">' + (rtrRow.rtr_tire ? tireHtml(rtrRow.rtr_tire) : esc(TIRE_TBC)) + '</span>' +
          (diff > 0
            ? '<span class="rm-opt__price">' + (from ? 'From ' : '') + '+' + esc(money(diff)) + ' over wheels only</span>'
            : isNaN(rtrPrice)
              ? ''
              : '<span class="rm-opt__price">From ' + esc(money(rtrPrice)) + '</span>') +
          '</span>',
      });
    }
    var note = '';
    if (opt && !(hasWheels && rtrRow)) {
      note = single
        ? 'Ready-to-Ride is offered on full off-road and supermoto sets only, so a single wheel comes as wheels only.'
        : rtrRow
          ? 'This size comes Ready-to-Ride only.'
          : 'Ready-to-Ride isn\'t offered in this size.';
    }
    var model = S.tires === 'rtr' && rtrRow && variantBikes(S.setup).length <= 1 ? modelPick(rtrFamily()) : '';
    /* The package moved with a new size or a link since step 4 was last passed. */
    var moved = S.tiresMoved
      ? 'Your tire package is now ' +
        (S.tires === 'rtr' ? 'Ready-to-Ride' : 'Wheels only') +
        '. Check it before you continue.'
      : '';
    return (
      '<h2>Wheels only, or Ready-to-Ride?</h2>' +
      '<p class="rm-bld__help">Ready-to-Ride (RTR) includes pre-selected tire packages designed to work with your bike. All RTR sets include rim strips, tubes, and professional tire mounting.</p>' +
      (moved ? '<p class="rm-note rm-note--warn" data-rm-tiremoved>' + esc(moved) + '</p>' : '') +
      (note ? '<p class="rm-note rm-note--info" data-rm-tirenote>' + esc(note) + '</p>' : '') +
      (cards
        ? '<fieldset class="rm-bld__fieldset"><legend class="rm-bld__legend">Tires</legend>' +
          '<div class="rm-bld__tiremode">' +
          cards +
          '</div></fieldset>'
        : '<p class="rm-note rm-note--info">Pick a size first.</p>') +
      (model ? '<div style="margin-top:18px">' + model + '</div>' : '') +
      tireChoiceHtml()
    );
  }

  function panelFinish() {
    /* On a phone this step is the configurator: a pinned stage and three tabs. The
       data hooks name each two-tone and splatter picker on every screen size, so a
       greyed Continue can point at the one still waiting. They are attributes only. */
    var cfg = configMode();
    var pick = function (name) {
      return ' data-rm-pick="' + name + '"';
    };
    /* The paid hub colors are named from the data, so the copy moves with COLORS. */
    var hubSub = 'Hubs and spoke nipples, anodized, always in the same color.';
    /* One sentence per extra amount, cheapest first: "Magnesium adds $15 per hub. Burnt
       Blue and Rainbow add $20 per hub." A color priced into its own variants
       (Magnesium) is named only when the size row in hand charges for it, at what it
       adds there per hub, so the sentence never disagrees with its swatch. */
    var hubExtras = {};
    var hubAmounts = [];
    for (var hx = 0; hx < COLORS.length; hx++) {
      var amt = COLORS[hx].hubUp;
      if (!amt && COLORS[hx].textUp) {
        var rowAdd = colorAddOn(currentRow(), COLORS[hx].id);
        amt = rowAdd > 0 ? rowAdd / hubCount() : 0;
      }
      if (!amt) continue;
      if (!hubExtras[amt]) {
        hubExtras[amt] = [];
        hubAmounts.push(amt);
      }
      hubExtras[amt].push(COLORS[hx].id);
    }
    hubAmounts.sort(function (a, b) {
      return a - b;
    });
    for (var ha = 0; ha < hubAmounts.length; ha++) {
      var names = hubExtras[hubAmounts[ha]];
      var list = names.length > 2 ? names.slice(0, -1).join(', ') + ' and ' + names[names.length - 1] : names.join(' and ');
      hubSub += ' ' + list + (names.length > 1 ? ' add ' : ' adds ') + money(hubAmounts[ha]) + ' per hub.';
    }
    var colorSel = colorOf(S.color);
    var colors =
      '<fieldset class="rm-bld__fieldset"><legend class="rm-bld__legend">Hub color</legend>' +
      '<div class="rm-bld__sub">' +
      esc(hubSub) +
      '</div>' +
      '<div class="rm-pal">' +
      COLORS.map(function (c) {
        var add = addOnText(colorAddOn(currentRow(), c.id));
        return optCard({
          name: 'rm-color',
          value: c.id,
          checked: S.color === c.id,
          html:
            '<i style="background:' +
            colorSwatch(c.id) +
            '"></i>' +
            esc(c.id) +
            (add ? '<small>' + esc(add) + '</small>' : ''),
        });
      }).join('') +
      '</div>' +
      (colorSel && colorSel.hubUp && !hubCartable(colorSel.id)
        ? '<p class="rm-note rm-note--warn" style="margin-top:10px">' +
          esc(colorSel.id) +
          ' hubs are quoted rather than bought online today. Keep building, send the request at the end, and we reply with the confirmed price and lead time. No payment until you say yes.</p>'
        : '') +
      '</fieldset>';

    var rimSel = rimOf(S.rim);
    var tiers = rimTiers();
    var tierHead = function (up) {
      if (!up) return 'Included';
      return 'Add ' + money(up) + ' ' + rimUnit();
    };
    var swatch = function (r) {
      if (r.image) {
        return '<i style="background-image:url(' + esc(r.image) + ');background-size:cover"></i>';
      }
      return '<i style="background:' + r.css + '"></i>';
    };
    /* The two color pickers only exist while the two-tone rim is the one selected, and
       they sit inside the rim fieldset because they are part of that one choice. */
    var toneCards = function (group, picked, list) {
      return (list || twoToneRims())
        .map(function (r) {
          return optCard({ name: group, value: r.id, checked: picked === r.id, html: swatch(r) + esc(r.id) });
        })
        .join('');
    };
    var toneBlock = isTwoTone()
      ? '<div class="rm-bld__tone">' +
        '<h3 class="rm-bld__tonetitle">Pick your two colors</h3>' +
        '<div class="rm-bld__sub">Two colors, one fade across the rim. The photo shows the fade the way we make it, so the order you pick them in does not change the wheel. A few pairs that sit too close to read as two colors are left off the second list.</div>' +
        '<h4 class="rm-bld__tierhead">Color one</h4>' +
        '<div class="rm-pal rm-pal--five"' + pick('tone-a') + '>' +
        toneCards('rm-tone-a', S.toneA) +
        '</div>' +
        '<h4 class="rm-bld__tierhead" style="margin-top:12px">Color two</h4>' +
        '<div class="rm-pal rm-pal--five"' + pick('tone-b') + '>' +
        toneCards('rm-tone-b', S.toneB, twoTonePartners(S.toneA)) +
        '</div>' +
        (!twoTonePairAllowed(S.toneA, S.toneB)
          ? '<p class="rm-note rm-note--warn" style="margin-top:10px">Pick a second color</p>'
          : '') +
        '</div>'
      : '';

    /* The splatter pickers work the same way and live in the same place: a base the rim
       is coated in, then the color thrown over it. The second list is read off the first,
       so a base never offers a splatter that would vanish into it. */
    var splatterCards = function (group, list, picked) {
      return list
        .map(function (r) {
          return optCard({ name: group, value: r.id, checked: picked === r.id, html: swatch(r) + esc(r.id) });
        })
        .join('');
    };
    var splatterBlock = isSplatter()
      ? '<div class="rm-bld__tone">' +
        '<h3 class="rm-bld__tonetitle">Pick your base and your splatter</h3>' +
        '<div class="rm-bld__sub">The base is the color the rim is coated in. The splatter is thrown over it by hand, so no two sets land the same.</div>' +
        '<h4 class="rm-bld__tierhead">Base color</h4>' +
        '<div class="rm-pal rm-pal--five"' + pick('splatter-base') + '>' +
        splatterCards('rm-splatter-base', splatterBases(), S.splatterBase) +
        '</div>' +
        '<h4 class="rm-bld__tierhead" style="margin-top:12px">Splatter color</h4>' +
        (S.splatterBase
          ? '<div class="rm-pal rm-pal--five"' + pick('splatter-color') + '>' +
            splatterCards('rm-splatter-color', splatterColors(S.splatterBase), S.splatterColor) +
            '</div>'
          : '<p class="rm-note rm-note--info">Pick a base color first and the splatter colors that work over it appear here.</p>') +
        (S.splatterBase && !S.splatterColor
          ? '<p class="rm-note rm-note--warn" style="margin-top:10px">Pick a splatter color</p>'
          : '') +
        '</div>'
      : '';

    var rims =
      '<fieldset class="rm-bld__fieldset"><legend class="rm-bld__legend">Rim color</legend>' +
      '<div class="rm-bld__sub">' +
      (setupOf(S.setup).pair
        ? 'Both rims match. Black is included. The colored rims carry a per-set charge, shown on each group.'
        : 'Black is included. The colored rims carry a per-wheel charge, shown on each group.') +
      '</div>' +
      tiers
        .map(function (t) {
          return (
            '<div class="rm-bld__tier"><h3 class="rm-bld__tierhead">' +
            esc(tierHead(rimCharge({ up: t.up }))) +
            '</h3><div class="rm-pal rm-pal--five">' +
            t.items
              .map(function (r) {
                return optCard({
                  name: 'rm-rim',
                  value: r.id,
                  checked: S.rim === r.id,
                  html:
                    swatch(r) +
                    esc(r.id) +
                    '<small>' +
                    (r.up ? '+' + esc(money(rimCharge(r))) : 'incl.') +
                    '</small>',
                });
              })
              .join('') +
            '</div></div>'
          );
        })
        .join('') +
      toneBlock +
      splatterBlock +
      (rimSel.lead
        ? '<p class="rm-note rm-note--info" style="margin-top:10px">' +
          esc(rimSel.id) +
          ' rims add about ' +
          esc(String(rimSel.lead)) +
          ' business days to the build.</p>'
        : '') +
      (rimGradient(rimSel) && !rimSel.image && !isTwoTone() && !isSplatter()
        ? '<p class="rm-note rm-note--info" style="margin-top:10px">' +
          esc(rimSel.id) +
          ' is a ' +
          esc((rimSel.note || '').toLowerCase()) +
          ' and cannot be shown accurately as a flat color. The swatch is a stand-in gradient, the preview photo shows the real finish.</p>'
        : '') +
      (rimSel.up && !rimCartable(rimSel)
        ? '<p class="rm-note rm-note--warn" style="margin-top:10px">Colored rims are quoted rather than bought online today. Keep building, send the request at the end, and we reply with the confirmed price and lead time. No payment until you say yes.</p>'
        : '') +
      '</fieldset>';

    /* The paid spoke line is written from the data, so the charge and the lead time in
       the copy cannot drift from the finish rows. */
    var spokePaid = null;
    for (var sp = 0; sp < SPOKES.length; sp++)
      if (SPOKES[sp].up) {
        spokePaid = SPOKES[sp];
        break;
      }
    var spokeSub = 'Black is standard. Stainless at no charge.';
    if (spokePaid) {
      spokeSub +=
        ' ' +
        spokePaid.id +
        ' powder coat adds ' +
        money(spokePaid.up) +
        ' per wheel' +
        (spokePaid.lead ? ' and about ' + spokePaid.lead + ' business days' : '') +
        '.';
    }
    var spokeSel = spokeOf(S.spoke);

    var spokes =
      '<fieldset class="rm-bld__fieldset"><legend class="rm-bld__legend">Spoke color</legend>' +
      '<div class="rm-bld__sub">' +
      esc(spokeSub) +
      '</div>' +
      '<div class="rm-pal">' +
      SPOKES.map(function (s) {
        return optCard({
          name: 'rm-spoke',
          value: s.id,
          checked: S.spoke === s.id,
          html:
            (s.image
              ? '<i style="background-image:url(' + esc(s.image) + ');background-size:cover"></i>'
              : '<i style="background:' + s.css + '"></i>') +
            esc(s.id) +
            '<small>' +
            /* The add-on for this setup, per wheel times wheels as price() counts it,
               in the same "incl." or "+$X" the rims and hubs use. */
            esc(addOnText((s.up || 0) * (setupOf(S.setup).pair ? 2 : 1))) +
            '</small>',
        });
      }).join('') +
      '</div>' +
      (spokeSel.up && !spokeCartable(spokeSel)
        ? '<p class="rm-note rm-note--warn" style="margin-top:10px">' +
          esc(spokeSel.id) +
          ' spokes are quoted rather than bought online today. Keep building, send the request at the end, and we reply with the confirmed price and lead time. No payment until you say yes.</p>'
        : '') +
      '</fieldset>';

    /* A compact copy of the finish photo, so the change is visible while picking rather
       than only over in the summary column. The panel re-renders on every radio change,
       so the src is rebuilt with it. */
    var livePhoto =
      cfg || rimUnfinished() || finishPhotoMissed(S.rim, S.spoke, S.color) ? '' : finishPhotoUrl(S.rim, S.spoke, S.color, 600);
    var live = livePhoto
      ? '<div class="rm-bld__livefinish"><img src="' +
        esc(livePhoto) +
        '" alt="' +
        esc(finishPhotoAlt()) +
        '" loading="lazy" data-rm-finish-photo></div>'
      : '';

    return (
      '<h2>Colors & finish</h2>' +
      '<p class="rm-bld__help">Choose separate colors for your hubs, rims and spokes. Special hub finishes, bi-color finishes and splattered finishes are available to choose from in the color tiles below. Please note hub colors and spoke nipple colors are paired together by default. If you prefer different color spoke nipples please contact us for special order.</p>' +
      /* The stage slot is swapped for the one persistent stage after the panel is
         written, so the photo node is never rebuilt by a render. */
      (cfg ? '<div class="rm-bld__cfg"><div data-rm-stage></div>' + finishTabs() + '</div>' : live) +
      '<div class="rm-bld__finish">' +
      finishPane('hubs', colors) +
      finishPane('rims', rims) +
      finishPane('spokes', spokes) +
      '</div>'
    );
  }

  /* ---------- the phone configurator ---------- */

  /* Peter's option C (2026-10-14): on a phone the colors step works like a car
     configurator. The wheel photo stays pinned at the top, Hubs, Rims and Spokes tabs
     sit under it, and every tap changes the photo in place. From 750px up step 5 is
     exactly what it was. */
  var PHONE_MQ = typeof window.matchMedia === 'function' ? window.matchMedia('(max-width: 749px)') : null;

  function configMode() {
    return S.step === 5 && !!PHONE_MQ && PHONE_MQ.matches;
  }

  var FIN_TABS = [
    { id: 'hubs', label: 'Hubs' },
    { id: 'rims', label: 'Rims' },
    { id: 'spokes', label: 'Spokes' },
  ];

  /* A two-tone pair or a splatter still missing a color is a rim that is not finished,
     which is what the marker on the Rims tab says. */
  function rimUnfinished() {
    return (isTwoTone() && !twoTonePairAllowed(S.toneA, S.toneB)) || (isSplatter() && !splatterChosen());
  }

  /* What an unpicked half of a dot is painted in: a plain light gray, so the dot never
     shows a color the rider did not choose. */
  var DOT_EMPTY = '#e4e5e7';

  function rimHex(name) {
    for (var i = 0; i < RIMS.length; i++) if (RIMS[i].id === name) return RIMS[i].dot || RIMS[i].css;
    return DOT_EMPTY;
  }

  /* The dot for the rim on the stage and its tab. The rim card paints a generic
     stand-in for two-tone and splatter, but here the dot shows the colors chosen: split
     between the pair, or the base speckled with the splatter. A half-picked rim shows
     the half it has and leaves the rest gray. */
  function rimDotCss() {
    if (isTwoTone()) {
      if (twoTonePairAllowed(S.toneA, S.toneB))
        return 'linear-gradient(135deg,' + twoToneHex(0) + ' 0 50%,' + twoToneHex(1) + ' 50% 100%)';
      return S.toneA ? 'linear-gradient(135deg,' + rimHex(S.toneA) + ' 0 50%,' + DOT_EMPTY + ' 50% 100%)' : DOT_EMPTY;
    }
    if (isSplatter()) {
      if (!splatterChosen()) return S.splatterBase ? rimHex(S.splatterBase) : DOT_EMPTY;
      var c = splatterHex('color');
      return (
        'radial-gradient(' + c + ' 24%,transparent 27%) 0 0/7px 7px,' +
        'radial-gradient(' + c + ' 18%,transparent 21%) 3.5px 3.5px/7px 7px,' +
        splatterHex('base')
      );
    }
    return rimOf(S.rim).css;
  }

  /* The rim written short enough for a chip or a tab: the pair, or the splatter on its
     base. A half-picked rim names what it has and what is still to pick. */
  function rimShort() {
    if (isTwoTone()) {
      if (twoTonePairAllowed(S.toneA, S.toneB)) return twoToneNames().join(' / ');
      return S.toneA ? S.toneA + ' / pick color two' : 'Two-tone, pick two colors';
    }
    if (isSplatter()) {
      if (splatterChosen()) return S.splatterColor + ' on ' + S.splatterBase;
      return S.splatterBase ? S.splatterBase + ', pick splatter color' : 'Splatter, pick base color';
    }
    return S.rim;
  }

  /* Each tab names its part and what is chosen for it, with a dot. A two-tone or
     splatter rim names its colors; a name too long for the tab is cut with an ellipsis
     on screen only, so the whole name is still the tab's accessible name. Only the open
     tab is in the tab order; the arrow keys move between them. */
  function finishTabs() {
    var vals = {
      hubs: { text: S.color, dot: colorSwatch(S.color) },
      rims: { text: rimShort(), dot: rimDotCss(), open: rimUnfinished() },
      spokes: { text: S.spoke, dot: spokeOf(S.spoke).css },
    };
    return (
      '<div class="rm-bld__tabs" role="tablist" aria-label="Finish parts">' +
      FIN_TABS.map(function (t) {
        var on = S.finTab === t.id;
        var v = vals[t.id];
        return (
          '<button type="button" role="tab" id="rm-tab-' + t.id + '" aria-controls="rm-pane-' + t.id + '"' +
          ' aria-selected="' + (on ? 'true' : 'false') + '" tabindex="' + (on ? '0' : '-1') + '" data-fintab="' + t.id + '">' +
          '<span class="rm-bld__tabname">' + t.label +
          (v.open ? '<em class="rm-bld__tabflag" aria-hidden="true"></em>' : '') +
          '<span class="rm-visually-hidden">:</span></span>' +
          '<span class="rm-bld__tabval" title="' + esc(v.text) + '"><i style="background:' + v.dot + '"></i>' +
          '<span class="rm-bld__tabtxt">' + esc(v.text) + '</span></span>' +
          (v.open ? '<span class="rm-visually-hidden">, not finished</span>' : '') +
          '</button>'
        );
      }).join('') +
      '</div>'
    );
  }

  /* The three fieldsets become the tab panels. Off a phone they are returned as they
     were, with no wrapper at all. */
  function finishPane(id, html) {
    if (!configMode()) return html;
    return (
      '<div class="rm-bld__pane" role="tabpanel" id="rm-pane-' + id + '" aria-labelledby="rm-tab-' + id + '"' +
      (S.finTab === id ? '' : ' hidden') + '>' + html + '</div>'
    );
  }

  /* The stage is built once and kept here, so the photo on screen survives every
     render. A new photo is fetched and decoded off-screen first and only then swapped
     in, so the old one stays up until the new one can paint. */
  var stage = null;
  var stageShown = ''; // the photo URL on screen, '' while the diagram stands in
  var stageWant = ''; // the photo URL the latest choice asks for
  var stageFade = 0;

  function stageNode() {
    if (stage) return stage;
    var el = document.createElement('div');
    el.className = 'rm-bld__stage';
    el.innerHTML =
      '<div class="rm-bld__stage-photo">' +
      '<img class="rm-bld__stage-img" alt="" hidden>' +
      '<img class="rm-bld__stage-ghost" alt="" aria-hidden="true" hidden>' +
      '<div class="rm-bld__stage-svg" hidden></div>' +
      '</div>' +
      '<div class="rm-chips rm-bld__stage-chips"></div>';
    stage = {
      el: el,
      img: el.querySelector('.rm-bld__stage-img'),
      ghost: el.querySelector('.rm-bld__stage-ghost'),
      svg: el.querySelector('.rm-bld__stage-svg'),
      chips: el.querySelector('.rm-bld__stage-chips'),
    };
    return stage;
  }

  /* The stage pins under the site header, wherever that pins at this width. */
  function setStageTop() {
    root.style.setProperty('--rm-cfg-top', Math.round(headerOffset()) + 'px');
  }

  function mountStage() {
    var slot = elPanel.querySelector('[data-rm-stage]');
    if (!slot) return;
    var st = stageNode();
    slot.parentNode.replaceChild(st.el, slot);
    setStageTop();
    updateStage();
  }

  /* The stage is about a third of the screen tall, so a 600px photo is soft on a 3x
     phone. The 900px file is asked for there, the 600px one everywhere else. */
  function stageWidth() {
    var css = Math.min(window.innerWidth || 390, (window.innerHeight || 844) * 0.36);
    return css * (window.devicePixelRatio || 1) > 640 ? 900 : 600;
  }

  /* The chips sit on one line so the stage never changes height. A name too long for
     the line is cut with an ellipsis on screen, and the whole of it stays in the text
     and the title. */
  /* The part name is its own span so a phone can hide it from view (Peter,
     2026-10-15); the tabs below already name each part, and screen readers still hear it. */
  function stageChip(bg, part, text, cls) {
    var full = part + ': ' + text;
    return (
      '<span class="rm-chip' + (cls ? ' ' + cls : '') + '" title="' + esc(full) + '"><i style="background:' + bg + '"></i>' +
      '<span class="rm-chip__txt"><span class="rm-chip__k">' + esc(part) + ': </span>' + esc(text) + '</span></span>'
    );
  }

  /* While the diagram is on the stage it is the placeholder, so it is kept in step
     with every tap until the photo is ready to take over. */
  function stageDiagramLive() {
    var st = stageNode();
    return !st.svg.hidden && !st.svg.classList.contains('is-out');
  }

  function updateStage() {
    var st = stageNode();
    st.chips.innerHTML =
      stageChip(colorSwatch(S.color), 'Hub', S.color) +
      stageChip(rimDotCss(), 'Rim', rimShort(), 'rm-chip--rim') +
      stageChip(spokeOf(S.spoke).css, 'Spokes', S.spoke);
    /* A two-tone pair or a splatter still missing a color has no photo to ask for, so
       the CDN is not asked and the diagram shows what has been picked so far. */
    var want =
      rimUnfinished() || finishPhotoMissed(S.rim, S.spoke, S.color) ? '' : finishPhotoUrl(S.rim, S.spoke, S.color, stageWidth());
    stageWant = want;
    if (!want) return stageDiagram();
    var alt = finishPhotoAlt();
    if (want === stageShown) {
      st.img.alt = alt;
      st.el.classList.remove('is-loading');
      return;
    }
    var probe = new Image();
    probe.src = want;
    /* A photo already in memory is complete the moment it is asked for, so it goes
       straight up with no diagram in between. */
    if (probe.complete && probe.naturalWidth) return stagePhoto(want, alt);
    st.el.classList.add('is-loading');
    if (stageDiagramLive()) {
      st.svg.innerHTML = svgWheel(S.rim, S.spoke, S.color, 'rmcv');
    } else if (!stageShown) {
      /* Nothing on the stage yet, so the diagram goes up in the same render and the
         photo fades in over it once it is ready. The stage is never an empty box. */
      stageDiagram(true);
    }
    var key = finishPhotoKey(S.rim, S.spoke, S.color);
    stageReady(probe).then(
      function () {
        if (stageWant === want) stagePhoto(want, alt);
      },
      function () {
        /* Remembered under the key finishPhotoMissed reads, so the diagram stands in
           for this combination from now on without asking the CDN again. */
        if (key) FINISH_PHOTO_MISS[key] = true;
        if (stageWant === want) stageDiagram();
      }
    );
  }

  /* Waits on a photo loading off-screen and resolves once it can paint. decode() can
     wait on a painted frame that a background tab never gets, so after the load it is
     given a moment rather than waited on forever. The load and error events always
     arrive after the task that set the src, so listening here is not too late. */
  function stageReady(probe) {
    return new Promise(function (res, rej) {
      probe.onload = function () {
        if (typeof probe.decode !== 'function') return res();
        var done = false;
        var finish = function () {
          if (done) return;
          done = true;
          res();
        };
        probe.decode().then(finish, finish);
        window.setTimeout(finish, 150);
      };
      probe.onerror = rej;
    });
  }

  /* The new photo goes into the one persistent img. Whatever was on the stage, the old
     photo laid over it on the ghost or the diagram, fades out above it: a short
     crossfade, skipped when motion is reduced. */
  function stagePhoto(url, alt) {
    var st = stageNode();
    var calm = prefersReducedMotion();
    var fromDiagram = stageDiagramLive();
    var old = fromDiagram ? '' : stageShown;
    var token = ++stageFade;
    stageShown = url;
    st.el.classList.remove('is-loading');
    st.ghost.classList.remove('is-out');
    if (old && !calm) {
      st.ghost.src = old;
      st.ghost.hidden = false;
    } else {
      st.ghost.hidden = true;
    }
    st.img.src = url;
    st.img.alt = alt;
    st.img.hidden = false;
    if (fromDiagram && !calm) {
      void st.svg.offsetWidth;
      st.svg.classList.add('is-out');
    } else {
      stageDiagramOff();
    }
    if (old && !calm) {
      void st.ghost.offsetWidth;
      st.ghost.classList.add('is-out');
    }
    window.setTimeout(function () {
      if (token !== stageFade) return;
      st.ghost.hidden = true;
      if (st.svg.classList.contains('is-out')) stageDiagramOff();
    }, 260);
  }

  function stageDiagramOff() {
    var st = stageNode();
    st.svg.hidden = true;
    st.svg.innerHTML = '';
    st.svg.classList.remove('is-out');
  }

  /* No photo for this combination, so the diagram stands in, inside the photo box only,
     which leaves the chips alone. As a placeholder it keeps the loading bar running. */
  function stageDiagram(placeholder) {
    var st = stageNode();
    stageShown = '';
    stageFade++;
    if (!placeholder) st.el.classList.remove('is-loading');
    st.svg.classList.remove('is-out');
    st.svg.innerHTML = svgWheel(S.rim, S.spoke, S.color, 'rmcv');
    st.svg.hidden = false;
    st.img.hidden = true;
    st.ghost.hidden = true;
  }

  /* A tab change scrolls only when the top of the new pane has gone up under the
     pinned stage, and then only far enough to bring it back out from under the tabs. */
  function paneIntoView() {
    var cfgEl = elPanel.querySelector('.rm-bld__cfg');
    var pane = elPanel.querySelector('.rm-bld__pane:not([hidden])');
    if (!cfgEl || !pane) return;
    /* Measured against where the tabs pin rather than where they are now: a shorter
       pane can shrink the page enough to unpin them. */
    var sc = pageScroller();
    var target = pane.getBoundingClientRect().top + sc.scrollTop - headerOffset() - cfgEl.offsetHeight;
    if (sc.scrollTop <= target + 1) return;
    sc.scrollTo({ top: Math.max(0, target), behavior: scrollBehavior() });
  }

  function pickFinTab(id) {
    if (!configMode()) return;
    if (id !== S.finTab) {
      S.finTab = id;
      render();
    }
    var tab = elPanel.querySelector('#rm-tab-' + id);
    if (tab) tab.focus({ preventScroll: true });
    paneIntoView();
  }

  /* The picker a greyed Continue points at, on any screen: the half of a two-tone
     pair or the splatter list still waiting for a color. */
  function openPicker() {
    var name = '';
    if (isTwoTone() && !twoTonePairAllowed(S.toneA, S.toneB)) name = twoToneEligible(S.toneA) ? 'tone-b' : 'tone-a';
    else if (isSplatter() && !splatterChosen()) name = S.splatterBase ? 'splatter-color' : 'splatter-base';
    return name ? elPanel.querySelector('[data-rm-pick="' + name + '"]') : null;
  }

  function panelReview() {
    var row = currentRow();
    var pr = price();
    var rim = rimOf(S.rim);
    var spoke = spokeOf(S.spoke);
    var rows = [
      ['Bike', bikeLabel(bikeOf(S.bike)) + (activeVariantBike() && variantBikes(famEffective()).length > 1 ? ' (' + activeVariantBike() + ')' : ''), 1],
      ['Riding style', setupOf(S.setup).title, 2],
      /* A fourth entry, where there is one, is the markup shown in place of the text. */
      ['Wheel size', row ? rowLabel(row) : 'Not chosen', 3, row ? rowLines(row) : ''],
      ['Wheelset package', S.tires === 'rtr' ? 'Ready-to-Ride, tires mounted' : 'Wheels only', 4],
    ];
    var tirePick = chosenTireChoice();
    if (row && S.tires === 'rtr') {
      rows.push(
        tirePick
          ? ['Tire pairing', tirePick.opt.tires_text, 4, esc(tirePick.opt.tires_text)]
          : row.rtr_tire
            ? ['Tire pairing', row.rtr_tire.split('|').join(' · '), 4, tireHtml(row.rtr_tire)]
            : ['Tire pairing', 'Confirmed with you before the build', 4]
      );
    }
    rows.push(
      ['Hub color', S.color + hubSuffix(), 5],
      ['Rim color', rimLabel() + (rim.up ? ' (+' + money(rimCharge(rim)) + ' ' + rimUnit() + ')' : ' (included)'), 5],
      ['Spoke color', S.spoke + spokeSuffix(spoke), 5]
    );

    var breakdown = '';
    if (pr.total != null) {
      breakdown =
        '<div class="rm-breakdown">' +
        '<div><span>' +
        esc(setupOf(S.setup).title) +
        (S.tires === 'rtr' ? ' Ready-to-Ride' : '') +
        ', ' +
        esc(S.color) +
        '</span><span>' +
        esc(money(pr.base)) +
        '</span></div>' +
        (pr.up
          ? '<div><span>' +
            esc(rimLabel()) +
            (setupOf(S.setup).pair ? ' rims, per set' : ' rim, per wheel') +
            '</span><span>' +
            esc(money(pr.up)) +
            '</span></div>'
          : '') +
        (pr.spokeUp
          ? '<div><span>' +
            esc(S.spoke) +
            ' spokes, per wheel' +
            (setupOf(S.setup).pair ? ' x2' : '') +
            '</span><span>' +
            esc(money(pr.spokeUp)) +
            '</span></div>'
          : '') +
        (pr.hubUp
          ? '<div><span>' +
            esc(S.color) +
            (hubCount() > 1 ? ' hubs, ' : ' hub, ') +
            esc(money(colorOf(S.color).hubUp)) +
            ' per hub × ' +
            hubCount() +
            '</span><span>' +
            esc(money(pr.hubUp)) +
            '</span></div>'
          : '') +
        (pr.tireUp
          ? '<div><span>Tire choice, ' + esc(tirePick ? tirePick.opt.label : '') + '</span><span>' + esc(money(pr.tireUp)) + '</span></div>'
          : '') +
        '<div class="rm-breakdown__total"><span>Total</span><span>' +
        esc(money(pr.total)) +
        '</span></div>' +
        '</div>';
    }

    /* The notes of the row being built. Step 3 asks for every note of the size, both
       packages, but only these belong to this build. */
    var notes = rowNotes(row);
    var confirmHtml = notes.length
      ? '<div><h3>Confirmed with you</h3><div class="rm-confirm">' +
        notes
          .map(function (n) {
            return '<label><span aria-hidden="true">✓</span><span>' + esc(n) + '</span></label>';
          })
          .join('') +
        '</div></div>'
      : '';

    var bike = bikeOf(S.bike);
    var bikeFlag =
      bike && bike.status === 'check'
        ? '<p class="rm-note rm-note--warn">' +
          esc(bikeLabel(bike)) +
          ': wheels are listed for this platform and we confirm fitment with you before the build starts.</p>'
        : '';

    var quoteFlag = '';
    if (pr.status === 'quote' && rim.up && !rimCartable(rim)) {
      quoteFlag =
        '<p class="rm-note rm-note--warn">' +
        esc(rimLabel()) +
        ' rims are quoted rather than bought online today. Send the request and we reply with the confirmed price and lead time. No payment until you say yes.</p>';
    } else if (pr.status === 'quote' && pr.spokeUp && !spokeCartable(spoke)) {
      quoteFlag =
        '<p class="rm-note rm-note--warn">' +
        esc(S.spoke) +
        ' spokes are quoted rather than bought online today. Send the request and we reply with the confirmed price and lead time. No payment until you say yes.</p>';
    } else if (pr.status === 'quote' && pr.hubUp && !hubCartable(S.color)) {
      quoteFlag =
        '<p class="rm-note rm-note--warn">' +
        esc(S.color) +
        ' hubs are quoted rather than bought online today. Send the request and we reply with the confirmed price and lead time. No payment until you say yes.</p>';
    }

    return (
      '<h2>Review your wheelset</h2>' +
      '<p class="rm-bld__help">Check your bike, sizes, finishes, and included items before adding this build to your cart.</p>' +
      bikeFlag +
      quoteFlag +
      '<div class="rm-review">' +
      '<table><tbody>' +
      rows
        .map(function (r) {
          return (
            '<tr><td>' +
            esc(r[0]) +
            '</td><td><span class="rm-mono">' +
            (r[3] || esc(r[1])) +
            '</span><button type="button" class="rm-link" data-step="' +
            r[2] +
            '">Edit</button></td></tr>'
          );
        })
        .join('') +
      '</tbody></table>' +
      breakdown +
      '<div><h3>Estimated lead time</h3><ul>' +
      leadLines()
        .map(function (l) {
          return '<li>' + esc(l) + '</li>';
        })
        .join('') +
      '</ul></div>' +
      '<div><h3>Included</h3><ul><li>' +
      (setupOf(S.setup).pair ? 'Front and rear wheels, built to our spec' : 'One wheel, built to our spec') +
      '</li>' +
      (S.tires === 'rtr' ? '<li>' + esc(rtrMountText()) + '</li>' : '<li>Rim strips</li>') +
      '</ul>' +
      '<h3 style="margin-top:14px">Not included</h3><ul><li>' +
      esc(partsNotIncluded()) +
      '. Installation and transfer of your stock parts are still needed</li>' +
      (S.tires === 'rtr' ? '' : '<li>Tires and tubes</li>') +
      '<li>Chain, spacer kit or caliper adapters if the size change needs them</li></ul></div>' +
      confirmHtml +
      '</div>' +
      '<p class="rm-bld__quote"><button type="button" class="rm-link" data-request>Request a quote instead</button></p>'
    );
  }

  function renderPanel() {
    var html = '';
    if (S.step === 1) html = panelBike();
    else if (S.step === 2) html = panelSetup();
    else if (S.step === 3) html = panelSize();
    else if (S.step === 4) html = panelTires();
    else if (S.step === 5) html = panelFinish();
    else html = panelReview();

    var nav =
      '<div class="rm-bld__nav">' +
      (S.step > 1 ? '<button type="button" class="rm-btn rm-btn--ghost" data-prev>Back</button>' : '<span></span>') +
      (S.step < 6
        ? '<button type="button" class="rm-btn rm-btn--primary" data-next' +
          (stepDone(S.step) ? '' : ' aria-disabled="true"') +
          '>' +
          nextHtml(NEXT_LABEL[S.step - 1]) +
          '</button>'
        : '') +
      '</div>';

    elPanel.innerHTML = html + nav;
    /* Coming to step 1 from elsewhere starts with no search and the picked bike's brand
       open, or every brand closed when there is no bike yet. A render while already on
       step 1 keeps both. */
    if (S.step === 1) {
      if (bikePanelStep !== 1) {
        bikeQuery = '';
        bikeOpen = S.bike && bikeOf(S.bike) ? brandOf(bikeOf(S.bike)) : bikeHint;
        var q = elPanel.querySelector('[data-rm-bike-q]');
        if (q) q.value = '';
      }
      syncBikeList();
      bindBikePics(elPanel);
    }
    bikePanelStep = S.step;
    bindFinishPhotos(elPanel);
    if (S.step === 4) {
      bindTirePics(elPanel);
      bindTireShots(elPanel);
    }
    if (configMode()) mountStage();
    announceStep();
  }

  /* What the set leaves out depends on the configuration: a front wheel has no
     sprocket, and only full sets can be Ready-to-Ride. */
  function partsNotIncluded() {
    if (S.setup === 'front_single') return 'Brake rotor not included';
    if (S.setup === 'rear_single') return 'Brake rotor and rear sprocket not included';
    return 'Brake rotors and rear sprocket not included';
  }

  function buyNote() {
    return (
      '<p class="rm-sum__fine">' +
      esc(partsNotIncluded()) +
      '. ' +
      (S.tires === 'rtr' ? 'Tires and tubes mounted before shipment.' : 'Tires and tubes not included.') +
      '</p>'
    );
  }

  function statusLabel(pr) {
    if (pr.status === 'verified') return { text: 'Build total', cls: 'is-ok' };
    if (pr.status === 'quote') return { text: 'Quoted price', cls: 'is-warn' };
    if (pr.status === 'estimate') return { text: 'Estimate', cls: 'is-warn' };
    return { text: 'Choose a size', cls: '' };
  }

  function renderSummary() {
    var pr = price();
    var st = statusLabel(pr);
    var row = currentRow();
    var rim = rimOf(S.rim);
    var canBuy = pr.status === 'verified' && buildReady() && S.step === 6;
    /* The size shows once it is picked, even while MX or EX is still to choose. */
    var sizeOpt = sizeOption(S.sizeKey);
    var sizeRow = row || (sizeOpt && (sizeOpt.wheels || sizeOpt.rtr[0])) || null;

    /* The finish photo is the preview. The diagram is only the fallback for a photo
       that will not load, so it stays in the file. A rim still missing a two-tone or
       splatter color goes straight to the diagram here too, as the stage does, on every
       screen size, so no photo that cannot exist is asked for. */
    var fp =
      rimUnfinished() || finishPhotoMissed(S.rim, S.spoke, S.color)
        ? ''
        : finishPhotoUrl(S.rim, S.spoke, S.color, 900);
    var finishCell = fp
      ? '<div><img src="' +
        esc(fp) +
        '" srcset="' +
        esc(finishPhotoUrl(S.rim, S.spoke, S.color, 600)) +
        ' 600w, ' +
        esc(fp) +
        ' 900w, ' +
        esc(finishPhotoUrl(S.rim, S.spoke, S.color, 1400)) +
        ' 1400w" sizes="(max-width: 700px) 100vw, 45vw" alt="' +
        esc(finishPhotoAlt()) +
        '" loading="lazy" data-rm-finish-photo><span>Finish</span></div>'
      : '<div>' + svgWheel(S.rim, S.spoke, S.color, 'rmpv') + '<span>Diagram</span></div>';

    var prev =
      '<div class="rm-prev"><div class="rm-prev__imgs">' +
      finishCell +
      '</div>' +
      '<div class="rm-chips">' +
      '<span class="rm-chip"><i style="background:' + rim.css + '"></i>Rim: ' + esc(rimLabel()) + '</span>' +
      '<span class="rm-chip"><i style="background:' + spokeOf(S.spoke).css + '"></i>Spokes: ' + esc(S.spoke) + '</span>' +
      '<span class="rm-chip"><i style="background:' + colorSwatch(S.color) + '"></i>Hubs: ' + esc(S.color) + '</span>' +
      '<span class="rm-chip"><i style="background:' + colorSwatch(S.color) + '"></i>Nipples: ' + esc(S.color) + '</span>' +
      '</div>' +
      '<p class="rm-prev__cap">' +
      previewCaption(!!fp) +
      '</p></div>';

    var dl =
      '<dl>' +
      '<dt>Bike</dt><dd' + (S.bike ? '' : ' class="rm-pend"') + '>' + esc(S.bike ? bikeLabel(bikeOf(S.bike)) : 'Not chosen') + '</dd>' +
      '<dt>Riding style</dt><dd>' + esc(setupOf(S.setup).title) + '</dd>' +
      '<dt>Wheel size</dt><dd' + (sizeRow ? '' : ' class="rm-pend"') + '>' + (sizeRow ? rowLines(sizeRow) : 'Not chosen') + '</dd>' +
      '<dt>Wheelset package</dt><dd>' + (S.tires === 'rtr' ? 'Ready-to-Ride' : 'Wheels only') + '</dd>' +
      '<dt>Hub color</dt><dd>' + esc(S.color + hubSuffix()) + '</dd>' +
      '<dt>Rim / spokes</dt><dd>' + esc(rimLabel()) + ' / ' + esc(S.spoke) + '</dd>' +
      '</dl>';

    var cta;
    if (S.step < 6) {
      cta =
        '<button type="button" class="rm-btn rm-btn--primary rm-btn--wide" data-next' +
        (stepDone(S.step) ? '' : ' aria-disabled="true"') +
        '>' +
        nextHtml(NEXT_LABEL[S.step - 1]) +
        '</button>';
    } else if (canBuy) {
      cta =
        '<button type="button" class="rm-btn rm-btn--primary rm-btn--wide" data-add' +
        (S.adding ? ' disabled' : '') +
        '>' +
        (S.adding ? (S.editing ? 'Updating...' : 'Adding...') : (S.editing ? 'Update cart ' : 'Add to cart ') + esc(money(pr.total))) +
        '</button>' +
        buyNote();
    } else {
      cta =
        '<button type="button" class="rm-btn rm-btn--primary rm-btn--wide" data-request' +
        (pr.total != null && buildReady() ? '' : ' disabled') +
        '>Request this build</button>' +
        '<p class="rm-sum__fine">We reply with a confirmed price and lead time. No payment until then.</p>';
    }

    /* A failed add has to say so where the button is. The note is rendered as part
       of the summary so it survives the next renderSummary, and it is a polite live
       region so a screen reader hears it without the focus being stolen. */
    var cartNote = S.cartError
      ? '<p class="rm-note rm-note--bad" role="status" aria-live="polite" tabindex="-1" data-rm-cart-note>' + esc(S.cartError) + '</p>'
      : '';

    elSummary.innerHTML =
      prev +
      '<div class="rm-sum"><h3>Your build <span>Step ' +
      S.step +
      ' of 6</span></h3>' +
      dl +
      '<div class="rm-sum__tot"><div>' +
      (pr.total != null
        ? '<small class="' + st.cls + '">' + esc(st.text) + '</small>' +
          '<span class="rm-price">' + esc(money(pr.total)) + '</span>'
        : '<span class="rm-price rm-price--pend">' + (modelPending() ? 'Pick MX or EX' : 'Pick a size') + '</span>') +
      '</div><div class="rm-sum__lead">' +
      leadLines()
        .map(function (l) {
          return esc(l);
        })
        .join('<br>') +
      '</div></div>' +
      cta +
      cartNote +
      '</div>';

    /* mobile bar. Back sits at the left from step 2 (Peter, 2026-10-14); the in-panel
       nav is hidden on a phone because this bar covers it. Before there is a price
       the bar names what this step wants, and once there is one it says what still
       blocks Continue. */
    var hint = !stepDone(S.step) ? missingText() : '';
    elMob.innerHTML =
      (S.step > 1
        ? '<button type="button" class="rm-bld__mobback" data-prev aria-label="Back to ' + esc(STEP_NAMES[S.step - 2]) + '">Back</button>'
        : '') +
      '<div class="rm-bld__mobinfo">' +
      (pr.total != null
        ? '<span class="rm-price">' + esc(money(pr.total)) + '</span>' +
          '<small' + (hint ? ' class="is-hint"' : '') + '>' + esc(hint || st.text) + '</small>'
        : '<span class="rm-price rm-price--pend">' + esc(barText(hint || (stepDone(S.step) ? chosenText() : STEP_PROMPTS[S.step - 1]))) + '</span>') +
      '</div>' +
      (S.step < 6
        ? '<button type="button" class="rm-btn rm-btn--primary rm-bld__mobnext" data-next' +
          (stepDone(S.step) ? '' : ' aria-disabled="true"') +
          ' aria-label="Next step: ' + esc(NEXT_LABEL[S.step - 1]) + '">' +
          nextHtml(NEXT_SHORT[S.step - 1]) +
          '</button>'
        : canBuy
          ? '<button type="button" class="rm-btn rm-btn--primary" data-add' + (S.adding ? ' disabled' : '') + '>' + (S.editing ? 'Update cart' : 'Add to cart') + '</button>'
          : '<button type="button" class="rm-btn rm-btn--primary" data-request' +
            (pr.total != null && buildReady() ? '' : ' disabled') +
            '>Send request</button>');

    bindFinishPhotos(elSummary);
    syncMobBar();
  }

  /* The sticky bar duplicates the summary CTA. On the review step, once that
     CTA is on screen, the bar is noise and covers the page, so hide it. */
  var mobWatchOn = false;
  var requestOpen = false;

  function ctaInView() {
    var cta = elSummary.querySelector('.rm-sum .rm-btn--wide');
    if (!cta || !cta.offsetParent) return false;
    var r = cta.getBoundingClientRect();
    if (!r.height) return false;
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var visible = Math.min(r.bottom, vh) - Math.max(r.top, 0);
    return visible >= r.height * 0.6;
  }

  function updateMobBar() {
    /* Once the request form is open it owns the page, so the bar goes away
       rather than sitting on top of the fields. */
    elMob.hidden = S.step === 6 && (requestOpen || ctaInView());
  }

  function syncMobBar() {
    if (S.step < 6) {
      elMob.hidden = false;
      return;
    }
    if (!mobWatchOn) {
      mobWatchOn = true;
      window.addEventListener('scroll', updateMobBar, { passive: true });
      window.addEventListener('resize', updateMobBar);
    }
    updateMobBar();
  }

  function render() {
    var keep = focusKey();
    S.maxStep = Math.max(S.maxStep, S.step);
    /* On a phone the summary CTA is hidden and the sticky bar carries the
       action. At the review step the real button comes back into the page,
       so the bar can step aside once it is on screen. */
    root.classList.toggle('is-review', S.step === 6);
    root.classList.toggle('is-cfg', configMode());
    /* From step 2 a phone shows the heading alone, so the hero stops repeating 200px of
       intro above every step. The CSS only acts on it below 750px. */
    root.classList.toggle('is-compact', S.step > 1);
    renderSteps();
    renderPanel();
    renderSummary();
    saveState();
    if (requestOpen && elRequest) fillRequestFields();
    restoreFocus(keep);
  }

  /* Every render rewrites the panel, which used to drop focus on the floor, so arrow
     keys in a radio group stopped after one step. What had focus is noted first and
     the same control is found again afterwards. */
  function focusKey() {
    var a = document.activeElement;
    if (!a || !elPanel.contains(a)) return null;
    if (a.getAttribute('role') === 'tab') return { tab: true };
    if (a.hasAttribute('data-rm-acc-head')) return { acc: a.id };
    if (a.hasAttribute('data-rm-bike-q')) return { q: true, from: a.selectionStart, to: a.selectionEnd };
    if (a.tagName !== 'INPUT') return null;
    if (a.dataset.note) return { note: a.dataset.note };
    return a.name ? { name: a.name, value: a.value } : null;
  }

  function restoreFocus(k) {
    if (!k) return;
    var el = null;
    if (k.tab) {
      el = elPanel.querySelector('[role="tab"][aria-selected="true"]');
    } else if (k.acc) {
      el = document.getElementById(k.acc);
    } else if (k.q) {
      /* The search box comes back with its text, focus and caret where they were. */
      el = elPanel.querySelector('[data-rm-bike-q]');
      if (el && el !== document.activeElement) {
        el.focus({ preventScroll: true });
        try {
          el.setSelectionRange(k.from, k.to);
        } catch (err) {
          /* not a text field after all. Focus is enough. */
        }
      }
      return;
    } else {
      var list = elPanel.querySelectorAll('input');
      for (var i = 0; i < list.length; i++) {
        var x = list[i];
        if (k.note ? x.dataset.note === k.note : x.name === k.name && x.value === k.value) {
          el = x;
          break;
        }
      }
    }
    if (el && el !== document.activeElement) el.focus({ preventScroll: true });
  }

  /* ---------- cart ---------- */

  /* What makes a build the same build, less its tire choice: a cart build can be reopened
     for a tire change only while the saved build still matches what went in the cart. */
  function buildSig() {
    return [S.bike, S.setup, S.tires, S.sizeKey, S.variantBike, S.color, S.rim, S.toneA, S.toneB, S.splatterBase, S.splatterColor, S.spoke].join('|');
  }

  /* The edit lasts for this tab, so a reload keeps it and a new tab does not. */
  var EDIT_KEY = 'rm_builder_edit';
  var EDIT_NOTE = 'You are changing the tires on the build in your cart. Pick new tires, then select Update cart on the review step to replace it.';
  function setEditing(id) {
    S.editing = id || null;
    try {
      if (id) window.sessionStorage.setItem(EDIT_KEY, id);
      else window.sessionStorage.removeItem(EDIT_KEY);
    } catch (e) {
      /* private mode: the edit lasts for this page only */
    }
  }

  function buildId() {
    if (!S.buildId) {
      var s = 'abcdefghjkmnpqrstuvwxyz23456789';
      var out = '';
      for (var i = 0; i < 8; i++) out += s.charAt(Math.floor(Math.random() * s.length));
      S.buildId = out;
    }
    return S.buildId;
  }

  function wheelTitle() {
    var row = currentRow();
    var s = setupOf(S.setup);
    return (
      'Custom ' +
      s.title +
      (S.tires === 'rtr' ? ' Ready-to-Ride' : '') +
      ' ' +
      (s.pair ? 'Wheelset' : 'Wheel') +
      ', ' +
      bikeLabel(bikeOf(S.bike)) +
      (row ? ', ' + rowLabel(row) : '')
    );
  }

  function cartSectionIds() {
    var ids = [];
    document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (el) {
      if (ids.indexOf(el.dataset.sectionId) === -1) ids.push(el.dataset.sectionId);
    });
    return ids;
  }

  function dispatchCartUpdate(lines, promise) {
    var name = 'shopify:cart:lines-update';
    var detail = { action: 'add', context: 'product', lines: lines, promise: promise };
    var target = root;
    /* Use the real CartLinesUpdateEvent when the standard events module is available so
       Savor's drawer, cart items and cart icon behave exactly as they do on a product form. */
    if (typeof window.__rmCartEventClass === 'function') {
      target.dispatchEvent(new window.__rmCartEventClass(detail));
      return;
    }
    var ev = new Event(name, { bubbles: true, cancelable: true });
    Object.assign(ev, detail);
    target.dispatchEvent(ev);
  }

  /* Try to pick up Savor's own event classes. If the import fails we still dispatch a
     plain event with the same name and shape. */
  var eventsReady = import('@shopify/events')
    .then(function (mod) {
      if (mod && mod.CartLinesUpdateEvent) {
        window.__rmCartEventClass = mod.CartLinesUpdateEvent;
        window.__rmCartEventPromise = mod.CartLinesUpdateEvent.createPromise.bind(mod.CartLinesUpdateEvent);
      }
    })
    .catch(function () {
      /* no standard events module. The fallback below covers it. */
    });

  function deferred() {
    if (typeof window.__rmCartEventPromise === 'function') return window.__rmCartEventPromise();
    var d = {};
    d.promise = new Promise(function (res, rej) {
      d.resolve = res;
      d.reject = rej;
    });
    return d;
  }

  /* What the rider reads when the add does not go through. The button stays as it
     was and the cart is left alone, so trying again is safe. */
  var CART_FAIL = 'We could not add this build to the cart. Please try again in a moment.';

  /* Shopify answers a bad add in more than one shape: {"status":422,...},
     {"description":"..."}, {"errors":"Too many attempts"} and {"errors":{...}}.
     Any of them means nothing was added. */
  function failedAdd(res) {
    if (!res || typeof res !== 'object') return true;
    return !!(res.status || res.errors || res.description || res.message);
  }

  /* The server line is worth showing only when it is a plain sentence a customer
     can act on. Field maps, ids and anything long stay out of the shopper's way. */
  function addErrorMessage(res, httpStatus) {
    var raw = '';
    if (res) {
      if (typeof res.description === 'string') raw = res.description;
      else if (typeof res.errors === 'string') raw = res.errors;
      else if (typeof res.message === 'string' && res.message !== String(httpStatus)) raw = res.message;
    }
    raw = String(raw || '').trim();
    if (!raw || raw.length > 160 || raw.indexOf('{') > -1 || raw.indexOf('<') > -1) return '';
    /* Read as one sentence after the standing line. */
    return raw.charAt(raw.length - 1) === '.' ? raw : raw + '.';
  }

  function addToCart() {
    var pr = price();
    var row = currentRow();
    if (!row || pr.status !== 'verified' || !pr.variantId || S.adding) return;
    S.adding = true;
    S.cartError = '';
    renderSummary();

    var id = buildId();
    /* The same six properties go on every line, so the lines read as one build
       wherever the order is looked at. Hub color is on every build, not only a builder
       only color, so hub, rim and spokes always read as three labelled lines (Peter,
       2026-10-15). A builder only color still carts as the Black variant, so its
       variant title says Black and this line is the one to build from. */
    var shared = {
      'Hub color': S.color,
      'Rim color': rimLabel(),
      Spokes: S.spoke,
      Bike: bikeLabel(bikeOf(S.bike)) + (activeVariantBike() && variantBikes(famEffective()).length > 1 ? ' (' + activeVariantBike() + ')' : ''),
      Setup: setupOf(S.setup).title + (S.tires === 'rtr' ? ', Ready-to-Ride' : ', wheels only'),
      /* Leading underscore: Shopify hides it at checkout and in notifications (Peter,
         2026-10-17). The cart groups and removes a build by it, and still accepts the
         old "Build id" on lines added before this change. */
      '_Build id': id,
    };
    /* The finish photo the builder previewed goes on every line as a hidden property, so
       the cart page and drawer can show the configured set instead of the stock variant
       photo. Underscore names never print as text. Checkout still shows the variant photo. */
    var previewUrl = finishPhotoMissed(S.rim, S.spoke, S.color) ? '' : finishPhotoUrl(S.rim, S.spoke, S.color, 600);
    if (previewUrl) shared['_Preview image'] = previewUrl;
    function withShared(extra) {
      var out = {};
      for (var k in shared) if (Object.prototype.hasOwnProperty.call(shared, k)) out[k] = shared[k];
      for (var j in extra) if (Object.prototype.hasOwnProperty.call(extra, j)) out[j] = extra[j];
      return out;
    }
    var wheelProps = { Size: rowLabel(row) };
    var tiresProp = S.tires === 'rtr' ? tiresText() : '';
    if (tiresProp) wheelProps.Tires = tiresProp;
    var items = [{ id: Number(pr.variantId), quantity: 1, properties: withShared(wheelProps) }];
    /* A tire choice is its own line, charged at its variant's price, grouped under the
       wheelset by For and the build id (the product pages do the same). */
    var tirePick = chosenTireChoice();
    if (tirePick) {
      items.push({
        id: Number(tirePick.id),
        quantity: 1,
        properties: withShared({ For: wheelTitle(), Tires: tirePick.opt.tires_text }),
      });
    }
    var rim = rimOf(S.rim);
    if (rim.up) {
      var upId = upchargeVariant(rimCharge(rim));
      if (upId) {
        items.push({
          id: Number(upId),
          quantity: 1,
          properties: withShared({ For: wheelTitle() }),
        });
      }
    }
    /* The spoke charge is per wheel, so a front and rear set takes two of it. */
    var spoke = spokeOf(S.spoke);
    if (spoke.up) {
      var spokeUpId = upchargeVariant(20);
      if (spokeUpId) {
        items.push({
          id: Number(spokeUpId),
          quantity: setupOf(S.setup).pair ? 2 : 1,
          properties: withShared({ For: wheelTitle(), Spokes: spoke.id + ', per wheel' }),
        });
      }
    }
    /* The hub charge is per hub: two on a set, one on a single wheel. It has its own
       variant, so it sits beside a rim or spoke line rather than merging into one. */
    if (pr.hubUp) {
      var hubUpId = upchargeVariant('hub20');
      if (hubUpId) {
        items.push({
          id: Number(hubUpId),
          quantity: hubCount(),
          properties: withShared({ For: wheelTitle(), 'Hub color': S.color + ', per hub' }),
        });
      }
    }

    var lines = items.map(function (i) {
      return { merchandiseId: String(i.id), quantity: i.quantity };
    });

    eventsReady.then(function () {
      var d = deferred();
      dispatchCartUpdate(lines, d.promise);

      /* Every line of the build goes in one /cart/add.js call, which Shopify applies
         all or nothing, so there is no half build to unwind. */
      fetch(CONFIG.cart_add_url || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        /* Shopify lists the lines of one add in reverse, so the charge lines go first and
           the cart shows the wheelset with its charges under it (redesign session,
           2026-10-17, with the cart's build grouping). */
        body: JSON.stringify({ items: items.slice(1).concat(items.slice(0, 1)), sections: cartSectionIds().join(',') }),
      })
        .then(function (r) {
          /* Anything but a clean 2xx is a failure, and so is a 2xx whose body
             carries an errors or description key. The throttle body
             {"errors":"Too many attempts"} has no status key at all, which is how
             it used to resolve as a success with an empty cart. */
          return r
            .json()
            .catch(function () {
              return null;
            })
            .then(function (res) {
              if (!r.ok || failedAdd(res)) throw new Error(addErrorMessage(res, r.status));
              return fetch('/cart.js').then(function (c) {
                return c.json();
              });
            });
        })
        .then(function (cart) {
          /* A build reopened from the cart's "Change tires" link replaces itself: once the
             new lines are in, the old build's lines come out. Adding first means a failed
             add never loses the build; a failed removal leaves both, and the cart's own
             remove takes the old one out whole. */
          var old = S.editing;
          if (!old || !cart || !cart.items) return cart;
          var updates = {};
          var n = 0;
          cart.items.forEach(function (it) {
            var p = it.properties || {};
            if (String(p['_Build id'] || p['Build id'] || '').trim() === old) {
              updates[it.key] = 0;
              n++;
            }
          });
          if (!n) return cart;
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ updates: updates }),
          })
            .then(function (u) {
              return u.ok ? u.json() : cart;
            })
            .catch(function () {
              return cart;
            });
        })
        .then(function (cart) {
          /* Belt and braces: a success that added nothing is still a failure. */
          if (!cart || !cart.item_count) throw new Error('');
          d.resolve({
            cart: null,
            detail: {
              items: cart.items,
              source: 'rm-builder',
              sourceId: 'rm-builder',
              itemCount: cart.item_count,
              didError: false,
            },
          });
          S.carted = { id: id, sig: buildSig() };
          setEditing(null);
          S.buildId = null;
          S.cartError = '';
          saveState();
          /* The build is in the cart; take the shopper there (Peter, 2026-09-16).
             The button stays in its Adding state until the cart page paints. */
          window.location.assign(CONFIG.cart_url || '/cart');
          return true;
        })
        .catch(function (err) {
          d.reject(err);
          S.cartError = CART_FAIL + (err && err.message ? ' ' + err.message : '');
        })
        .then(function (redirected) {
          if (redirected === true) return;
          S.adding = false;
          renderSummary();
        });
    });
  }

  /* ---------- build request ---------- */

  function requestSummaryText() {
    var row = currentRow();
    var pr = price();
    var rim = rimOf(S.rim);
    var lines = [
      'Custom wheel quote',
      'Bike: ' + bikeLabel(bikeOf(S.bike)) + bikeSuffix(),
      'Setup: ' + setupText(),
      'Tires: ' + (S.tires === 'rtr' ? 'Ready-to-Ride, mounted' : 'Wheels only'),
      'Size: ' + (row ? rowLabel(row) : 'not chosen'),
      'Quantity: ' + quantityText(),
      'Hub color (hub and nipples): ' + S.color + hubSuffix(),
      'Rim color: ' + rimLabel() + (rim.up ? ' (+' + money(rimCharge(rim)) + ' ' + rimUnit() + ')' : ' (included)'),
      'Spokes: ' + S.spoke + spokeSuffix(spokeOf(S.spoke)),
      'Price shown in the builder: ' + (pr.total != null ? money(pr.total) : 'not priced') + ' (' + statusLabel(pr).text.toLowerCase() + ')',
      'Lead time shown: ' + leadLines().join('. '),
    ];
    if (row && S.tires === 'rtr' && chosenTireChoice()) lines.push('Tire pairing: ' + chosenTireChoice().opt.tires_text + ' (tire choice)');
    else if (row && row.rtr_tire && S.tires === 'rtr') lines.push('Tire pairing: ' + row.rtr_tire.split('|').join(' / '));
    var notes = rowNotes(row);
    if (notes.length) lines.push('Confirmed in the builder: ' + notes.join(' / '));
    lines.push('Build reference: ' + buildId());
    return lines.join('\n');
  }

  /* The row's bike name in brackets, only where it says something the bike label does
     not ("Stark Varg MX", "Talaria MX4/XXX"), never "Stark Varg (Stark Varg)". */
  function bikeSuffix() {
    var vb = activeVariantBike();
    var label = bikeLabel(bikeOf(S.bike));
    /* "Stark Varg MX" carries its model already, and is never "Stark Varg MX (Stark Varg)". */
    return vb && vb !== label && label.indexOf(vb) !== 0 ? ' (' + vb + ')' : '';
  }

  /* A bike with no sizes listed has no setup to name, so the request says so. */
  function setupText() {
    return rowsAny() ? setupOf(S.setup).title : 'None listed for this bike';
  }

  function quantityText() {
    return setupOf(S.setup).pair ? '1 set, front and rear' : '1 wheel';
  }

  /* The quote carries every choice as its own field as well as in the body, so the rim
     color is data on the email and not only prose a rider could delete. */
  function fillRequestFields() {
    var row = currentRow();
    var pr = price();
    var rim = rimOf(S.rim);
    var bike = bikeLabel(bikeOf(S.bike)) + (activeVariantBike() && variantBikes(famEffective()).length > 1 ? ' (' + activeVariantBike() + ')' : '');
    var setup = setupText();
    var values = {
      subject: 'Custom wheel quote: ' + (bike || 'bike not chosen') + ' ' + setup + ' ' + rimLabel() + ' rims',
      bike: bike,
      setup: setup,
      tires: S.tires === 'rtr' ? 'Ready-to-Ride, mounted' : 'Wheels only',
      sizes: row ? rowLabel(row) : 'not chosen',
      accent: S.color + hubSuffix(),
      rim: rimLabel() + (rim.up ? ' (+' + money(rimCharge(rim)) + ' ' + rimUnit() + ')' : ' (included)'),
      spokes: S.spoke + spokeSuffix(spokeOf(S.spoke)),
      quantity: quantityText(),
      price: pr.total != null ? money(pr.total) + ' (' + statusLabel(pr).text.toLowerCase() + ')' : 'not priced',
      build: buildId(),
    };
    Object.keys(values).forEach(function (k) {
      var el = elRequest.querySelector('[data-rm-field="' + k + '"]');
      if (el) el.value = values[k];
    });
  }

  function openRequest() {
    var text = requestSummaryText();
    var hidden = elRequest.querySelector('[data-rm-request-summary]');
    var body = elRequest.querySelector('#rm-req-body');
    fillRequestFields();
    if (hidden) hidden.value = text;
    if (body && (!body.value || body.dataset.rmAuto !== 'no')) {
      body.value = text + '\n\nAnything we should know:\n';
      body.dataset.rmAuto = 'yes';
    }
    elRequest.hidden = false;
    requestOpen = true;
    updateMobBar();
    elRequest.scrollIntoView({
      behavior: prefersReducedMotion() ? 'auto' : 'smooth',
      block: 'start',
    });
    if (body) body.focus();
  }

  /* ---------- events ---------- */

  function goto(n) {
    n = Math.max(1, Math.min(6, n));
    /* Passing step 4 with Continue is seeing the package, so the later steps open again. */
    if (S.tiresMoved && S.step === 4 && n === 5 && stepDone(4)) S.tiresMoved = false;
    var reach = reachLimit();
    if (n > reach) return;
    S.step = n;
    setStepMenu(false);
    render();
    var h = root.querySelector('.rm-bld__panel h2');
    if (h) {
      h.setAttribute('tabindex', '-1');
      h.focus({ preventScroll: true });
    }
    scrollToStep();
  }

  /* The sticky site header covers the top of the page, so every scroll target is
     measured from its bottom edge. */
  function headerOffset() {
    var h = document.querySelector('.rm-header');
    var el = h;
    while (el && el !== document.body) {
      var pos = window.getComputedStyle(el).position;
      if (pos === 'fixed') {
        var b = el.getBoundingClientRect().bottom;
        return b > 0 ? b : 0;
      }
      /* A sticky header measured at the top of the page still sits below the
         announcement bar, so use where it pins once the page has scrolled. */
      if (pos === 'sticky') return (parseFloat(window.getComputedStyle(el).top) || 0) + el.offsetHeight;
      el = el.parentElement;
    }
    return 0;
  }

  /* From 990px the theme scrolls .page-wrapper and locks the document (scroll-container.js);
     below that the document scrolls so the phone toolbar can hide. */
  function pageScroller() {
    if (window.matchMedia('(min-width: 990px)').matches) {
      var w = document.querySelector('.page-wrapper');
      if (w) return w;
    }
    return document.scrollingElement || document.documentElement;
  }

  function scrollBehavior() {
    return prefersReducedMotion() ? 'auto' : 'smooth';
  }

  /* A new step starts at its top. Before this, focus moved with preventScroll and
     the page stayed where the last tap was, so a phone landed halfway down the
     next step (the rim colors, or under the review summary). */
  function scrollToStep() {
    var nav = root.querySelector('.rm-bld__steps');
    if (!nav) return;
    var top = nav.getBoundingClientRect().top;
    var sc = pageScroller();
    var target = top + sc.scrollTop - headerOffset();
    /* On desktop the steps stay put while they are on screen, so the page doesn't jump. */
    if (window.matchMedia('(min-width: 750px)').matches && top >= headerOffset() && top < window.innerHeight * 0.6) target = sc.scrollTop;
    /* Back on step 1 with a bike already picked, its card comes on screen as well. */
    if (S.step === 1) target = bikeTarget(target);
    if (Math.abs(sc.scrollTop - target) < 4) return;
    sc.scrollTo({ top: Math.max(0, target), behavior: scrollBehavior() });
  }

  /* Where the page should sit for the picked bike's card to be on screen: left at from
     when the card is already in view there, otherwise with the card centred between the
     header and the phone bar. A card further down the list used to stay out of sight
     when the rider came back to step 1. From 750px up the page moves only as far as the
     card needs, so the step band stays on screen wherever it can. */
  function bikeTarget(from) {
    var input = S.bike ? elPanel.querySelector('input[name="rm-bike"]:checked') : null;
    if (!input) return from;
    var card = input.closest('label') || input;
    var sc = pageScroller();
    var box = card.getBoundingClientRect();
    var docTop = box.top + sc.scrollTop;
    var head = headerOffset();
    var bar = root.querySelector('.rm-bld__mobbar');
    var foot = window.innerHeight - (bar && !bar.hidden ? bar.offsetHeight : 0);
    var at = docTop - from;
    if (at >= head && at + box.height <= foot) return from;
    if (window.matchMedia('(min-width: 750px)').matches) {
      if (at < head) return Math.max(0, docTop - head - 8);
      return Math.max(0, docTop + box.height - foot + 8);
    }
    return Math.max(0, docTop - head - Math.max(8, (foot - head - box.height) / 2));
  }

  /* A bike restored on step 1 at page load is brought into view the same way. Focus is
     left alone. */
  function revealBike() {
    if (S.step !== 1 || !S.bike) return;
    var sc = pageScroller();
    var target = bikeTarget(sc.scrollTop);
    if (Math.abs(sc.scrollTop - target) < 4) return;
    sc.scrollTo({ top: target, behavior: scrollBehavior() });
  }

  /* Before a price exists, a finished step shows what was picked so the bar confirms it. */
  function chosenText() {
    if (S.step === 1 && S.bike) return bikeLabel(bikeOf(S.bike));
    if (S.step === 2 && S.setup) return setupOf(S.setup).title;
    if (modelPending()) return 'Pick MX or EX';
    if (S.step === 3 && S.sizeKey) return sizeShort(S.sizeKey);
    if (S.step === 4) return S.tires === 'rtr' ? 'Ready-to-Ride' : 'Wheels only';
    return STEP_PROMPTS[S.step - 1];
  }

  /* A size short enough for the phone bar: 19x1.60 / 16x1.85. */
  function sizeShort(label) {
    var opt = sizeOption(label);
    var r = opt && (opt.wheels || opt.rtr[0]);
    if (!r || (!r.front && !r.rear)) return label;
    return [r.front, r.rear].filter(Boolean).join(' / ');
  }

  /* Whether the bike has sizes in any setup at all. */
  function rowsAny() {
    return SETUPS.some(function (s) {
      return rowsFor(s.id).length > 0;
    });
  }

  /* What still stands between this step and Continue, in the words the bar uses. */
  function missingText() {
    if (S.step === 1 && !S.bike) return 'Pick your bike';
    if (S.step === 2) return S.setup && rowsFor(S.setup).length ? '' : rowsAny() ? 'Pick a riding style' : NO_SETUP_TEXT;
    if (S.step === 3) {
      if (!sizeOption(S.sizeKey)) return variantBikes(S.setup).length > 1 && !variantFor(S.setup) ? 'Pick MX or EX' : 'Pick a size';
      var open = sizeNotes(S.sizeKey).filter(function (n) {
        return !S.confirmed[noteKey(S.sizeKey, n)];
      }).length;
      return open > 1 ? 'Tick the notes to continue' : 'Tick the note to continue';
    }
    if (S.step === 4) {
      if (S.tires === 'rtr' && sizeOption(S.sizeKey) && !currentRow()) return 'Pick MX or EX';
      if (currentRow() && !tireChoiceConfirmed()) return 'Tick the tire note to continue';
      return 'Pick a tire package';
    }
    if (S.step === 5) {
      if (isTwoTone() && !twoTonePairAllowed(S.toneA, S.toneB)) return 'Pick your second color';
      if (isSplatter() && !splatterChosen()) return 'Pick the splatter colors';
      return 'Pick your colors';
    }
    return '';
  }

  /* A tap on an unfinished Continue goes to the thing that is missing instead of
     doing nothing. */
  function showMissing() {
    var target = null;
    var pulse = null;
    var below = headerOffset() + 16;
    if (S.step === 5 && rimUnfinished()) {
      /* On a phone the picker lives on the Rims tab, which may not be the open one, so
         that opens first. On any screen the picker still waiting for a color (color
         two, the splatter base or the splatter color) is the one scrolled to, pulsed
         and focused, under the pinned stage on a phone. */
      if (configMode() && S.finTab !== 'rims') {
        S.finTab = 'rims';
        render();
      }
      pulse = openPicker();
      var head = pulse && pulse.previousElementSibling;
      target = head && head.tagName === 'H4' ? head : pulse;
      var cfgEl = configMode() ? elPanel.querySelector('.rm-bld__cfg') : null;
      if (cfgEl) below = headerOffset() + cfgEl.offsetHeight + 8;
    }
    if (target) {
      /* found above */
    } else if (S.step === 2 && elPanel.querySelector('[data-rm-nosetup]')) {
      target = elPanel.querySelector('[data-rm-nosetup]');
    } else if (S.step === 4 && elPanel.querySelector('[data-rm-model]')) {
      target = elPanel.querySelector('[data-rm-model]');
    } else if (S.step === 3 && sizeOption(S.sizeKey)) {
      var boxes = elPanel.querySelectorAll('[data-note]');
      for (var i = 0; i < boxes.length; i++)
        if (!boxes[i].checked) {
          target = boxes[i].closest('label') || boxes[i];
          break;
        }
    } else if (S.step === 5) {
      /* The two-tone and the splatter pickers share the one block class. */
      target = elPanel.querySelector('.rm-bld__tone') || elPanel.querySelector('.rm-bld__fieldset');
    } else if (S.step === 1) {
      /* The search box comes up just under the header, with the notice about a header bike
         we do not list above it when there is one. Aimed at the fieldset, the box sat
         hidden under the header. */
      target =
        elPanel.querySelector('[data-rm-bike-foreign]') ||
        elPanel.querySelector('.rm-bld__bsearch') ||
        elPanel.querySelector('h2');
    } else {
      target = elPanel.querySelector('.rm-bld__fieldset') || elPanel.querySelector('h2');
    }
    var msg = missingText();
    if (elLive && msg) elLive.textContent = msg;
    if (!target) return;
    pulse = pulse || target;
    var sc = pageScroller();
    var top = target.getBoundingClientRect().top + sc.scrollTop - below;
    sc.scrollTo({ top: Math.max(0, top), behavior: scrollBehavior() });
    pulse.classList.remove('rm-pulse');
    void pulse.offsetWidth;
    pulse.classList.add('rm-pulse');
    var input = pulse.querySelector ? pulse.querySelector('input') : null;
    /* Focus in the search box would open a phone's keyboard over the list, so it only
       moves there with a mouse or trackpad. */
    if (input && input.hasAttribute('data-rm-bike-q') && !(window.matchMedia && window.matchMedia('(pointer: fine)').matches)) input = null;
    if (input) input.focus({ preventScroll: true });
  }

  root.addEventListener('click', function (e) {
    if (!(e.target instanceof Element)) return;
    var t = e.target.closest('[data-step],[data-next],[data-prev],[data-add],[data-request],[data-fintab]');
    if (!t || !root.contains(t)) return;
    if (t.hasAttribute('data-fintab')) return pickFinTab(t.getAttribute('data-fintab'));
    if (t.hasAttribute('data-step')) return goto(parseInt(t.getAttribute('data-step'), 10));
    if (t.hasAttribute('data-next')) {
      if (!stepDone(S.step)) return showMissing();
      return goto(S.step + 1);
    }
    if (t.hasAttribute('data-prev')) return goto(S.step - 1);
    if (t.hasAttribute('data-add')) return addToCart();
    if (t.hasAttribute('data-request')) return openRequest();
  });

  /* What a new bike resets, from a pick on step 1 or from the header picker: the size,
     the variant bike, a riding style the bike has no sizes for, and Ready-to-Ride where
     it is not offered. */
  function setBike(handle) {
    S.bike = handle;
    bikeHint = null;
    /* Another bike is another build, never a change to the one in the cart. */
    if (S.editing) setEditing(null);
    S.tireSku = '';
    S.sizeKey = null;
    S.tiresMoved = false;
    S.variantBike = null;
    if (!rowsFor(S.setup).length) {
      for (var i = 0; i < SETUPS.length; i++)
        if (rowsFor(SETUPS[i].id).length) {
          S.setup = SETUPS[i].id;
          break;
        }
    }
    syncTires();
  }

  /* The header named a store bike the builder splits (stark-varg) and the build is on
     some other bike: no bike, step 1, that brand open. */
  function clearBike(fit) {
    S.bike = null;
    S.sizeKey = null;
    S.variantBike = null;
    S.tiresMoved = false;
    S.buildId = null;
    S.step = 1;
    S.maxStep = 1;
    bikeHint = brandOf(bikesFor(fit)[0]);
  }

  /* A bike picked in the header while the builder is open. One the builder lists is
     applied as a pick here would be, without announcing it back. Steps 1 and 2 stay put;
     from step 3 on the size no longer holds, so the builder goes to step 3, the size, and
     says why. When the new bike has no sizes in the riding style that was picked, the
     style changed with it, so the builder goes to step 2 to show that first. A bike the builder does not list takes it to step 1 with the notice. A cleared
     header bike leaves the build alone. Focus and scroll stay where they are, because the
     header picker is still open in front. */
  document.addEventListener('rm:bike-change', function (e) {
    var d = (e && e.detail) || {};
    if (d.source === 'builder') return;
    var handle = d.handle || d.bike;
    if (!handle || !started) return;
    var b = resolveBike(handle);
    if (!b && sharedFit(handle)) {
      bikeForeign = null;
      clearBike(handle);
      bikeOpen = bikeHint;
      render();
      return;
    }
    if (!b) {
      bikeForeign = { handle: handle, label: headerBikeLabel(handle) };
      S.step = 1;
      render();
      return;
    }
    var had = bikeForeign;
    bikeForeign = null;
    if (b.handle === S.bike) {
      if (had) render();
      return;
    }
    var setupWas = S.setup;
    setBike(b.handle);
    bikeOpen = brandOf(b);
    S.buildId = null;
    var back = S.step >= 3;
    if (back) S.step = S.setup === setupWas ? 3 : 2;
    render();
    if (back && elLive) elLive.textContent = 'Bike changed to ' + bikeLabel(b) + '. Pick your size again.';
  });

  root.addEventListener('change', function (e) {
    var el = e.target;
    if (!el.name && !el.dataset.note) return;

    if (el.name === 'rm-bike') {
      setBike(el.value);
      announceBike(el.value);
    } else if (el.name === 'rm-setup') {
      S.setup = el.value;
      S.sizeKey = null;
      S.variantBike = null;
      S.tireSku = '';
      S.tiresMoved = false;
      syncTires();
    } else if (el.name === 'rm-tirechoice') {
      S.tireSku = el.value || '';
    } else if (el.name === 'rm-tires') {
      /* Step 4 comes after the size now, so a tire choice keeps it. A tap is the rider's
         ask from here on, Wheels only included. */
      S.tires = el.value;
      S.tiresWant = el.value === 'rtr' ? 'rtr' : 'none';
      syncTires();
    } else if (el.name === 'rm-variantbike') {
      S.variantBike = el.value;
      /* A size the new model does not list is dropped; the Ready-to-Ride pick on step 4
         keeps its size. */
      if (!sizeOption(S.sizeKey)) S.sizeKey = null;
      syncTires();
    } else if (el.name === 'rm-size') {
      var pkgWas = S.tires;
      /* A new size starts on the standard tires, so a choice made for other rims is not
         carried into a set it was not picked for. */
      if (el.value !== S.sizeKey) S.tireSku = '';
      S.sizeKey = el.value;
      /* A tire choice the new size is not offered in switches to the one it is, and a
         rider already past step 4 is sent back through it to see the change. */
      syncTires();
      tiresMovedCheck(pkgWas);
    } else if (el.name === 'rm-color') {
      S.color = el.value;
    } else if (el.name === 'rm-rim') {
      S.rim = el.value;
      /* Two-tone opens with a pair we can build, so the preview has a photo to show the
         moment the card is picked. */
      if (isTwoTone()) {
        if (!twoToneEligible(S.toneA)) S.toneA = 'Black';
        if (!twoTonePairAllowed(S.toneA, S.toneB)) S.toneB = twoTonePairAllowed(S.toneA, 'Red') ? 'Red' : '';
      }
      /* Splatter opens with both pickers empty, because neither the base nor what is
         thrown over it has a default we could stand behind. A stale choice from an
         earlier visit is dropped rather than carried into a list it is not in. */
      if (isSplatter()) {
        if (!splatterBaseEligible(S.splatterBase)) S.splatterBase = '';
        if (!splatterColorEligible(S.splatterBase, S.splatterColor)) S.splatterColor = '';
      }
    } else if (el.name === 'rm-tone-a') {
      S.toneA = el.value;
      /* The second list is read off the first, so a color the new first color rules out
         is dropped rather than left selected under a list it is no longer in. */
      if (!twoTonePairAllowed(S.toneA, S.toneB)) S.toneB = '';
    } else if (el.name === 'rm-tone-b') {
      S.toneB = el.value;
    } else if (el.name === 'rm-splatter-base') {
      S.splatterBase = el.value;
      /* The splatter list is read off the base, so a color the new base rules out is
         dropped rather than left selected under a list it is no longer in. */
      if (!splatterColorEligible(S.splatterBase, S.splatterColor)) S.splatterColor = '';
    } else if (el.name === 'rm-splatter-color') {
      S.splatterColor = el.value;
    } else if (el.name === 'rm-spoke') {
      S.spoke = el.value;
    } else if (el.dataset.note) {
      S.confirmed[el.dataset.note] = el.checked;
    }
    S.buildId = null;
    render();
  });

  /* Left and right move between the finish tabs, Home and End jump to either end.
     The tab that takes focus opens with it. */
  root.addEventListener('keydown', function (e) {
    var t = e.target;
    if (!(t instanceof Element) || !t.hasAttribute('data-fintab')) return;
    var i = 0;
    for (var k = 0; k < FIN_TABS.length; k++) if (FIN_TABS[k].id === t.getAttribute('data-fintab')) i = k;
    var n = FIN_TABS.length;
    if (e.key === 'ArrowRight') i = (i + 1) % n;
    else if (e.key === 'ArrowLeft') i = (i + n - 1) % n;
    else if (e.key === 'Home') i = 0;
    else if (e.key === 'End') i = n - 1;
    else return;
    e.preventDefault();
    pickFinTab(FIN_TABS[i].id);
  });

  /* Crossing the phone breakpoint on the colors step swaps between the configurator
     and the desktop layout, and a resize can move where the header pins. */
  if (PHONE_MQ) {
    var phoneChange = function () {
      if (S.step === 5) render();
    };
    if (PHONE_MQ.addEventListener) PHONE_MQ.addEventListener('change', phoneChange);
    else if (PHONE_MQ.addListener) PHONE_MQ.addListener(phoneChange);
  }
  window.addEventListener(
    'resize',
    function () {
      if (configMode()) setStageTop();
    },
    { passive: true }
  );

  /* keep the body editable without it being overwritten on the next render */
  if (elRequest) {
    var bodyField = elRequest.querySelector('#rm-req-body');
    if (bodyField)
      bodyField.addEventListener('input', function () {
        bodyField.dataset.rmAuto = 'no';
      });
  }

  /* ---------- boot ---------- */

  /* ---------- the rider's selections survive a reload ---------- */

  var STORE_KEY = 'rm_builder';
  /* Version 2 is the size-before-tires order (2026-10-16). A version 1 build had steps 3
     and 4 the other way round. */
  var STORE_VERSION = 2;

  function saveState() {
    try {
      window.localStorage.setItem(
        STORE_KEY,
        JSON.stringify({
          v: STORE_VERSION,
          bike: S.bike,
          setup: S.setup,
          tires: S.tires,
          tiresWant: S.tiresWant,
          tiresMoved: S.tiresMoved,
          sizeKey: S.sizeKey,
          variantBike: S.variantBike,
          color: S.color,
          rim: S.rim,
          toneA: S.toneA,
          toneB: S.toneB,
          splatterBase: S.splatterBase,
          splatterColor: S.splatterColor,
          spoke: S.spoke,
          tireSku: S.tireSku,
          carted: S.carted,
          confirmed: S.confirmed,
          step: S.step,
          maxStep: S.maxStep,
        })
      );
    } catch (e) {
      /* private mode. Not worth surfacing. */
    }
  }

  function restoreState() {
    var raw = null;
    try {
      raw = window.localStorage.getItem(STORE_KEY);
    } catch (e) {
      return false;
    }
    if (!raw) return false;
    var d;
    try {
      d = JSON.parse(raw);
    } catch (e) {
      return false;
    }
    if (!d || (d.v !== 1 && d.v !== STORE_VERSION) || !d.bike || !bikeOf(d.bike)) return false;
    var old = d.v === 1;
    S.bike = d.bike;
    if (d.setup) S.setup = d.setup;
    if (d.tires) S.tires = d.tires;
    /* A version 1 build has no separate ask, so the package it was on stands in for it. */
    S.tiresWant = d.tiresWant === 'rtr' || d.tiresWant === 'none' ? d.tiresWant : S.tires === 'rtr' ? 'rtr' : 'none';
    S.tiresMoved = d.tiresMoved === true;
    S.sizeKey = d.sizeKey || null;
    S.variantBike = d.variantBike || null;
    if (d.color) S.color = d.color;
    if (d.rim && rimOf(d.rim).id === d.rim) S.rim = d.rim;
    if (d.toneA && twoToneEligible(d.toneA)) S.toneA = d.toneA;
    if (d.toneB && twoTonePairAllowed(S.toneA, d.toneB)) S.toneB = d.toneB;
    if (d.splatterBase && splatterBaseEligible(d.splatterBase)) S.splatterBase = d.splatterBase;
    if (d.splatterColor && splatterColorEligible(S.splatterBase, d.splatterColor)) S.splatterColor = d.splatterColor;
    if (d.spoke && spokeOf(d.spoke).id === d.spoke) S.spoke = d.spoke;
    S.tireSku = typeof d.tireSku === 'string' ? d.tireSku : '';
    S.carted = d.carted && typeof d.carted.id === 'string' && typeof d.carted.sig === 'string' ? d.carted : null;
    /* A version 1 build keeps every choice, but its ticks were keyed by row and index and
       are dropped, and it reopens no further than step 3, so the rider checks the size and
       then the tires in the new order. */
    S.confirmed = !old && d.confirmed && typeof d.confirmed === 'object' ? d.confirmed : {};
    if (!sizeOption(S.sizeKey)) S.sizeKey = null;
    syncTires();
    var reach = maxReachable();
    if (old) reach = Math.min(reach, 3);
    S.step = Math.min(Math.max(1, d.step || 1), reach);
    S.maxStep = Math.min(Math.max(S.step, d.maxStep || 1), reach);
    return true;
  }

  /* The header bike button and the "your bike" strip listen for this, as they do for
     the header picker, rm-bike.js and the homepage guide. Without it they showed the old
     bike until the next page load. */
  function announceBike(handle) {
    var picked = bikeOf(handle);
    /* The header knows the store's bike, so the Varg MX and EX both go out as stark-varg. */
    if (picked) handle = fitHandle(picked);
    try {
      window.localStorage.setItem('rm_bike', handle);
    } catch (err) {
      /* private mode. Not worth surfacing. */
    }
    var label = picked ? bikeLabel(picked) : handle;
    document.dispatchEvent(
      new CustomEvent('rm:bike-change', {
        detail: { bike: handle, handle: handle, label: label, name: label, source: 'builder' },
      })
    );
  }

  /* The cart's "Change tires" link on a builder build (snippets/cart-products.liquid)
     is ?edit=<build id>&back=<wheelset url>. It reopens that build on step 4 when this
     browser still holds it unchanged, and the add then replaces it in the cart. A build
     this browser does not hold has its tires changed where a product page build does,
     on the wheelset's page. Returns true when the build to show is settled. */
  function editPreselect(params) {
    var edit = params.get('edit');
    var fromLink = !!edit;
    if (!edit) {
      try {
        edit = window.sessionStorage.getItem(EDIT_KEY);
      } catch (e) {
        edit = null;
      }
    }
    if (!edit) return false;
    var held = S.carted && S.carted.id === edit && !!sizeOption(S.sizeKey) && S.tires === 'rtr';
    /* A link must find the build as it went in the cart; a reload keeps an edit already
       under way, whatever has changed since. */
    if (held && fromLink) held = S.carted.sig === buildSig();
    if (!held) {
      setEditing(null);
      var back = params.get('back') || '';
      if (fromLink && /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/[a-z0-9-]+(?:\?variant=\d+)?$/i.test(back)) {
        window.location.replace(back);
        return true;
      }
      return false;
    }
    setEditing(edit);
    if (fromLink) {
      S.step = 4;
      S.maxStep = 6;
      S.tiresMoved = false;
      /* The link is spent: a reload keeps the step the rider is on. */
      try {
        var u = new URL(window.location.href);
        u.searchParams.delete('edit');
        u.searchParams.delete('back');
        window.history.replaceState({}, '', u.pathname + u.search + u.hash);
      } catch (e) {
        /* old browser: the link stays, which reopens step 4 */
      }
    }
    announceBike(S.bike);
    if (S.step > reachLimit()) S.step = maxReachable();
    S.maxStep = Math.max(Math.min(S.maxStep, reachLimit()), S.step);
    return true;
  }

  function preselect() {
    var params = new URLSearchParams(window.location.search);
    var restored = restoreState();
    if (editPreselect(params)) return;
    /* ?bike= wins. Without it the header's bike (rm_bike) wins over a saved build, since
       it is the newer of the two: every pick here is written to rm_bike as well, so a
       difference means the bike was changed in the header since. */
    var bike = params.get('bike');
    if (!bike) {
      try {
        bike = window.localStorage.getItem('rm_bike');
      } catch (e) {
        bike = null;
      }
    }
    if (bike) {
      /* also accepts a store option value, in case another page stored one */
      var b = resolveBike(bike);
      /* A Stark Varg from the header or a product link, MX or EX not said, opens step 1
         on the Stark brand with neither picked. */
      if (!b && sharedFit(bike)) {
        clearBike(bike);
      } else if (!b) {
        /* A bike the builder does not list opens step 1 with the notice. */
        bikeForeign = { handle: bike, label: headerBikeLabel(bike) };
        S.step = 1;
      }
      /* A product page link (?bike=) names the bike, so the header follows it too. */
      if (b && params.get('bike')) announceBike(b.handle);
      if (b && b.handle !== S.bike) {
        setBike(b.handle);
        S.step = 2;
        S.maxStep = 2;
      }
    }
    var setup = params.get('setup');
    var setupMoved = false;
    var wantWas = S.tiresWant;
    var pkgWas = S.tires;
    if (setup) {
      /* The short forms are what the Blackline product pages link with. rtror and
         rtrsm also turn the Ready-to-Ride choice on. */
      var map = {
        offroad: 'offroad',
        'off-road': 'offroad',
        or: 'offroad',
        rtror: 'offroad',
        supermoto: 'supermoto',
        sm: 'supermoto',
        rtrsm: 'supermoto',
        front_single: 'front_single',
        front: 'front_single',
        fw: 'front_single',
        rear_single: 'rear_single',
        rear: 'rear_single',
        rw: 'rear_single',
      };
      if (map[setup]) {
        if (map[setup] !== S.setup) {
          /* A new setup is a new list of sizes: step 3, no size, nothing later open. */
          S.setup = map[setup];
          S.sizeKey = null;
          S.variantBike = null;
          setupMoved = true;
          if (S.bike) {
            S.step = 3;
            S.maxStep = 3;
          }
        } else if (S.bike && S.step < 3) {
          S.step = 3;
          S.maxStep = Math.max(S.maxStep, 3);
        }
      }
      if ((setup === 'rtror' || setup === 'rtrsm') && rtrOffered()) S.tiresWant = 'rtr';
    }
    if (params.get('tires') === 'rtr' && rtrOffered()) S.tiresWant = 'rtr';
    /* Ready-to-Ride from a link is a choice made before the size. It applies on step 4 if
       the size has it, and a saved size without it falls back to wheels only. */
    syncTires();
    /* A link that changes only the tire ask, on a build already past step 3, opens step 4
       so the package and any fallback note are seen. */
    if (!setupMoved && S.tiresWant !== wantWas && S.step > 3 && sizeOption(S.sizeKey)) {
      tiresMovedCheck(pkgWas);
      S.step = 4;
      S.maxStep = Math.min(Math.max(S.maxStep, 4), S.tiresMoved ? 4 : 6);
    }
    /* Never leave the builder on a step it cannot reach. */
    if (S.step > reachLimit()) S.step = maxReachable();
    S.maxStep = Math.max(S.maxStep, S.step);
  }

  /* On a preview link Shopify's own bar is fixed over the bottom of the screen and hid the
     builder's sticky bar (Peter, 2026-10-15), so the bar sticks just above it instead.
     Customers never have that bar, so for them the lift is 0. */
  function pinMobBar() {
    if (!elMob) return;
    var lifted = null;
    function lift() {
      var pbar = document.getElementById('PBarNextFrameWrapper') || document.getElementById('preview-bar-iframe');
      var h = 0;
      /* offsetParent is always null for a fixed element, so visibility is read from style. */
      if (pbar && window.getComputedStyle(pbar).display !== 'none') {
        var r = pbar.getBoundingClientRect();
        if (r.height && r.bottom >= window.innerHeight - 2) h = Math.round(r.height);
      }
      root.style.setProperty('--rm-mob-lift', h + 'px');
      if (pbar && pbar !== lifted && 'ResizeObserver' in window) {
        lifted = pbar;
        new ResizeObserver(lift).observe(pbar);
      }
    }
    lift();
    /* Shopify adds its bar after the page loads. */
    [600, 1500, 3500].forEach(function (ms) {
      setTimeout(lift, ms);
    });
    window.addEventListener('resize', lift);
  }

  var started = false;

  function start(data) {
    started = true;
    ROWS = (data && data.rows) || [];
    preselect();
    render();
    revealBike();
    pinMobBar();
    /* Ask the storefront whether the upcharge product is really there. The answer only
       ever changes a note and which button shows, so the first paint does not wait. */
    probeUpcharge().then(function () {
      render();
    });
    loadTireChoices();
  }

  /* After a contact form round trip the confirmation or the error is the first
     thing the reader needs, so bring it on screen and send focus to it. The block
     is already open on both branches, this only makes sure it is looked at. */
  (function focusFormNote() {
    var note = root.querySelector('[data-rm-form-note]');
    if (!note) return;
    if (elRequest) {
      elRequest.hidden = false;
      requestOpen = true;
    }
    note.scrollIntoView({
      behavior: prefersReducedMotion() ? 'auto' : 'smooth',
      block: 'center',
    });
    note.focus({ preventScroll: true });
  })();

  var inline = readJson('[data-rm-fitment]');
  if (inline && inline.rows && inline.rows.length) {
    start(inline);
  } else if (CONFIG.fitment_asset) {
    fetch(CONFIG.fitment_asset)
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (data) {
        start(data);
      })
      .catch(function () {
        elPanel.innerHTML =
          '<h2>The builder could not load</h2><p class="rm-bld__help">Reload the page. If it still will not load, email us with your bike and the setup you want and we will build it with you.</p>';
      });
  }
})();
